/* eslint-disable max-len */
export default {
    test: "Test!",
    brandName: "SmartFabric",
    errorRequired: "This field is required!",
    platformVersion: "Platform version:",
    oldValue: "old value: ",
    generic: {
        bcApplications: "Applications",
        bcProcesses: "Processes",
        bcSettings: "Settings",
        bcGeneral: "General",
        bcGlobalFeatures: "Data Store",
        bcEntities: "Data Tables",
        bcAdmin: "Administration",
        bcApplicationSpecificGroups: "Application Specific Groups",
        bcWorkSchedule: "Work Schedule",
        bcPermissionsSet: "Permissions",
        bcArchiveProcess: "Archive Process",
        bcInterfaceBuilder: "User Interfaces",
        bcDocumentBuilder: "Document Templates",
        bcPerspectiveBuilder: "Custom Data Views",
        bcSearchPerspectives: "Data Views",
        bcReports: "Analytics",
        bcProcessData: "Process Live View",
        bcStatistics: "Process Statistics",
        bcBlockchain: "Smart Contracts",
        bcAPIs: "Integrations",
        bcDataModel: "Data Model",
        bcCatalogs: "Catalogs",
        closePreview: "Close preview",
        collapse: "Collapse",
        expand: "Expand",
        add: "Add",
        modify: "Modify",
        update: "Update",
        refresh: "Refresh",
        view: "View",
        warning: "Warning!",
        cancel: "Cancel",
        errors: "Error!",
        test: "Test",
        save: "Save",
        or: "or",
        saveData: "Save data",
        create: "Create",
        createNew: "Create new",
        edit: "Edit",
        clear: "Clear all",
        clearSingle: "Clear",
        done: "Done",
        open: "Open",
        confirm: "Confirm",
        discardAndContinue: "Discard and continue",
        yes: "Yes",
        no: "No",
        leave: "Leave",
        saved: "Saved",
        apply: "Apply",
        information: "Information",
        savedSuccessfully: "Saved Successfully",
        saveUnsuccessful: "Save Unsuccessful",
        publishingErrorTitle: "Publishing error",
        notFound: "Resource with id {id} not found",
        notFoundInterface: "User interface not found",
        missingDoc: "Missing document template",
        copy: "Text copied",
        search: "Search",
        searchTables: "Search tables",
        genericError: "An error has occured",
        ok: "Ok",
        delete: "Delete",
        filter: "Filter",
        noDataAvailable: "No data available",
        name: "Name",
        description: "Description",
        from: "From",
        to: "To",
        copyURL: "Click to copy URL",
        help: "Help",
        abort: "Abort",
        continue: "Continue",
        upload: "Upload",
        keep: "Keep",
        dataSearchPerspective: "Data",
        minimum: "Minimum",
        maximum: "Maximum",
        language: "Language",
        noData: "No classes or attributes to select."
    },
    mainPage: {
        sideBar: {
            smartcontract: "Smart Contracts",
            apps: "Applications",
            settings: "Administration",
            ui: "User Interfaces",
            plm: "Diagrams",
            processes: "Processes",
            appSettings: "Settings",
            appGeneral: "General",
            plv: "Analytics",
            search: "Data Views",
            documents: "Document Templates",
            dataModel: "Data Model",
            api: "Integrations",
            tasks: "Tasks",
            workspace: "Workspace",
            manageGroups: "Manage Groups",
            processInspector: "Process Controller",
            selectWorkspace: "Select workspace",
            globalFeatures: "Data Store",
            globalEntities: "Data Tables",
            globalIntegration: "Database Connections",
            perspectiveBuilder: "Custom Data Views",
            branding: "Branding"
        },
        saveAs: "Save as",
        viewonlyMode: "View Only Mode",
        lastSave: "Last saved at ",
        lastPublishDate: "Last publish date: ",
        neverPublishTimestamp: "Never",
        publish: "Publish App",
        publishButtonTooltip: "Publish data table structure",
        apply: "Apply",
        exclusiveGatewayError: "Exclusive gateway is not configured",
        save: "Save",
        noProcessesTooltip: "The app does not contain any processes yet",
        noPublishPermissionTooltip: "Sorry, you don't have publishing rights",
        publishedState: "Published",
        savedState: "Saved",
        backToRuleTesting: "Back to rule testing",
        backToDiagram: "Back to diagrams",
        previewSmartContract: "Preview Smart Contract Code",
        downloadSmartContract: "Download Smart Contract",
        downloadSwagger: "Download Swagger descriptor",
        deleteSmartContract: "Delete Smart Contract",
        publishEntity: "Publish data table",
        maintenanceMessage: "Make sure your work is saved. Maintenance scheduled on",
        maintenanceLoginBtn: "Maintenance user login",
        maintenanceRefresh: "Refresh"
    },
    apps: {
        addSomeApps: "Add some applications and they will be listed in this section",
        itIsEmpty: "It's a bit empty in here",
        noDescription: "No description.",
        downloadError: "Make a save in Diagrams and after you can download the application",
        getStarted: "Get Started",
        noInterfaces: "No user interfaces used",
        search: "Search for an application",
        searchText: "Search",
        manageBtn: "Manage",
        reportsBtn: "Analytics",
        appsChipsInfo: "Total applications - 1 to 5 displayed here",
        displayed: "recently used",
        startBtn: "Start",
        noApps: "No apps found",
        caption: "Applications",
        addNew: "Create new",
        viewAllApps: "View All",
        yourApplications: "Applications",
        sharedWithYou: "Shared with you",
        archivedApplications: "Archived applications",
        addNewApp: "Application settings",
        appName: "Application name",
        appType: "Type",
        appDescription: "Description",
        userInterface: "User Interface",
        question: "Question",
        response: "Response",
        addToArchive: {
            archiving: "Archive Application",
            applyTo: "Apply to",
            optionLabel: "Add to archive",
            appDefinition: "Application definition",
            appDetails: "Application details",
            instances: "Process Instances",
            appDefInfo:
                "The application definition will be archived together with the application processes, user interfaces, document templates, integrations, data models and catalogues.",
            appInstanceInfo:
                "All process instances of this application will be archived. Running and failed process instances will be terminated and then archived. The number of affected process instances is shown below.",
            all: "All"
        },
        archiveConfirmationMsg: "Archiving an application will remove it from the applications area and it cannot be used anymore",
        taskBoard: "Task board",
        shareApp: "Share App",
        export: "Export",
        duplicate: "Duplicate",
        description: "Description:",
        duplicatedApp: "This name is already used by an application.",
        createFirst: "First you have to create the application",
        noName: "Please type a name for your application.",
        noCode: "Application code is mandatory",
        exceededLength: "You have exceeded the accepted length",
        noType: "Application type is mandatory",
        avatarUploaderBody1: "Accepted formats:",
        avatarUploaderBody2: ".jpg, .png, .svg (max 2 MB)",
        noPermisions: "Permissions and users/roles are mandatory",
        noPermsionsUser: "Users are mandatory",
        addPermision: "Permissions are mandatory",
        uploadImage: "Upload Image",
        editApp: "Edit",
        startApp: "Start",
        nameApp: "Name",
        settingsProcess: "Settings",
        noPermisionsToStartApp: "The process was started. If you are assigned a Task, you will receive a notification.",
        noPermissionsToStartProcess: "You don't have the permission to start this process. Please contact your administrator.",
        noPermisionsToInitiateApp: "You do not have the necessary rights to start this app",
        untitledApp: "Untitled application",
        appTypeNotSet: "Application type",
        appStatus: "Application status:",
        status: "Status",
        notPublished: "Not published",
        createdBy: "Created by",
        noInfo: "No information available",
        tasksIterations: "Tasks & iterations:",
        createApp: "Create Application",
        createAppBtn: "Create application",
        descriptionApp:
            "Applications are a collection of business processes together with their supporting elements: user interfaces, document templates, integrations, and data models.<br> Get started by creating an application.",
        discardApp: "Discard application",
        update: "Update",
        highlights: "Highlights",
        appDetails: "Application Details",
        users: "Users & Permissions",
        groups: "Application groups",
        groupsTitle: "Application specific groups",
        groupsAddNewBtn: "Add new",
        noRoles: "For the moment this application is not accessible by any users or roles",
        existRoles: "The application is accesible to:",
        rolesText: "roles",
        usersText: "users",
        giveAcces: "Give access",
        importApplication: "Drag and drop the settings file (.bfz) here.",
        linkImportApplication: "Or click below to upload it",
        instanceRetention: "Process instance retention",
        periodRetention: "Process instance retention period",
        retentionMessage:
            "The retention period indicates the amount of time process instance logs are kept after an instance is Completed, Terminated, or Archived.",
        indefinite: "Indefinite",
        limited: "Limited",
        period: "Period",
        retentionExpirationMessage: "A retention period of 0 means that process instances will be deleted as soon as they are Completed or Terminated.",
        errorMessage: "Cannot be a fraction or negative",
        days: "Days",
        months: "Months",
        weeks: "Weeks",
        years: "Years",
        importExport: "Export application",
        exportApp: "Export this application with all of its settings",
        download: "Download",
        import: "Import",
        groupsRole: "Groups",
        usersCard: "Users",
        exportSet: "Export application",
        importApp: "Import app settings",
        titleModalSettings: "Import Application",
        importAppBtn: "Import application",
        importButton: "Upload application file",
        importSucess: "Application successfully uploaded!",
        ini: "INI",
        wri: "WRI",
        rep: "REP",
        PUBLISHED: "Published",
        ARCHIVE_IN_PROGRESS: "ARCHIVING...",
        NOT_PUBLISHED: "Unpublished",
        UNPUBLISHED_CHANGES: "Unpublished Changes",
        IMPORTED: "Imported",
        blockchainType: {
            standard: "Standard",
            blockchain: "Blockchain"
        },
        deleteUser: "Do you want to delete this user?",
        deleteRole: "Do you want to delete this group?",
        yes: "Yes",
        no: "No",
        titlePreviewSC: "Smart Contract Code",
        copyBtn: "Copy",
        successCopy: "Code copied to clipboard",
        errorCopy: "Sorry, unable to copy to clipboard.",
        previewTitle: "Code Preview ",
        dialogTitle: "Update Application",
        dialogMessage: "You have to upload the application package in order to update your application.",
        chooseFile: "Select file or drag and drop here",
        updateFailed: "Update failed",
        updated: "{appName} has been updated successfully.",
        warningMsg: "Updating the application will change configurations from all modules to match the exported application version.",
        removeBfz: "Are you sure you want to delete this file? You won't be able to revert the action.",
        deleteFile: "Delete file",
        delete: "Delete",
        cancel: "Cancel",
        bfz: "bfz",
        publishedTooltip: "This application is published and up to date.",
        unpublishedTooltip: "This application is unpublished.",
        unpublishedChangesTooltip: "This application has unpublished changes.",
        beenPublished: "This application has been published",
        by: "By",
        code: "Code",
        appCode: "App code:",
        defaultNameApp: "Application name not set",
        initialBlockchainTypeLabel: " not set",
        codeMandatory: "Application code is mandatory.",
        codeDuplicate: "This code is already used by an application.",
        codeRegex: "The application code can have 2 to 5 characters (A-Z, 0-9) and cannot contain special characters.",
        viewApp: "View",
        resultsFound: "result(s) found",
        imageSizeError: "Uploaded image is too large. Maximum allowed size is {maxSize}",
        importUpdateAppDupTitle: "There is already an app with the same unique code as the app you are about to import.",
        importUpdateAppDupBody: "If you continue, this imported app will be assigned a new code. As a result, you will <b>not be able to update this app</b>."
    },
    processes: {
        processes: "Processes",
        addProcess: "Add process",
        diagram: "Diagram",
        import: "Import",
        settings: "Settings",
        retentionTitle: "Retention",
        invalidName: "Invalid name",
        nrOfProcesses: "process | processes",
        nrOfApplications: "application | applications",
        numberOfProcesses: "No processes. | Contains 1 process. | Contains {count} processes.",
        processType: "Type:",
        startableOpt: "Standalone (The process can be started directly)",
        unstartableOpt: "Linked (The process can be started via another process only)",
        inheritedOpt: "Inherited from application settings",
        indefiniteOpt: "Indefinite",
        limitedOpt: "Limited",
        standaloneLabel: "STANDALONE",
        emptyPeriod: "The value must be numerical",
        retentionZeroInfo: "A retention period of 0 means that cases will be deleted as soon as they are Completed or Terminated.",
        linkedLabel: "LINKED",
        duplicatedProcessName: "A process with this name already exists.",
        warningTitle: "Warning!",
        wrnBodyMsg: "If you leave before saving, your changes will be lost. Are you sure you want to continue?",
        leaveBtn: "Save work & continue",
        search: "Search for a process",
        descriptionError: "The field must not contain special characters",
        archive: "Archive",
        editDetails: "Edit Details",
        duplicate: "Duplicate",
        errorFound: "Error found",
        noProcesses: "No processes, yet",
        createNew: "Create new process",
        startProcess: "Start a process",
        startProcessBtn: "Start",
        deleteUnpublishedFirstMsg: "Are you sure you want to delete '{process}'?",
        deleteUnpublishedSecondMsg: "You can recover deleted processes using the Change history.",
        deleteUnpublishedMessageTitle: "'{process}' process",
        deletePublishedFirstMsg: "All instances of this process will be Terminated and Archived when the application is published. Currently, there are ",
        deletePartMsg: " running instances. | running or failed instances.",
        deletePublishedSecondMsg: "You can recover deleted processes using the Change History. If you recover this process before publishing, then it's instances will no longer be Terminated. Any assigned users will have the initiation rights removed upon publish.",
        deletePublishedMessageTitle: "'{process}' process",
        markForArchiving: "Mark for archiving",
        rename: "Rename",
        renameProcess: "Rename process",
        successfullyRenamed: "Process successfully renamed.",
        failedRename: "Failed to rename process",
        emptyProcessNameNotif: "Name can not be empty",
        alreadyEditProcess: "The Process is being edited by {username} and cannot be renamed",
        wrongPatternErr: "The name can contain letters, numbers and special characters such as underline,line and space. The first character must be a letter",
        statusReport: "Status report",
        cancelArchiving: "Cancel archiving",
        detailsTitle: "Details",
        processDetails: "Process details",
        publishedWithChanges: "PUBLISHED WITH SAVED CHANGES",
        currentlyApplying: "Currently applying to",
        instances: "Process instances",
        instancesDescription:
            "All the process instances will be archived. The Running ones will be Terminated after archiving. The current total number and the individual number of instances are displayed below.",
        completed: "Completed",
        terminated: "Terminated",
        running: "Running",
        failed: "Failed",
        all: "All",
        scheduledForArchiving: "Scheduled for Archiving on next Publish",
        abortArchiving: "Abort {name} achiving?",
        archivingDescription: "Aborting the archiving action will stop the process from being archived on the next publish.",
        infoAlert: "Info alert",
        infoAlertMsg: "Continuing with application publish will also archive: {name}.",
        listChanged: "The list of processes has changed",
        processChanged: "Process “{name}” has been updated",
        processDeleted: "“{name}” has been successfully deleted",
        errorOnDelete: "You cannot delete “{name}” because it is being edited.",
        errorOnRename: "The Process is being edited by “{user}” and cannot be renamed.",
        processUpdatedRefresh: "Process “{name}” has been updated. To see the latest version please refresh the page.",
        editNameTooltip: "Click the “Rename” button under the three-dot menu of the Process in order to rename it."
    },
    giveAcces: {
        add: "Add",
        update: "Update",
        titleModalAcces: "Give Permissions",
        permissionsTitle: "Permissions and levels",
        initiator: "Initiator",
        editor: "Editor",
        report: "Report viewer",
        userRoles: "Select users and roles",
        userTitle: "Users",
        groupsTitle: "Groups"
    },
    dataModel: {
        caption: "Data model & Catalogs",
        noCatToShow: "It's a bit empty in here",
        name: "Data model",
        emptyDataModel: "There are no classes created yet",
        emptyDataModelMessage: "Once you'll create your first class, it will appear here",
        catalogs: "Catalogs",
        addNew: "Add New",
        classesCounter: "Class | Classes",
        classesCounterLowerCase: "class | classes",
        attributesCounter: "attribute | attributes",
        attributesFound: "attribute found | attributes found",
        resultsFound: "result found | results found",
        thisClassHas: "This class has",
        addAttribute: "Add attribute",
        emptyClassTitle: "You can not save an empty class",
        emptyClass: "{emptyClass} class is empty | {emptyClass} classes are empty",
        ok: "OK",
        createAnother: "Create another",
        dataModelUpdateToast: "Data model was updated. Press the button to see the last version. ",
        refresh: "Update",
        deleteClassSuccess: "The class was succesfully deleted",
        createNew: "Create new",
        modal: {
            title: "Add new class",
            editTitle: "Edit class",
            subtitle: "Class settings",
            attributesSection: "Attributes",
            className: "Class name",
            blockchainLabel: "Smart Contract ready",
            titleAddFields: "Add new attribute",
            titleEditFields: "Edit attribute",
            subtitleFields: "Attribute settings",
            propertyName: "Attribute name",
            isEmbedded: "Is Embedded",
            isIndexable: "Searchable",
            personalInformation: "Personal information",
            isList: "List",
            type: "Type",
            deleteTitleDialog: "Woah! Are you sure you want to delete this class?",
            deleteTitleDialogClass: "Are you sure you want to delete this class?",
            deleteBodyMsg: "This action cannot be undone.",
            deleteBodyMsgClass: "You can later restore this class by reverting the Data Model to an older save via the Save History.",
            deleteBodyMsgAttr: "You can later restore this attribute by reverting the Data Model to an older save via the Save History.",
            deleteBtnDlt: "Delete",
            closeTitleDialog: "Warning",
            closeBodyDialog: "Are you sure you want to leave? You will lose all your changes!",
            closeDialog: "Confirm",
            deleteBtnCancel: "Cancel",
            deletePropDialog: "Are you sure you want to delete this attribute?",
            noNameErrorClassName: "The class name should not contain spaces, special characters or numbers only and to not start with a number.",
            noNameError: "The attribute name should not contain spaces, special characters or numbers only and to not start with a number.",
            forbiddenAttName: "You are not allowed to use this attribute name",
            duplicateInCatalogs: "There is already a catalog named {name}",
            duplicateInDataModel: "There is already a class named {name}",
            duplicatePropName: "There is already an attribute named {name} in this class",
            duplicateInTypes: "{name} is a reserved name",
            searchableTooltip:
                "Activate if you want this value to show up in search results when using application module like Analytics or Process Controller",
            listTooltip: "Activate if you want to allow the field to hold multiple values or complex data structure",
            smartContractTooltip: "The class should be Smart Contract ready in order to have this option available.",
            smartContractTooltipActivated: "Activate the Smart Contract ready option for {className} if you want it to be available for this selection.",
            smartClassTooltip: "Activate if you want to use this class in Smart Contract",
            smartAttributeTooltip: "Activate if you want to use this attribute in Smart Contract",
            editSmartContractClassTooltip: "You cannot deactivate this option because it contains a Smart Contract ready attribute."
        }
    },
    catalogs: {
        name: "Catalogs",
        title: "All Catalogs",
        baseTypes: "Base Types",
        catalogsDetailsSuccess: "Catalog saved successfully",
        addSomeCat: "Add or select a catalog and its details will be listed in this section",
        addRowCat: "You've saved a catalog that don't have any rows.They will not be saved!",
        emptyCatalogs: "There are no catalogs created yet",
        noCatalogSelected: "Select or create a new catalog",
        emptyCatalogMessage: "Once you'll create your first catalog, it will appear here",
        emptyRow: "Row name or row code cannot be empty!",
        addRow: "Add row",
        onlyTypeValAllowed: "Only {name} values are allowed",
        exportDialogTitle: "Choose export format",
        exportDialogBody: "Please choose the export format",
        exportExcel: "Excel (.xlsx)",
        exportJson: "JSON",
        infoMessage: "Your catalog name exceeds the character limit of Excel worksheets. If you continue, the name will be truncated to 31 characters and you will therefore not be able to use the sheet to import data back into the catalog. We recommend using JSON instead.",
        infoMessageList: "One or more catalog names exceed the character limit of Excel worksheets. If you continue, the name will be truncated to 31 characters and you will therefore not be able to use the sheet to import data back into the catalog. We recommend using JSON instead.",
        exportBtn: "Export",
        addNew: "Add New",
        addData: "Add Data",
        editBtn: "Edit",
        addCat: "Add Catalog",
        editCat: "Edit Catalog",
        catalogsCount: "catalog | catalogs",
        cardInfoBody: "Click a Catalog name to view it`s data",
        info: "Info",
        deleteCatRowDialog: "Are you sure you want to delete this row?",
        deleteBodyMsgRow: "You can later restore this row by reverting the Catalog to an older save via the Save History.",
        deleteCatDialog: "Are you sure you want to delete this Catalog?",
        deleteBodyMsgCat: "You can later restore this Catalog from the Catalogs Change History.",
        alreadyDeleted: "Catalog was deleted by another user.",
        searchCode: "Search a code",
        infoExport: "Saved catalogs have been exported",
        maxCodeLength: "The maximum allowed length for code is 50 characters",
        wrnMsgImportDirty: "You have unsaved changes. Importing data will overwrite these changes.",
        icons: {
            deleteCatalog: "Delete Catalog"
        },
        true: "True",
        false: "False",
        addNewCat: {
            title: "Add new Catalog",
            subtitle: "Catalog settings",
            name: "Name",
            type: "Type",
            addBtnModal: "Add",
            save: "Save",
            description: "Description",
            columns: "Columns",
            addBtn: "Add column",
            deleteCol: "Delete Column",
            requiredTooltip: "Required",
            errorDuplicatedName: "Catalog with name {name} already exists",
            noNameError: "The class name should not contain spaces, special characters or numbers only.",
            noCatalogNameError: "This name should not contain spaces, special characters or numbers only and not starting with numbers.",
            duplicatedColumn: "You already have this column name.",
            nullColumn: "You cannot save an empty column",
            errorExistingCode: "You already have a row with this code.",
            alreadyEmptyRow: "Fill in code and name to add a new row!",
            warning: "Warning",
            duplicatedNameWithInactiveCat: "You already have an inactive catalog with this name.",
            saveCatBeforeImport: "You have to save the catalog before importing data.",
            activeSpaceData: "Data entry can not contain only space characters or start with a space character."
        },
        importExport: {
            title: "Import new catalog",
            titleBulk: "Bulk data import",
            text: "Type of data you want to Import / Export:",
            importData: "Import Data",
            exportData: "Export Data",
            import: "Import",
            importAll: "Bulk data import",
            export: "Export",
            exportAll: "Bulk data export",
            uploadImportFile: "Upload your file",
            downloadTemplate: "Download template",
            downloadSectionbdy: "You can download template from here",
            importBtn: "Import",
            incorectFile: "The file you want to import doesn't match the catalog's name",
            importDupCodeName: "Make sure you don't have the code or name values duplicated.",
            error: "Error!",
            invalidJsonFile: "Make sure the JSON file is correctly formatted.",
            importXlsCatListErr: "You can not import new catalogs, just values in existing ones.",
            importMaxLengthErr: "The maximum allowed length for code is 50 characters",
            duplicateColName: "Duplicate value in column name: ",
            duplicateColCode: "Duplicate value in column code: ",
            codeErrEmpty: "Code cannot be empty",
            nameErrEmpty: "Name cannot be empty",
            type: "Type",
            successImport: "Successfully imported data into the catalog(s)",
            alertTooltip: "Please Save the Catalog before exporting or importing data."
        },
        listUpdated: "The list of catalogs has changed!",
        contentUpdated: "has been updated!"
    },
    api: {
        caption: "APIs",
        addNew: "Add New",
        apiResults: "API | APIs",
        credentialApiResults: "API credentials | API credentials",
        results: "Result | Results",
        mainConsumed: "External APIs",
        mainInternal: "System APIs",
        mainInternalApis: "Internal APIs",
        internalNoData: "You don't have access to any Internal APIs.",
        internalNoDescription: "Please contact your Administrator to enable Internal APIs for this application.",
        internalMethods: "Methods:",
        internalType: "System API",
        mainExposed: "Exposed API Credentials",
        mainConsume: "Consume",
        mainExpose: "Expose",
        exposedMainTitle: "Credential details",
        consumeMainTitle: "API details",
        addNewCard: " Add some APIs and they will be listed in this section",
        noApis: "No APIs, yet.",
        toggleExposedLabel: "Allow access only from custom domains",
        toggleConsumedLabel: "Requires authentication",
        name: "Name",
        url: "Base URL",
        type: "Type",
        search: "Search for an Api",
        description: "Description",
        description2: "Description:",
        methods: "Methods:",
        type2: "Type:",
        url2: "URL:",
        edit: "Edit",
        refresh: "Refresh",
        delete: "Delete",
        username: "Username",
        password: "Password",
        clientID: "Client ID",
        clientID2: "Client ID:",
        secretKey2: "Client Secret:",
        clientSecret: "Client Secret",
        mandatoryField: "This field is mandatory",
        baseURL: "Base URL",
        secretKey: "Secret Key",
        addDomain: "Add origin",
        request: "Request",
        response: "Response",
        uploadImage: "Upload Image",
        allApis: "All",
        update: "Update",
        add: "Add",
        warningMessage: "Are you sure you want to exit? There is unsaved information that will be lost",
        warning: "Warning",
        uploadMessage: "Or, you can upload webservice specs file",
        uploadDescription: "Accepted file types are .json and .xml",
        buttonMessage: "Upload webservice file",
        noParams: "There are no parameters for this call.",
        nothingToMap: "There is nothing to map.",
        viewMethods: "view methods",
        changeName: "You already have this API name",
        changeLocation: "You already have this API location",
        ok: "Ok",
        cancel: "Cancel",
        nameRequired: "Name is required",
        urlRequired: "Location url is required",
        toggleAuth: "Authentication is required",
        download: "Download file",
        downloadMessage: "Download webservice specs file",
        downloadDescription: "File types are .json and .xml or .asmx",
        downloadButton: "Download webservice file",
        changeFile: "You already have this webservice file",
        fileUploadedMsg1: "File has been uploaded",
        errorUrlType: "The URL is already in use by another API.",
        errorType: "Incorrect API type selected.",
        failedApi: "Failed to parse API",
        timeoutApi: "API definition took too long to respond.",
        authentificationError: "This API requires authentification.",
        serviceUnavailableError: "Service unavailable.",
        location: "Location",
        location2: "Location:",
        deleteExpApiError: "API cannot be deleted as it's in use (mapped) to the 'Start from external' element.",
        externalSource: "Assigned exposed APIs",
        domainTooltip: "https://*.website.com//86.102.41.*",
        authUserPass: "Username and password",
        oauth2: "Oauth2",
        oauth2Pass: "Oauth2 with Password",
        clientCred: "Client credentials",
        allValDdl: "All",
        externalSourceValueDdl: "External Source",
        apiValDdl: "API",
        searchPlaceholder: "Search",
        close: "Close",
        errorName: "This api name already exists!",
        emptyName: "Api name cannot be empty",
        wrongPatternErr: "The name can contain letters, numbers and special characters such as underscore, dot, dash, apostrophe and space.",
        fileSizeError: "Uploaded file is too large. Maximum allowed size is {maxSize}",
        websocketNotif: "External API list has been updated",
        websocketDeletedNotif: "External API successfully deleted",
        websocketDeletedNameNotif: "External API \"{name}\" was deleted by {user}",
        websockeRenameNotif: "External API successfully renamed",
        websocketCredentialsNotif: "Credentials list has been updated",
        websocketCredentialsDeletedNotif: "Credentials successfully deleted",
        websocketCredentialsDeletedNameNotif: "Credentials  \"{name}\" was deleted by {user}",
        websocketCredentialsRenameNotif: "Credentials successfully renamed",
        renameOptionMenu: "Rename",
        renameTitleDialog: "Rename External API",
        renameExposedTitleDialog: "Rename Exposed API",
        readonlyNameTooltip: "To rename the API, open the menu “⋮” from the API card",
        readonlyExposedNameTooltip: "To rename the Exposed API Credentials, open the menu “⋮” from the API card",
        emptyNameDialog: "This field is required",
        showCredentials: "Show credentials",
        hideCredentials: "Hide credentials",
        copyBtn: "Copy",
        authTypeReq: "Please select an authentication type",
        externalApiHighlights: "API highlights",
        externalApiDescriptor: "Descriptor",
        externalApiAuthentication: "Authentication",
        reloadDescriptorCheckbox: "Reload descriptor",
        sameDescriptorNotif: "The new API descriptor is identical to the old one.",
        radioFileOpt: "File",
        radioUrlOpt: "URL",
        internalUrlCard: "Internal URL",
        methodsModalTitle: "method",
        downloadDescriptor: "Download descriptor",
        savingWillPublish: "Saving will publish the changes",
        deletedExposed: "Deleted Exposed API Credentials cannot be recovered"
    },

    tasks: {
        caption: "Tasks",
        myTasks: "My Tasks",
        myTeamsTasks: "Team Tasks",
        task: "The task",
        taskNoLongAvail: " you are trying to view is no longer available.",
        alrdyClaimed: " has already been claimed by",
        noGuiMessage: "There is no user interface mapped on this end point. The task can't be displayed.",
        newTaskAssigned: "A new task has been assigned to you",
        newTaskReassigned: "A new task has been reassigned to you",
        newTaskAssignedFabricI: "A new task has been assigned to you. You can review it in task explorer section.",
        newTaskReassignedFabricI: "A new task has been reassigned to you. You can review it in task explorer section.",
        openMyTasks: "Open My Tasks",
        activeTasks: "To Do",
        teamTasks: "To do",
        appsCreators: "Apps Creators",
        completedTasks: "Completed",
        myCompletedTasks: "My Tasks - Completed",
        myTeamTasks: "Team tasks - To Do",
        myTeamCompletedTasks: "Team tasks - Completed",
        noTasks: "No tasks to be displayed",
        myOpenTasks: "My Tasks - To Do",
        filterModalTitle: "Filters & sorting",
        sortBy: "Sort by",
        priorityName: "Priority",
        taskName: "Task name",
        creationDateFilter: "Creation date",
        completionDateFilter: "Completion date",
        timeRemaining: "Time Remaining",
        groupTitle: "Group",
        clearAll: "Clear All",
        id: "Id",
        tasksExplorer: "Task explorer",
        taskChipsInfo: "Total tasks - 1 to 10 displayed here",
        search: "Search",
        applications: "Applications",
        display: "Display",
        allApps: "All applications",
        status: "Status",
        timeToDeadline: "Time to deadline:  ",
        creationDate: "Creation date ",
        completionDate: "Completion date",
        assignmentUsers: "Assignment ",
        completedOn: "Completed on:",
        hours: " hrs",
        minutes: " min",
        days: " days",
        weeks: " weeks",
        noOpenTasks: "You don't have any open task.",
        noCompltedTasks: "You don't have any completed task.",
        viewAllTasks: "View All",
        filterBy: {
            ascending: "Ascending",
            descending: "Descending",
            onTime: "On time",
            inWarning: "In warning",
            attention: "In attention",
            overdue: "Overdue",
            allTasks: "All Tasks",
            byStatus: "By Status",
            byPriority: "By Priority",
            byDate: "By Date",
            priorities: {
                highest: "Highest",
                high: "High",
                normal: "Normal",
                low: "Low",
                lowest: "Lowest"
            }
        },
        taskAlreadyClaimed: "It appears that this task has been claimed by someone else. ",
        taskNotFound: "Oops! This task does not exist or has been removed",
        noRightsToClaimTask: "Oops! It seems that you are not allowed to claim this task. Please discuss with your admin. ",
        taskFinalized: "This task is no longer active.",
        taskNotAvailable: "This task is no longer available.",
        view: "View",
        claim: "Claim",
        cancel: "Cancel",
        unclaimTask: "Unclaim",
        reassignTask: "Reassign",
        escalateTask: "Escalate",
        bulkUnclaim: "Bulk unclaim",
        bulkReassign: "Bulk reassign",
        bulkEscalate: "Bulk escalate",
        bulkSelect: "Select visible",
        apply: "Apply",
        unclaimTitle: "Unclaim",
        unclaimReason: "Reason",
        infoTurnOff: "Turn off reassign notification",
        infoTurnOffTooltip: "The bulk reassign notifications can trigger spam filters",
        reasonPlaceholder: "Please specify the reason for your action.",
        popupTitle: "Unclaim task?",
        reasonRequired: "The reason for your action is required.",
        unclaimedSucces: "Tasks have been successfully unclaimed. | Task has been successfully unclaimed.",
        allUsers: "Users",
        searchPlaceholder: "Search users and roles",
        popupAssignTitle: "Reassign task?",
        popupAssignTasks1: "Reassign ",
        popupAssignTasks2: " tasks ?",
        popupUnclaimTasks1: "Unclaim ",
        popupUnclaimTasks2: " tasks ?",
        reassignSucces: "Tasks have been successfully reassigned. | Task has been successfully reassigned.",
        unclaimMessage: "Success, you've Unclaimed your task",
        reassignMessage: "Success, you've Reassigned the task",
        errorTitle: "Select new user",
        errorText: "Please select users or groups to reassign task",
        completedTeam: "Completed",
        tabExternal: "External",
        tabInternal: "Internal",
        availableUsers: "Available users",
        availableUsersGroups: "Available users and groups",
        labelEmail: "Email address",
        labelPhone: "Phone number",
        externalBadge: "TXT",
        errorEmail: "Email address is required",
        errorEmailValid: "Email address must be valid",
        errorPhone: "Phone number is required",
        errorPhoneValid: "Phone number must be valid",
        errorPhoneNumeric: "Phone number should contain only numeric characters",
        separateTask: "Create a separate task for each assignee",
        separateTaskInfo: "Important note: Make sure you use the Data Store to configure the user interface for this task.",
        separateTaskInfo2:
            "Important note: Make sure you use the Data Store to configure the user interface for this task. A separate task will be created for each assignee."
    },

    login: {
        changePassTitle: "Set up your blockchain wallet",
        changePassDescription:
            "A blockchain wallet was generated for your account. Please choose a password for this wallet. This password cannot be changed later.",
        temporaryWalletPass: "Temporary wallet password",
        temporaryWalletDescription: "An email has been sent to you with your temporary wallet password",
        errorPassWallet:
            "The password must contain at least one uppercase letter, one lowercase letter, one 0-9 figure and must be at least 8 characters long.",
        errorTempWallet: "Wrong Password",
        newWalletPass: "New wallet password*",
        confirmWalletPass: "Confirm new wallet password*",
        setUpLater: "Set up later",
        changePassword: "Change password",
        username: "Email address",
        password: "Enter password",
        resetTokenExpired: "Your token has expired",
        login: "Continue",
        createAccount: "Create new account",
        createOneHere: "Create one here.",
        noAccount: "Don't have an account?",
        enterEmail: "Please enter your email address.",
        errMaintenance: "The platform is under maintenance",
        registrationSubmitted: "Registration request submitted",
        backToConfirmCard: "Back to login",
        goToLogin: "Go to login",
        savePassword: "Save password",
        setPassword: "Set password",
        logoutTitle: "You have logged out",
        logoutMessage: "We hope to see you again very soon. You can log back in by pressing the button below.",
        title: "Log in",
        invalidSignUpEmail: "Please provide a valid email address",
        forgotPassword: "Forgot password",
        reset: "Click here to reset it",
        userEmail: "Email address/username",
        welcomeMessage: "Welcome,",
        userInvalidCredentials: "Invalid user username/password",
        strength: "Password strength:",
        strong: "Strong",
        weak: "Too weak",
        medium: "Medium",
        titleReset: "Reset password",
        savedPassword: "Password saved",
        setPass: "Reset password",
        passwordChanged: "Password reset!",
        accountDisabled: "Account disabled",
        accountDisabledBodyMsg: "This account is disabled, please contact your administrator to enable it.",
        accountNotRegistered: "Account not registered",
        accountNotRegisteredBodyMsg: "This account is not registered, please contact your administrator to create an account.",
        passwordChangedMessage: "Your password has been reset. <br> To log in with your new password, please click below.",
        passwordSetMessage: "Your password has been set. To log in with your new password, please click below.",
        returnToLogin: "Go back to login page.",
        returnToReset: "Go back to reset password page",
        tokenExpiry: "Token is set to expire in:",
        expiredToken: "The token has expired",
        messageForExpiredToken: "The link is not available anymore. Resend a new link by accessing the password reset page.",
        invalidUser: "This account was disabled. Please contact your system administrator",
        increaseContrast: "Increase contrast",
        backToReset: "Back to the password reset page",
        backToLogin: "Go to login",
        hours: "hours",
        changeUser: "Not you? Sign in as a different user",
        sessionExpired: "Your session has expired",
        confirmSignUpMessage: "You will receive an email with the next steps required to complete your registration.",
        resetPassMessage: "We'll send a password reset link to the email address that you've provided.",
        nonexistentEmail: "There is no user account with this email address",
        linkSentMessage:
            "We've sent a password reset link to the email address that you've provided. If it's in our database, you'll be able to reset your password in no time.",
        inviteSetExpiredMsg: "The link is not available anymore. Request a new link in order to set up your account.",
        dashboard: "Go to your dashboard!",
        continue: "Login",
        resetLink: "Send reset link",
        resetP: "Reset Password!",
        resendLink: "Ask for resend link",
        resetErr: "Password doesn't match.",
        emptyUser: "Please enter an email address to access your account.",
        emptyPass: "Please enter a password to access your account ",
        sendLink: "Please enter an email address",
        addPass: "Please add your new password",
        confirmPass: "Please confirm your new password",
        setPassSAML:
            "The authentication method has been changed and you have to set a password. We've sent a password set link to the email address that you've provided.",
        aurachain: "{brandName}",
        allRightsReserved: "All rights reserved.",
        setNewPass: "Set new password*",
        confirmNewPass: "Confirm new password*",
        firstName: "First name*",
        lastName: "Last name*",
        setAccount: "Set account",
        createAcc: "Continue",
        matchPassErr: "Passwords do not match!",
        emptyFirstName: "Please enter your first name to access your account",
        emptyLastName: "Please enter your last name to access your account",
        twoFactorAuthBodyMsg:
            "Your account requires multi-factor authentication. <br> We've sent an access code via SMS to the following number: <strong>{phoneNo}</strong>",
        accessCode: "Access code",
        generateNewCodeMsg: "If you don't receive it in few minutes, generate a new one by ",
        clickingHereAccessCode: "clicking here.",
        resendAccessCode: "The SMS code has been sent. If you didn't receive it you can generate a new one after",
        wrongAccessCode: "Wrong code, try it again or generate another one",
        expiredAccessCode: "Your authentication code has expired. Please generate a new authentication code.",
        emptyAccessCode: "Access code is mandatory",
        secureAccTitle: "Secure your account",
        securePhoneBodyMsg: "Provide your phone number in order to complete your 2 factor authentication.",
        phoneNumberInput: "Your phone",
        skipButton: "Skip",
        errorGenerate: "You can generate a single code once every 60 seconds.",
        errorPhoneNr: "Phone number is mandatory.",
        invalidPhoneNumber: "Please enter a valid phone number starting with '+'.",
        oneSkipRemaining: "(One skip remaining)",
        twoSkipsRemaining: "(Two skips remaining)",
        logoutError: "Service unavailable. Logout failed.  You can try reloading the page. If the error persists, please try again in a few minutes.",
        invalidTenantTitle: "Page not found",
        invalidTenantDescription: "Invalid URL, please check the address with your Administrator."
    },
    admin: {
        icons: {
            users: "Users",
            editRole: "Edit Role Name",
            deleteRole: "Remove Role",
            save: "Save",
            cancel: "Cancel",
            addRolesToUsers: "Edit Roles",
            delete: "Delete",
            remove: "Remove"
        },
        schedule: {
            title: "Work Schedule",
            cardTitle: "Working hours",
            workdays: "Workdays",
            from: "From",
            to: "To",
            monday: "Monday",
            tuesday: "Tuesday",
            wednesday: "Wednesday",
            thursday: "Thursday",
            friday: "Friday",
            saturday: "Saturday",
            sunday: "Sunday",
            holidays: "Holidays",
            noHolidayText: "There are currently no days selected.",
            addBtn: "Add new date",
            close: "Close",
            toggleTitle: "Enable Work schedule",
            toggleAppTitle: "Overwrite organization schedule",
            toggleSubtitle: "Define working days, working hours and holidays for your organization.",
            january: "January",
            february: "February",
            march: "March",
            april: "April",
            may: "May",
            june: "June",
            july: "July",
            august: "August",
            september: "September",
            october: "October",
            november: "November",
            december: "December",
            mandatory: "Mandatory",
            toastSaved: "Work schedule has been successfully saved",
            toastErrSave: "Work schedule must have at least one working day.",
            addNew: "Add new",
            infoTextApp: "Currently there is no organization work schedule defined.",
            manageHolidayPerYear: "Manage one time dates",
            manageRecurring: "Manage recurrent dates",
            tooltip: "Navigation is posible for five years around the current one.",
            holidayInfo: "Define one time (",
            holidayInfo1: ") and recurring (",
            holidayInfo2: ") free days for your organization."
        },
        processInspector: {
            appSummary: {
                summary: "Summary",
                headerInstanceFrom: " process instances from ",
                headerAppsSelected: " apps selected",
                headerAppSelected: " app selected",
                multipleSelectTitle: "Applications",
                instances: "Process instances",
                collapsHeaderInstances: "Process instances",
                appTooltip: "All the process instances will be archived. The total number and a breakdown per status are displayed below.",
                deleteInstTitle: "Delete process instance",
                deleteInstMess: "The process instance and all its data will be permanently deleted. Also all the synchronous instances will be deleted too.",
                deleteInstanceSuccess: "The process instance was succesfully deleted",
                deleteInstanceError: "Failed to delete process instance"
            },
            instances: "process instances",
            filtersApplied: "filters applied",
            clearFilters: "Clear filters",
            filter: "Filter",
            recordNo: "Records per page",
            at: "at",
            notAvailable: "N/A",
            deleteSuccessfully: "{type} from {activity} successfully deleted",
            selectedInstances: "selected",
            instanceID: "process instance ID:",
            all: "All",
            publishedBy: "published by",
            lastSaveBy: "Last saved by",
            on: "on",
            terminateConfirm: "Terminate",
            archive: "Archive",
            dmlChip: "DML",
            archiveInstance: "Archiving Process Instances",
            bulkArchiveMsg:
                "Archiving these process instances will remove them from the instance list. Any other synchronously started instances related to them will also be archived.",
            title: "Process Controller",
            subTitle: "Filter the search by using the available options",
            systemStatus: "System status",
            process: "Process",
            selectProcess: "Select a single application to continue.",
            from: "From",
            to: "To",
            other: "Other",
            errorDate: " 'To Date' is mandatory!",
            errorFromDate: " 'From Date' is mandatory!",
            allStatuses: "All statuses",
            runningStatus: "Running",
            completedStatus: "Completed",
            failedStatus: "Failed",
            deleted: "Deleted",
            deletedComment: "DELETED",
            deletedDocument: "DELETED",
            terminateStatus: "Terminated",
            successfulStatus: "Successful",
            noItemsExecuted: "No items executed",
            application: "Application",
            searchApp: "Search for Application names",
            noAppSelected: "No applications selected",
            appSelected: "applications selected",
            modalTitle: "Details",
            modalTitleArchive: "Add process instance to archive",
            apiModalTitle: "View",
            messagesModalTitle: "Summary",
            messageName: "Message name",
            messageGenerated: "Generated",
            messageSent: "Sent",
            messageConnectorName: "Connector name",
            messageConnectorDescription: "Connector description",
            messageRuleName: "Rule name",
            messageTrigger: "Trigger",
            messageRecipient: "Recipient definition",
            messageRecipients: "Recipients",
            messageSMTPServer: "SMTP server",
            messageSMTPUsername: "SMTP username",
            messageSubject: "Subject: ",
            smsSubject: "Message Content",
            beforeStage: "Before stage",
            afterStage: "After stage",
            apiSummary: "API Summary",
            blockchainSummary: "Blockchain Summary",
            apiName: "Name",
            deleteTitleNotification: "Delete {type} notification",
            deleteBodyNotification: "This message will be permanently deleted. Are you sure?",
            blockchainName: "Smart Contract name",
            apiExecutedOn: "Executed on",
            apiExecutedIn: "Executed in",
            apiExecutedBy: "Executed by",
            apiType: "Type",
            apiMethod: "Method",
            apiUrl: "URL",
            blockchainChanel: "Channel",
            blockchaiHost: "Host",
            apiLocation: "Location",
            apiRequest: "Request",
            apiResponse: "Response",
            appDetails: "Application details",
            processDetails: "Process details",
            blockchainDetails: "Blockchain details",
            retentionPeriod: "Retention period",
            changeRetention: "Change retention period",
            deletionDate: "Deletion date",
            changeDeletion: "Change deletion date",
            type: "Type",
            duration: "Duration",
            never: "Never",
            custom: "(custom)",
            deletionInfo: "The process instance will not be automatically deleted by the system.",
            invalidRetentionDate: "Please choose a valid date",
            proccesInstanceId: "Process instance ID",
            parentInstanceId: "Root instance ID",
            confirmSavedInterface: "Process instance name successfully changed.",
            lastActionBy: "Last action by",
            startDate: "Start date",
            lastUpdate: "Last update",
            sentAt: "Sent at",
            noRespAvailable: "No response available",
            noReqAvailable: "No request available",
            error: "Error",
            retry: "Retry",
            retryNotify: "Retry?",
            success: "Success",
            unclaim: "Unclaim",
            reassign: "Reassign",
            escalate: "Escalate",
            suspend: "Suspend",
            resume: "Resume",
            terminate: "Terminate process instances",
            bulkTerminateMsg:
                "Terminating these process instances will remove them from the instance list. Any other synchronously started instances related to them will also be terminated.",
            viewLogs: "View logs",
            viewLogsConfirm: "View logs?",
            proceed: "Proceed",
            downloadLog: "Download log",
            deleteBtn: "Delete",
            logsMessage: "This action will open an external link in a new tab",
            terminateInst: "Terminate process instance",
            terminateMessage:
                "Terminating a process instance will end the instance before its completion. It will also terminate any other synchronously running or failed instances related to it. All the active tasks will be removed.",
            archiveInst: "Archive process instance",
            archiveMessage:
                "Archiving a process instance will remove it from the instance list. Any other synchronously started instances related to it will also be archived.",
            deleteInst: "Delete process instance",
            cancel: "Cancel",
            change: "Change",
            delete: "Delete",
            copy: "Copy",
            download: "Download",
            downloadAll: "Download all",
            deleteDocument: "Delete",
            results: "Results",
            startDateInst: "Start Date: ",
            lastUpdateInst: "Last Update: ",
            date: "Date",
            traceId: "Trace ID",
            sortBy: "Sort By",
            refresh: "Refresh",
            ascending: "Ascending",
            descending: "Descending",
            dataModel: "Data Model",
            api: "API",
            documents: "Documents",
            richText: "Rich Text",
            uid: "UID",
            blockchain: "Blockchain",
            messages: "Messages",
            assignee: "Assignee",
            initiator: "Initiator",
            search: "Search",
            dataModelDetails: "Data Model Details",
            instanceName: "Process instance name",
            searchUsersAndGroups: "Search for users and groups",
            searchUsers: "Search for users",
            archivedApplication: "Include archived applications",
            includeDeletedProcesses: "Include deleted processes",
            deletedProcesses: "Deleted processes",
            dataModelModal: {
                modalTitle: "Edit",
                savedSuccessfully: "Successfully Saved",
                savedUnsuccessfully: "Invalid JSON syntax",
                save: "Save"
            },
            headerActionDots: {
                retry: "Retry",
                terminate: "Terminate",
                export: "Export to Excel",
                archive: "Archive",
                delete: "Delete"
            },
            apiDetails: "API Details",
            sorry: "Sorry",
            notAcceptedFileType: "is not an accepted file type.",
            documentTitle: "Documents details",
            commentTitle: "Comments details",
            noDocsAvailable: "No documents available",
            noCommentsExecuted: "No comments available",
            noRichTextAvailable: "No rich text available",
            richTextContentUnavailable: "No rich text content available",
            isExecuted: "is executed in",
            posted: "Posted on {event} for",
            lastUpdatedBy: "Last updated on",
            by: "by",
            canNotTerminate:
                "Only running, failed, or suspended root process instances can be terminated. Please select eligible instances for this operation.",
            canNotRetry: "Only failed process instances can be retried. Please select eligible instances for this operation",
            canNotArchive:
                "Running process instances must be terminated first. Only root instances can be selected archived. Please select eligible instances for this",
            canNotExport: "Please select at least one process instance to export",
            canNotDelete: "Only completed, terminated or achived process instances can be deleted",
            dataModelField: "Data model field",
            uploadedIn: "Uploaded in",
            generatedIn: "Generated in",
            generatedBy: "Generated by",
            relatedTo: "Related to",
            uidDoc: "UID",
            pathOnDisk: "Path on disk",
            noMessagesToBeDisplayed: "No items to be displayed",
            deletedTooltip: "Deleted by {user} on {time}",
            deleteMessage: "Content was deleted by <b>{user}</b> on {time}",
            deletedDoc: "Document was deleted by <b>{user}</b> on {time}",
            messageDetails: "Message details",
            items: " items",
            toLabel: "to",
            errorToStartBigger: "To start date must be after from date !",
            errorToLastBigger: "To last update date must be after from date !",
            deleteValues: "Delete values",
            deleteAuditData: "Delete all data audit entries",
            deleteInformationTitle: "Delete personal information",
            deletePersonalInfo: "Delete personal information",
            editIconDisabledTooltip: "Only root process instances data model can be edited. Please select eligible instances for this operation.",
            deleteDataModelDisabledTooltip:
                "Only root process instances data model values can be deleted. Please select eligible instances for this operation.",
            deleteAllDataModelDisabledTooltip:
                "Only root process instances can have their data audit entries deleted. Please select eligible instances for this operation.",
            deleteDialog: "All values stored in the data model of this process instance will be permanently deleted. Are you sure?",
            deleteDialogTitle: "Delete data model values",
            deleteAuditDialog: "All data audit entries will be permanently deleted. Are you sure?",
            deletePersonalInfoDialog:
                "The values of attributes labelled as personal data will be removed from the Data Model as well as from Data Audits of this instance and any synchronous child instances.",
            deleteAuditConfirmation: "All data audit entries successfully deleted",
            deleteInformationConfirmation: "Personal information successfully deleted",
            deleteValuesConfirmation: "Data model values successfully deleted",
            titleApiModal: "Delete API data",
            titleBlockchainModal: "Delete blockchain {type}",
            messageApi: "Deleting the API {type} data entry is irreversible and the values will not be accessible anymore",
            messageBlockchain: "The content of this blockchain {type} will be permanently deleted. Are you sure?",
            apiDelete: "API {type} data entry successfully deleted",
            blockchainDelete: "Blockchain {type} successfully deleted",
            deleteDataRequest: "Delete data request",
            deleteDataResponse: "Delete data response",
            dataDeleted: "Data deleted",
            dataDeletedBy: "Data deleted by {user} on ",
            archivedStatus: "Archived",
            activeDoc: "Latest",
            comments: "Comments",
            deleteCommentsDialog: "The content of this comment will be permanently deleted",
            deleteTitle: "Delete comment",
            deleteRichText: "Delete Content",
            deleteRichTextMessage: "The content will be permanently deleted. Are you sure?",
            deleteRichTextConfirmation: "The content was successfully deleted",
            richTextStatus: "DELETED",
            content: "Content",
            deleteConfirmation: "The comment was successfully deleted",
            deleteInstancesMess: "The process instance(s) and all its data will be permanently deleted. Are you sure?",
            cancelDeleteInst: "Cancel",
            confirmDeleteInst: "Delete",
            deleteInstancesTitle: "Delete {number} process instances",
            succesDelete: "{number} process instances were successfully deleted",
            processInstanceName: "Process instance name",
            lastSaved: "Last saved",
            lastSavedBy: "Last saved by",
            richTextDetails: "Details"
        },
        brandingPage: {
            nameMandatory: "Name is mandatory",
            title: "Branding",
            brandName: "Company name",
            brandNameSubtitle: "Appears on page title, copyright notices and error messages.",
            inputLabel: "Name",
            navigationLogo: "Navigation logo",
            navigationLogoSubtitle: "Appears on top left of every page, next to the navigation menu.",
            appBuilderSubtitle: "Appears on top of the app builder pages.",
            appBuilderLogoTitle: "App Builder logo",
            loginLogo: "Login area logo",
            loginLogoSubtitle: "Appears on top of the login form.",
            logoInfoNav: "Accepted formats: .jpg, .png, .svg (max 2 MB), with a minimum size of 160x40 px.",
            logoInfoLogin: "Accepted formats: .jpg, .png, .svg ({maxSize}), with a minimum size of 280x60 px.",
            logoInfoFav: "Accepted formats: .jpg, .png, .svg (max 2 MB), with a minimum size of 16x16 px.",
            logoInfoApp: "Accepted formats: .jpg, .png, .svg (max 128 KB), with a minimum size of 80x80 px.",
            appBuilderLogo: "Accepted formats: .jpg, .png, .svg (2MB), with a minimum size of 48x48 px.",
            colorCode: "Use your color with good contrast & try to avoid light colors.",
            colorCodeTitle: "Branding color",
            colorCodeLabel: "Hex color code",
            colorCodeSubtitle: "Appears on all selected navigation icons.",
            resetBtn: "Reset to default",
            uploadBtn: "Upload new logo",
            favicon: "Favicon",
            faviconSubtitle: "Appears on browser tabs and bookmarks",
            uploadBtnFavicon: "Upload new favicon",
            appPlaceholderLogo: "Application placeholder logo",
            appPlaceholderSubtitle: "Appears as the default logo for applications.",
            sizeError: "Uploaded image is too large. Maximum allowed size is 2MB.",
            sizeErrorLogo: "Uploaded image is too large. Maximum allowed size is {sizeLimit}."
        },
        settings: {
            caption: "Application settings",
            highlights: "Highlights",
            userPermissions: "User & Permissions",
            notifications: "Notifications",
            interrogations: "Interrogations",
            importSettings: "Import settings"
        },
        navigation: {
            caption: "Admin",
            usersRoles: "Users and Groups",
            schedule: "Work Schedule",
            users: "Users",
            appM: "Manage Apps",
            docM: "Manage Documents",
            uiM: "Manage UI's",
            mktComponents: "Marketplace",
            mktApps: "Apps from Marketplace",
            settings: "Advanced settings",
            notSettings: "Messaging & Com",
            application: "Application",
            features: "Features",
            plugins: "Plugins",
            taskNotifications: "Email Templates",
            authentication: "Authentication",
            systemApis: "System APIs",
            SSLCertificates: "SSL Certificates",
            logs: "Logs"
        },
        logs: {
            titleApi: "API call logs",
            descriptionApi: "Detailed logs for all API calls performed by Aurachain applications.",
            export: "Export",
            dialogTitle: "Export API usage log",
            logsMessage: "You will be notified via email once the export has been processed and the file is ready for download",
            allApplications: "All applications",
            notifyMessage: "Log export started. You will be notified via e-mail once the log file is available.",
            titleSecurity: "Security log",
            descriptionSecurity: "Detailed list with security-related events (startup, shutdown, logins, password changes, user management, etc.)",
            fromDateTimeError: "From is mandatory",
            toDateTimeError: "To is mandatory",
            titleAttachments: "Attachments download logs",
            descriptionAttachments: "Detailed logs for attachment downloads performed in Aurachain (source, user, date-time, etc.)"
        },
        dialogs: {
            delete: {
                msgSingle: "Are you sure you want to delete this item?",
                msgMultiple: "Are you sure you want to delete these items?",
                confirm: "Yes",
                cancel: "No"
            },
            roles: {
                title: "Users for",
                name: "User"
            },
            users: {
                title: "Roles for",
                name: "Role Name"
            }
        },
        roles: {
            modal: {}
        },
        users: {
            name: "Full Name",
            username: "Username",
            email: "Email"
        },
        manageApps: {
            name: "Name",
            owner: "Owner"
        },
        manageDocuments: {
            name: "Name",
            owner: "Owner"
        },
        manageUIs: {
            name: "Name",
            description: "Description",
            noDescription: "There is no description provided",
            owner: "Owner",
            usedOn: "UI used on"
        },
        mktButtons: {
            install: "INSTALL",
            remove: "REMOVE",
            update: "UPDATE",
            sync: "SYNC"
        },
        mktComponents: {
            name: "Component Name"
        },
        mktApps: {
            name: "App Name"
        },
        notification: {
            title: "Email templates",
            emailTemplate: "Email Template",
            subjectInput: "Subject",
            editorHTMLTitle: "Email Template HTML Editor",
            htmlEditor: "HTML Editor",
            htmlEditorError: "HTML Editor has errors. Check marked lines! ",
            save: "Save",
            restoreDefault: "Restore default",
            newTaskTemplate: "New task",
            newArchiveAppTemplate: "Archive application",
            newArchiveInstance: "Archive process instance",
            newAccount: "Create new account",
            shareReportsFilterTemplate: "Shared filter",
            resetPassword: "Reset password",
            htmlName: "HTML Template",
            expiredDelegator: "Delegation expired(to delegator)",
            expiredDelegate: "Delegation expired(to delegatee)",
            newDelegation: "New Delegation Request",
            cancelledDelegation: "Cancelled Delegation",
            updateDelegationToDelegate: "Updated Delegation (to delegatee)",
            updateDelegationToDelegator: "Updated Delegation (to delegator)",
            delegationAccepted: "Delegation request accepted",
            delegationRejected: "Delegation request rejected",
            delegatorReminder: "Delegation received reminder(to delegator)",
            delegateReminder: "Delegation received reminder(to delegatee)",
            changedEmail: "Changed Email Address",
            changedPassword: "Changed Password",
            changedInformation: "Changed Account Information",
            changedPhone: "Changed Phone Number",
            archiveProcess: "Archive process",
            SSLExpired: "SSL certificate expired",
            blockchainWallet: "Blockchain Wallet",
            gdmSuccess: "Data Store Legacy - export (success)",
            gdmFailed: "Data Store Legacy - export (failed)",
            dataStoreSuccess: "Data Store 2.0 - export (success)",
            dataStoreFailed: "Data Store 2.0 - export (failed)",
            reportsSucces: "Analytics export (success)",
            reportsFailed: "Analytics export (failed)",
            logExportSuccess: "Log Export (success)",
            logExportFailed: "Log Export (failed)",
            dataStoreImportSuccess: "Data Store 2.0 - import table (success)",
            dataStoreImportFailedValidation: "Data Store 2.0 - failed table import (validation)",
            dataStoreImportFailedSystem: "Data Store 2.0 - failed table import (system)",
            dataStoreImportDataSkippedRows: "Data Store 2.0 - import data (skipped rows)",
            dataStoreImportFailedDataValidation: "Data Store 2.0 - failed data import (validation)",
            dataStoreImportFailedDataSystem: "Data Store 2.0 - failed data import (system)",
            dataStoreImportDataSuccess: "Data Store 2.0 - import data (success)",
            defaultTemplate: "Default",
            customTemplate: "Custom"
        },
        messagingCom: {
            title: "Messaging & com",
            email: "Email",
            sms: "SMS",
            twilio: "Twilio",
            other: "Other",
            outgoingEmail: "Outgoing email address",
            server: "SMTP Server",
            outgoingDisplayName: "Outgoing display name",
            username: "SMTP Username",
            pass: "SMTP Password",
            requiresAuthentication: "Requires Authentication",
            useEncryption: "Use SMTP TLS Encryption",
            changeInfo: "Change information",
            testEmail: "Test email",
            accID: "Account ID",
            authToken: "Auth Token",
            outgoingPhone: "Outgoing phone number",
            testSMS: "Test SMS",
            save: "Save",
            discard: "Discard",
            serviceName: "Service name",
            passKey: "Pass key",
            configService: "Configure service",
            deleteService: "Delete the service",
            deleteServiceBody: "This file scanning service will be deleted. Are you sure?",
            serviceBodyNotSaved: "If you exit without saving all your changes will be lost. Are you sure? ",
            fileScanningSaved: "File scanning has been configured successfully",
            warning: "Warning",
            mandatory: "This field is required!",
            testEmailModal: {
                title: "Send test Email",
                properties: "Email Properties",
                recipients: "Recipients",
                subject: "Subject",
                body: "Body",
                notification: "Email has been sent successfully",
                send: "Send",
                recipientsRequired: "Recipients are required",
                subjectRequired: "Subject is required",
                emailValid: "Email address must be valid"
            },
            testSmsModal: {
                title: "Send test SMS",
                properties: "SMS Properties",
                recipients: "Recipients",
                body: "Body",
                notification: "SMS has been sent successfully",
                recipientsRequired: "Recipients are required",
                mobileValid: "Mobile number should start with +"
            },
            saveNotification: "SMS gateway settings saved successfully",
            failedPass: "Failed to connect to {serviceName} service: Invalid passkey",
            failedService: "Failed to connect to {serviceName} service: invalid service name"
        },
        usersAndRoles: {
            title: "Users and Groups",
            manageGroupsTitle: "Groups",
            createRole: "Create a new group",
            addUser: "Add new user",
            searchPlaceholderUsers: "Search users",
            users: "Users",
            user: "user",
            roles: "Groups",
            role: "group",
            usersLower: "users",
            rolesLower: "groups",
            and: " and ",
            usersChipsInfo: "Total users - 1 to 10 displayed here",
            browseRoles: "Browse groups",
            items: "items",
            browseUsers: "Browse users",
            editRole: "Edit group",
            editUser: "Edit user",
            roleSettings: "Group settings",
            userSettings: "User settings",
            searchPlaceholder: "Search for users or groups",
            searchPlaceholderGroups: "Search for groups",
            addPermissions: "Add Permissions",
            addUsersAndGroups: "Add users and groups",
            groupCoreDescription: "Core",
            groupTypeTD: "User defined",
            groupTPD: "Application: ",
            groupsSubtitle1: "This application has ",
            groupsSubtitle2: " active group of users",
            groupsSubtitle3: " active groups of users",
            showOnlyActiveGr: "Show active groups only",
            groupsNoGroupsSubtitle: "This application has no active groups of users!",
            usernameField: "Field completed when typing the email address.",
            disabledOn: "Disabled on ",
            sync: "Synchronized",
            viewAll: "View all",
            noUsersAvailable: "No users available!",
            addRoleModal: {
                title: "Create new group",
                roleTitle: "Group name",
                addPermissions: "Add permissions",
                usersCardTitle: "It looks like this group doesn't have any members",
                usersCardDescription: "Add some groups and/or users",
                addUsers: "Add users",
                addMembers: "Add users and groups",
                accessPermissions: "Access permissions",
                additionalPermissions: "Additional permissions",
                permissionsLabel: "Manually added",
                roleError: "Group name is required",
                roleSpaceError: "Group name should not start or end with empty space, contain special characters or contain only numbers.",
                duplicateRoleError: "A group with the same name already exists in the platform. Please choose another group name.",
                initiator: "Ini",
                editor: "Wri",
                report: "Rep",
                deletePermission: "Delete",
                PUBLISHED: "PUBLISHED",
                NOT_PUBLISHED: "NOT PUBLISHED",
                UNPUBLISHED_CHANGES: "UNPUBLISHED CHANGES",
                alreadyExistName: "Group name already exists!",
                selectManager: "Select a manager",
                selectManagerModal: "Select manager",
                changeManager: "Change manager",
                noUsersManager: "Add users in order to select a Manager",
                typeManager: "MANAGER",
                typeLDAP: "LDAP",
                selectUsersGroups: "Select users and groups",
                save: "Save",
                update: "Update",
                add: "Add",
                platform: "PLATFORM",
                application: "APP",
                system: "SYSTEM",
                external: "EXTERNAL",
                successfulCreate: "The group has been successfully created",
                titleNotif: "Disable group",
                messageNotif: "Disabling a group will permanently remove the group from all the locations where it was set and from the active list.",
                cancelBtnNotif: "Cancel",
                disableBtnNotif: "Disable",
                createGroup: "The group has been successfully created",
                disableGroup: "The group has been successfully disabled",
                dontChangePass: "User is disabled/inactive. Before you can change the password you need to activate/enable the user."
            },
            addUserModal: {
                noUsersSelected: "No users selected",
                usersSelected: " users selected"
            },
            editRoleModal: {
                title: "Edit group",
                parent: "Parent group",
                groupStatus: "Group status",
                enableOrDisable: "Enable or Disable a group",
                disabledBy: "Disabled by ",
                disabledOn: " on ",
                updateGroup: "The group has been successfully updated",
                disableGroup: "The group has been successfully disabled"
            },
            manualAddModal: {
                title: "Manually add user",
                uploadImage: "Upload image",
                firstName: "First name",
                lastName: "Last name",
                email: "Email address",
                username: "Username",
                gender: "Gender",
                language: "Select language",
                english: "English",
                status: "Status",
                addUserBtn: "Add User",
                randomPass: "By default the system sends to the users's email adress an invitation to set the password",
                randomPassDescription: "The user will receive an email with a randomly generated password. He will have to change it after the first login.",
                manualPassword: "Manually set password",
                password: "Password",
                confirmPassword: "Confirm password",
                passwordRequirements:
                    "The password must contain at least one uppercase letter, one lowercase letter, one 0-9 figure, one symbol (eg. @, #, etc.) and must be at least 10 and at most 128 characters long, and not have more than two identical characters in a row (eg. aa).",
                firstNameErr: "First name is required",
                phoneErr: "Please enter a valid phone number starting with '+'",
                usernameErr: "Username is required",
                lastNameErr: "Last name is required",
                phoneNumber: "Phone number",
                occupation: "Occupation",
                organization: "Organization",
                phoneError: "Phone number is required",
                occupationError: "Occupation is required",
                organizationError: "Organization is required",
                emailErr: "Email is required",
                emailValidErr: "Email address must be valid",
                genderErr: "Gender selection is required.",
                passwordErr: "Password is required.",
                maleGender: "Male",
                femaleGender: "Female",
                invalidEmail: "Invalid email address format",
                emailDuplicate: "Email address is already used",
                usernameDuplicate: "Username is already used",
                noRoles: "This user is not yet part of any groups.",
                addRoles: "Add group",
                inheritedRoles: "Inherited from groups",
                inheritedInfo: "This user has the following access permissions inherited from the groups he is included in:",
                specificApps: "Specific applications",
                specificInfo: "This user has the following access permissions regardless of the groups he is included in:"
            },
            permissionsModal: {
                title: "Set permissions",
                selectApp: "Select application",
                levels: "Levels",
                initiator: "Initiator",
                editor: "Editor",
                reportViewer: "Report Viewer",
                app: "Application",
                requireApps: "Please select an application!",
                requirePermissions: "There are no permissions selected!",
                search: "Search",
                placeholderApplication: "Select application",
                manualPermissions: "Permissions - manually added",
                oneRole: "group",
                moreRoles: "groups",
                saveBtn: "Save",
                updateBtn: "Update"
            },
            addNewUserOnRole: {
                availableUser: "Available users"
            },
            addNewRoleOnUser: {
                done: "Done",
                editTitle: "Select group",
                noRoles: "No groups selected ",
                selection: "group selected",
                selections: " groups selected"
            },
            editUserModal: {
                title: "Edit user details",
                changePassword: "Change user's password",
                english: "English",
                romanian: "Romanian",
                userStatus: "User status",
                active: "Active",
                inactive: "Inactive",
                disabled: "Disabled",
                savedSuccessfully: "The user has been successfully updated",
                createdSuccessfully: "The user has been successfully created",
                errorAdmin: "Cannot change another admin's password!",
                disabledTooltip: "User cannot login, cannot be added to groups/permissions, and cannot be assigned to tasks or notifications.",
                inactiveTooltip: "User no longer exists in the Active Directory",
                disabledWarningTitle: "Disable User?",
                disabledWarningMessage:
                    "The user will no longer be able to log in and will no longer receive any notifications. All tasks currently claimed by the user will be unclaimed."
            },
            addGroupMembers: {
                addTitleModal: "Add users and groups",
                editTitleModal: "Edit users and groups",
                addButtonTitle: "Add",
                title: "Users and groups",
                searchPlaceHolder: "Search users and groups",
                showSelectedNrs: "users",
                showSelectedNr: "user",
                showSelectedGroupNr: " group",
                showSelectedGroupNrs: "groups",
                inGroup: "in this group",
                and: "and",
                showSelected: "selected",
                showAnd: "and",
                emptyList: "Nothing to display",
                noItemsList: "There are no elements in this list",
                emptyGroup: "No groups and users",
                nrsUsersGroup: "users in this group",
                nrUsersGroup: "user in this group",
                nrGroupGroup: "group in this group",
                nrsGroupGroup: "groups in this group",
                nrGroupUsersPart1: "group and ",
                nrGroupUsersPart2: "users in this group",
                ldapType: "LDAP",
                noUsersGroups: " No groups and users in this group",
                noMembersAvailable: "No members available!",
                loadMore: "Load more",
                systemUser: "System user"
            }
        },
        labs: {
            title: "Features",
            stable: "Additional",
            experimental: "Experimental",
            integration: "Integrations",
            KIBANA_LOG_title: "Allow Kibana log integration",
            FULL_TIMELINE_title: "Display full timeline",
            APP_UPDT_title: "Update Application",
            ALLOW_MULTILANGUAGE_title: "Allow multi language",
            ACCESSIBILITY_title: "Accessibility",
            INTEGRATION_V2_title: "Migrate Integration",
            INTEGRATION_V2_description: "Migrate Integration to V2",
            DESIGN_title: "Migrate to design service feature",
            MULTI_SC_title: "Migrate to multiple SmartContracts",
            ALLOW_TWO_FACTOR_title: "Protect accounts with 2-factor authentication",
            REPLACE_BASE64_IMAGE_title: "Replace all base64 images from templates with url",
            FILE_SCANNING_title: "File scanning",
            ENABLE_AI_title: "Enable AI assisted scripting",
            ENABLE_AI_description: "Enable the ChatGPT-powered assistant for the UI builder.",
            ENABLE_ASSISTANT_title: "Enable AI Task assistant",
            ENABLE_ASSISTANT_description: "Enable the ChatGPT-powered assistant for the application users",
            configure: "Configure",
            configuration: "Configuration",
            apiKey: "API key",
            chatDeploymName: "Chat deployment name",
            embeddingDeploymName: "Embedding deployment name",
            editConfiguration: "Edit configuration",
            enableAI: "Enable AI",
            url: "URL",
            aiDialogTitle: "Disclaimer",
            TASK_DELEGATION_title: "Task delegation",
            KIBANA_LOG_description: "Allow Administrators to open logs in Kibana from Process Controller.",
            APP_UPDT_description: "Update Application imported from other environments.",
            FULL_TIMELINE_description:
                "Display full audit trail for users in task window. Users will be able to see the audit trail for all process activities including the system ones.",
            ALLOW_MULTILANGUAGE_description: "Allow users to select a different language beside the default one.",
            ACCESSIBILITY_description: "Use an accessibility-compliant color scheme across the platform.",
            REPLACE_BASE64_IMAGE_description: "One time usage! This feature save the base64 images on our server and expose an url to be consumed.",
            TASK_DELEGATION_description: "Allow registered users to delegate their tasks while away.",
            GDM_title: "Data Store",
            legacy: "Legacy",
            DESIGN_description: "Migrate old data to design service.",
            GDM_description: "Allow users to have access to the Data Store area and manage data tables.",
            GDM_false_tooltip: "Please contact your administrator. In order to use this feature some technical prerequisites need to be checked",
            GDM_true_tooltip: "Data Store area is enabled",
            MULTI_SC_description: "One time usage! If enabled, all blockchain application will be updated in order to enable multiple SC.",
            ALLOW_TWO_FACTOR_description:
                "Add an extra layer of security. Each time users provide their password, they will also receive a validation code via SMS.",
            SIGNUP_title: "Enable self-enrollment",
            SIGNUP_description: "Show “Create new user” button on login screen and link it to an enrollment process.",
            FILE_SCANNING_description: "Configure file scanning behavior for files uploaded in the platform",
            additionalDescription:
                "Some features in {brandName} are enabled on request only. They are stable features which can be enabled or disabled, depending on the users' needs.",
            experimentalDescription:
                "{brandName} offers several beta features known as Experimental, which are exciting new ways to enhance your applications. Keep in mind that when you use an Experimental feature, you are agreeing to use a feature that has not been fully tested and may still have some bugs.",
            additionalEmptyState: "There are no additional features available at this time",
            experimentalEmptyState: "There are no experimental features available at this time",
            integrationEmptyState: "There are no integration features available at this time",
            updateApplication: "Update Application",
            updateApp1: "The current version (e.g. the app that is going to get updated) will be replaced by the updated one (from the update package)",
            updateApp2: "Updates can occur in all building modules.",
            updateApp3: "The newly created elements will be added to the current version.",
            updateApp4: "The deleted elements in the update package will not be removed at update - they will remain as is.",
            featureCancel: "Cancel",
            featureSave: "Save Configuration",
            featureStatusTitle: "Enabled",
            dialogTitle: "Unsaved changes",
            dialogMessage: "If you leave this page, any changes you have made will be lost.\n Are you sure you want to return to Features page?",
            disclaimerAI: "Warning: prompts entered by app creators when editing scripts using this feature will be sent to third party service provider together with the current content of the script being edited. Please ensure that your organisation allows the use of ChatGPT. By enabling this feature, you acknowledge and accept the inherent risk of sharing potentially sensitive information. Aurachain shall not be held liable for any loss, damages, or consequences arising from the transmission of such data.",
            disclaimerTaskAI: "Warning: this feature can allow app users to upload documents to OpenAI or Azure (depending on the configuration).Please ensure that your organisation allows the use of ChatGPT. By enabling this feature, you acknowledge and accept the inherent risk of sharing potentially sensitive information. Aurachain shall not be held liable for any loss, damages, or consequences arising from the transmission of such data.",
            disclaimerAIDialog: "Prompts entered by app creators when editing scripts using this feature will be sent to third party service provider together with the current content of the script being edited. Please ensure that your organisation allows the use of ChatGPT. By enabling this feature, you acknowledge and accept the inherent risk of sharing potentially sensitive information. Aurachain shall not be held liable for any loss, damages, or consequences arising from the transmission of such data.",
            discaimerTaskAIDialog: "This feature can allow app users to upload documents to OpenAI or Azure (depending on the configuration).Please ensure that your organisation allows the use of ChatGPT. By enabling this feature, you acknowledge and accept the inherent risk of sharing potentially sensitive information. Aurachain shall not be held liable for any loss, damages, or consequences arising from the transmission of such data.",
            noAIConfiguration: "Not configured",
            warningMessage: "If you leave before saving, your changes will be lost. Are you sure you want to continue?",
            warningTitle: "Warning!",
            configured: "Configured",
            errorTitleAi: "Configure the AI assisted scripting feature",
            errorTitleTaskAi: "Configure the AI Task assistant feature",
            agreementConfirmation: "I agree",
            mandatoryField: "This field is mandatory",
            limitExceeded: "ChatGPT token limit exceeded. Try to shorten your prompt.",
            cannotReach: "Could not reach the AI service. Please contact an administrator.",
            genericError: "An unknown error has occurred",
            apiAuthentificationError: "Could not reach the AI service. Please contact an administrator",
            publicEnrollment: {
                title: "Self-enrollment process",
                noSignUpApps: "The Users API is not enabled for any applications.",
                signUpEmptySubtitle: "Enable the Users API via the Internal APIs menu.",
                labelBtn: "Select process",
                changeAppBtn: "Change process",
                modalTitle: "Select self-enrollment process",
                modalSubTitle: "Eligible applications",
                processesSubTitle: "Eligible processes",
                code: "Code:",
                errorTitle: "Select an application for public enrollment.",
                noProcessToDisplay: "The currently selected application doesn't have any eligible processes available."
            },
            scanningService: {
                title: "Add new service",
                editTitle: "Edit service",
                subtitle: "Configuration",
                serviceNameErrMsg: "Service name can't contain special characters"
            }
        },
        authentication: {
            enforce: "Single Sign-On",
            infoSSO: "Allow users to log in using an external SAML or OpenID Connect Identity Provider.",
            firstStep: "Select protocol",
            secondStep: "Endpoints",
            identityProvider: "Identity provider",
            configurationDoneToast: "{provider} successfully configured!",
            ssoDoneToast: "Single sign-on successfully enabled!",
            ssoDisableToast: "Single sign-on successfully disabled!",
            samlDomain: "Domain",
            clientId: "Client ID",
            clientSecret: "Client secret",
            configurationUrl: "Well-known configuration URL",
            viewConfig: "View configuration",
            samlDetails: "SAML endpoints",
            openIdDomain: "OpenID configuration",
            openIdDomainDescription: "Provide the information below in order to finish the configuration",
            uploadArea: "UPLOAD AREA",
            redirectURL: "Authorization redirect URL",
            logoutURL: "Logout URL",
            openIdDetails: "OpenID Connect endpoints",
            openIdDetailsDescription: "Use the information below to configure the OpenID Connect Identity Provider.",
            configurationFile: "Configuration file",
            dialogTitle: "Turn off Single Sign-On?",
            turnOffBtn: "Turn off",
            dialogMessage: "After disabling Single-Sign On, users on the SSO domain will be converted to Platform users.",
            deleteDialogTitle: "Delete Configuration",
            deleteDialogMsg: "Are you sure you want to delete this configuration?",
            configurationFirstInfo: "Obtain an XML configuration file from the SAML Identity provider.",
            autoProvisioningSSO: "Allow automatic provisioning of SSO accounts",
            configurationSecondInfo: "The configuration file must contain the Identity Provider certificate, the entity ID/Issuer and the redirect URL.",
            samlDetailsDescription: "Use the information below to configure the SAML Identity Provider.",
            samlDomainDescription:
                "Usernames on this domain will be redirected to the Identity Provider to authenticate. After successful authentication, if the username corresponds to a Platform user, it will be converted to an External user.",
            oidcInfoUrls:
                "Enter the client ID, client secret, and provide an OpenID Connect Discovery configuration URL that contains a valid OpenID configuration",
            simpleNext: "Next",
            previousStep: "Previous",
            ldapInfoText:
                "An LDAP configuration has been detected. Single Sign-On cannot be used while LDAP authentication is active. Please contact your IT department for more information.",
            downloadMetadata: "Download metadata file",
            domainError: "The domain name cannot be empty",
            clientIdError: "The client ID cannot be empty",
            clientSecretError: "The client secret  cannot be empty",
            configUrlError: "The URL does not contain a valid configuration",
            disableConfiguration: "No configuration available",
            metadataInfoTitle: "Identity Provider Metadata file",
            thirdStep: "Finish Configuration",
            selectProvider: "Select your service provider",
            samlProviderTitle: "SAML single sign-on",
            samlProviderDescription: "Configure authentication through a SAML Identity Provider",
            openIdProviderTitle: "OpenID Connect",
            openIdProviderDescription: "Configure authentication through an OpenID Connect Identity Provider",
            providerID: "Service Provider Entity ID ",
            providerURL: "Service Provider Assertion Consumer Service URL/SP Login URL ",
            providerMessage2: "to your Identity Provider.",
            labelURL: "Service Provider Assertion Consumer Service URL",
            urlLogoutLabel: "Single log-out (SLO) URL",
            logoutUrlTooltip: "URL the identity provider can use to log the users out of {brandName}",
            and: "and ",
            next: "Next Step",
            copyClipboard: "Content has been successfully copied!",
            copyToClipboardCustomMsg: " succesfully copied to clipboard!",
            fileNameCopyClipboard: "File name has been copied!",
            metadataInfo:
                "The user must upload the Identity Provider metadata XML file that contains the Identity Provider certificate, the entity ID/Issuer and the redirect URL.",
            finishInfo:
                "Please, make sure that your steps are correctly followed for configurating your SAML connection. You can always take a look on the previous step to confirm that everything is ok.",
            readyInfo:
                "You are now ready to log in with SAML SSO, and all the log in requests will be redirected to your Identity Provider. If you want to edit your configuration, please press below.",
            domainName: "Domain name",
            editConfig: "Edit configuration",
            providerIDTooltip: "The SAML identifier that uniquely names the {brandName}. This Entity ID is also known as Service Provider Issuer or Audience.",
            providerURLTooltip: "The URL where the {brandName} listens for requests from Identity Provider",
            domainTooltip: "The domain is used for enforcing domain users to sign in with SAML SSO",
            identityMetadata: "Identity Provider metadata XML",
            logoutSAMLError: "Your current session has expired, please re-login to continue your work in the application.",
            uploadTitle: "Uploaded file",
            usedFile: "Used file"
        },
        systemApis: {
            title: "System APIs",
            users_apiTitle: "Users and Groups API",
            users_apiDescription: "Allows applications to create and manage users and groups",
            series_apiTitle: "Series API",
            series_apiDescription: "Allows applications to generate a distinct sequence of unique numbers for each defined series",
            downloadLog: "Download log",
            defaultDesc: "This api is not enabled for any applications",
            enabledDescription: "This api is enabled for {counter} application | This api is enabled for {counter} applications",
            addAppBtn: "Add application",
            appPermissions: "Application permissions",
            appTitle: "Applications",
            selectApp: "Select application",
            methods: "Methods",
            CHECK_USERDescription: "Allows to check user exists",
            GET_USERDescription: "Allows get user",
            ADD_USER_TO_GROUPDescription: "Allows to add user to group",
            ADD_USERDescription: "Allows to add new users",
            appSuccessfully: "Permissions successfully added",
            appSuccessUpdated: "Permissions successfully updated",
            appError: "There was an error while saving the permission.",
            notifAppDelete: "Permissions successfully removed",
            messageTitle: "Remove permission",
            messageBody: "Are you sure you want to remove this permission ?",
            messageTitleNoDelete:
                "This application is currently used as self-enrollment application. Please disable self-enrollment or choose a different self-enrollment application in Admin > Features."
        },
        SSLCertificates: {
            title: "SSL Certificates",
            tableTitle: "Trusted certificate authorities",
            upload: "Upload new certificate",
            issuedBy: "Issued by",
            issuedTo: "Issued to",
            name: "Name",
            addedOn: "Added on",
            download: "Download",
            expirationDate: "Expiration date",
            status: "Status",
            delete: "Delete",
            retrieveForURL: "Retrieve certificate for URL",
            retrieveCertificate: "Retrieve certificate",
            retrieveFromServer: "Retrieve Certificate Authority from Server",
            serverURL: "Server URL",
            deleteCertificate: "Delete Certificate",
            confirmDelete: "The certificate will be permanently removed from the platform. Are you sure?",
            uploadCertificates: "Upload certificates",
            successfullyAdded: "Certificate successfully added. It might take up to 1 minute to register.",
            successfullyDeleted: "Certificate successfully deleted."
        }
    },
    diagrams: {
        gridText: "Show grid",
        bridgesText: "Show connector bridges",
        labelsText: "Show labels",
        gridTooltip: "Show or hide the background pattern behind activities and connectors",
        bridgesTooltip: "Show or hide a visual marker when connectors overlap",
        diagram: "Diagram settings",
        performanceInfo: "Diagram performance enhanced. Connector bridges hidden. Reactivate from the bottom-right three-dot menu.",
        uiTitle: "Diagrams",
        activities: "Activities",
        events: "Events",
        gateways: "Gateways",
        confirmActivation: "Your last saved app will be published, continue?",
        appActivated: "The application was published successfully",
        duplicatedCode: "There is already a code {name}",
        untitledConnector: "Untitled connector",
        connectorType: "Connector",
        errorMenuTitle: "Application cannot be published -  Errors Found",
        hintsErrorsEmptyState: "Here you will see Hints or Errors related to the process",
        task: "Task",
        decisions: "Decisions",
        externalTask: "External Task",
        generateDoc: "Generate Documents",
        callAPI: "Call API",
        process: "Process",
        advLogic: "Advanced Logic",
        start: "Start",
        startExt: "Start from external",
        end: "End",
        expAPI: "Expose API",
        exclusiveGate: "Exclusive Gateway",
        parallelGate: "Parallel Gateway",
        joinGate: "Join Gateway",
        blockchain: "Blockchain",
        dataExp: "Data export",
        blockEv: "Blockchain event",
        blockStart: "Start Blockchain",
        pluginDescription: {
            name: "Object properties",
            noPluginSelected: "There are no objects selected. Choose one from the left sidebar to find out more about its properties",
            noneSelected: "None"
        },
        turnaroundTime: {
            title: "Turnaround time",
            modalTitle: "Stats",
            liveApps: "Live apps ",
            app: "App",
            reference: "Reference",
            currentPeriod: "Current period",
            variation: "Variation",
            lastPeriod: "Last period",
            stage: "Stage",
            week: "Week",
            month: "Month",
            year: "Year"
        },
        thresholds: {
            title: "Thresholds",
            attention: "Attention threshold",
            warning: "Warning threshold",
            showStage: "Show stage lights",
            filters: "Filters",
            dataModel: "Data model",
            value: "Value",
            reset: "Reset filter",
            filter: "Filter"
        },
        appTracer: {
            title: "App tracer"
        },
        canvasElements: {
            name: "Canvas elements",
            details: "Details",
            targets: "Targets",
            users: "Assign",
            rules: "Rules",
            levels: "Levels",
            external: "Dynamic external tasks"
        },
        components: {
            valueRequired: "This value is required",
            label: "Label",
            statusName: "Status name",
            statusCode: "Status code",
            code: "Code",
            description: "Description",
            deadline: "Deadline",
            timeToDeadline: "Time to deadline",
            expirationFrame: "Timeframe",
            expirationTitle: "Expiration behaviour",
            processBeh: "Process behaviour",
            selectTarget: "Select target",
            expiration: "Time to expiration",
            expirationTarget: "Expiration target",
            expirationBehaviour: "Expiration Behaviour",
            errorTime: "This field is required",
            errorTimeUnit: "Select time unit",
            target: "Select a target",
            settings: "Settings",
            expirationTime: "Expiration Time",
            minutes: "Minutes",
            hours: "Hours",
            days: "Days",
            approvalEvent: "Approval Matrix decisions",
            approve: "Approve",
            autoApprove: "Auto approve",
            reject: "Reject",
            autoReject: "Auto reject",
            approvalMDecision: "Assign decisions",
            decisionOverride: "Decision allready userd and it will be assiged here instead",
            onlyNumeric: "Only numeric characters",
            maxValue: "Max value is ",
            emptyOpt: "Empty/Null",
            empty: "Empty",
            todayOpt: "Today",
            alwaysOpt: "Always",
            taskPriority: {
                priorityLevel: "Priority level",
                lowest: "Lowest",
                low: "Low",
                normal: "Normal",
                high: "High",
                highest: "Highest"
            },
            deadlineExpiration: {
                cardtitle: "Deadline & Expiration",
                defaultNotification: "No notification",
                notificationNumber: "No notifications set | One notification set | {count} notifications set",
                modalTitle: "Set Deadline & Expiration",
                modalTitleExpiration: "Expiration Behaviour",
                title: "Deadline & Expiration Behaviour",
                defaultCreation: "creationDateTime",
                chipType: "Task",
                modType: "MOD",
                timeTodead: "Time to deadline",
                timeToExpiration: "Time to expiration",
                defaultDeadline: "deadline",
                extraTextDeadline: "If the task deadline can't be determined the system will use the ",
                extraTextAfter: "to set the deadline.",
                activateExpiration: "Add expiration behaviour",
                description: "The task will become overdue ",
                descriptionGen: "The task will become overdue {customTime} ",
                descriptionGen1: "The task will become overdue after {customTime} ",
                after: "after ",
                from: "from",
                generalInfoDeadFrom: "from task creation.",
                generalInfoDead: " after task creation.",
                generalInfoExp: "deadline and the process will follow {plugin} path.",
                generalInfoExpExpose: "task creation and the process will follow {plugin} path.",
                d: "day",
                ds: "days",
                h: "hour",
                hs: "hours",
                m: "minute",
                ms: "minutes",
                descriptionExpiration1: "The task will expire after ",
                descriptionExpiration1After: "The task will expire {customTime} after ",
                descriptionExpiration2: "If the task expiration can't be determined or is in the past the system will use ",
                descriptionExpiration3: " to set the expiration.",
                processFollow: " and the process will follow {plugin} path.",
                behaviourFollow: " and the process will follow {plugin} behaviour",
                defaultDescription: "Not configured.",
                selectTarget: "Select Target",
                errorTarget: "Please select a target to save the expiration behaviour",
                deadlineError: "The time to deadline value is mandatory to save the configuration",
                expirationError: "The time to expiration value is mandatory to save the configuration",
                deadlineFormat: "Valid values are: 3d 20h 30m",
                activateSchedule: "Use work schedule"
            },
            setGui: {
                assignUi: "Assign user interface",
                assignedUi: "Assigned user interface ",
                availableUis: "Available user interfaces",
                unassigned: "Unassigned",
                createdBy: "Created by",
                createNew: "Create new user interface",
                currAssignment: "Currently assigned to: {nrItems} other items",
                addInterface: "Add user interface",
                wasNotAssigned: "Not in use",
                wasAssigned: "Used in {count} place | Used in {count} places",
                nothing: "Nothing to display",
                nothingDetails: "There are no user interfaces available yet",
                notResultsFound: "No results found",
                notResultsDetails: "Your search didn't return any user interfaces"
            },
            configApi: {
                apiSettings: "API Settings",
                errModalTitle: "Path",
                errDetailsTitle: "Error details",
                errNumber: "Error number",
                errDescription: "Error description",
                configExposeApi: "Configure Expose API",
                configured: "Configured",
                clientsDefined: "clients defined",
                client: "client",
                rulesDefined: "rules defined",
                configApi: "Configure API",
                configParameter: "Configure parameter",
                customHeaderErrorValue: "The name is already used in this custom header configuration",
                emptyNameError: "Name cannot be empty",
                selectValueDataModel: "Select value",
                customDataTab: "Custom data",
                deleteRuleTitle: "Delete blockchain event rule",
                valueCustomDataInput: "Value",
                deleteRuleBody: "This rule will be permanently deleted. Are you sure?",
                noActionTitle: "Please configure",
                addBtn: "Add",
                error: "Error",
                errEditor: "Error editor",
                addRules: "Add new rule",
                ruleEditor: "Rule Editor",
                actionError: "Action(Required)",
                apiLabel: "Select API",
                metLabel: "Select method",
                selectedMethodErrorLabel: "Please select a method",
                reqTitle: "Request",
                respTitle: "Response",
                noDataModel: "No Datamodel field",
                respTab: "Response",
                errors: "Errors",
                noPath: "This field is required!",
                placeholder: "No DataModel",
                selectApi: "Select Api response",
                respEqual: "Equals",
                busiTitle: "Set rules",
                apiFrom: "From Api to",
                actionErr: "Select path",
                defaultPath: "Select default path",
                selectAction: "Select action path",
                selectResp: "Select response",
                addNewApi: "Add new condition",
                addNewConsumedApiTitle: "Create new external API",
                editConsumedApiTitle: "Edit External API",
                addNewExposedApiTitle: "Create new Exposed API Credentials",
                editExposedApiTitle: "Edit Exposed API Credentials",
                newTab: "New",
                customHeaderNotAvailable: "Not available for the currently selected API",
                customHeadersErrorMapping: "Please map request and response parameters on custom header",
                errorApiResponse: "Please select Api response!",
                warningRequest: "Please add request parameters!",
                warningResponse: "Please add response parameters!",
                warningDefultPath: "Please specify a path",
                warningError: "Please add actions for errors",
                errRule: "Please add conditions",
                errRuleValues: "Please add values to your conditions",
                defaultPathsub: "Default path",
                custoRules: "Custom rules",
                errorsSub: "Errors",
                warningRequestResponse: "Please add request and response parameters!",
                configuration: "Configuration",
                testBtn: "Test",
                apiNotFound: "The mapped API (\"{name}\") couldn't be found!"
            },
            exposeApi: {
                titleModalActionRules: "Action Rule Editor",
                titleModalDefault: "Set default path",
                actionRulesCardTitle: "Action Rules",
                paths: "Available paths",
                requestSectionSubtitle: "Request",
                requestSectionTitle: "Define Request",
                noRequests: "No request defined",
                configuration: "Configuration",
                defineRequestModalTitle: "Define Request",
                continueLabel: "Continue",
                skipLabel: "Skip",
                backLabel: "Back",
                finishLabel: "Finish",
                defineValidationRules: "Define Validation Rules",
                rules: "Rules",
                addRules: "Add validation rules",
                addAction: "Add action rules",
                actionName: "Rule name",
                ruleHighlights: "Rule highlights",
                actionRulePath: "Action Rule Path",
                validationRuleEditor: "Validation Rule Editor",
                addBtn: "Add",
                updateBtn: "Update",
                setError: "Set Error",
                errorMessage: "Error message",
                error418: "I'm a teapot",
                error400: "Bad Request",
                error500: "Internal Server Error",
                default: "Default: ",
                search: "Search stage name",
                searchAPICredentials: "Search API Credentials",
                skipBtn: "Skip",
                configExpose: "Configure Expose API",
                finishStep: "Finish Step",
                API_PLUGINCODE: "CA",
                EXTERNAL_PLUGINCODE: "ET",
                GENERAL_END_PLUGINCODE: "GE",
                TASK_PLUGINCODE: "HT",
                APPROVAL_PLUGINCODE: "AM",
                DATA_EXPORT_PLUGINCODE: "DE",
                GENERATE_DOCUMENT_PLUGINCODE: "GD",
                EXPOSE_API_PLUGINCODE: "EA",
                BLOCKCHAIN_PLUGINCODE: "BC",
                JOIN_GATEWAY_PLUGINCODE: "JG",
                EXCLUSIVE_GATEWAY_PLUGINCODE: "EG",
                PARALLEL_GATEWAY_PLUGINCODE: "PG",
                PROCESS_PLUGINCODE: "PR",
                API_PLUGINNAME: "Call Api",
                EXTERNAL_PLUGINNAME: "External Task",
                GENERAL_END_PLUGINNAME: "End",
                TASK_PLUGINNAME: "Human task",
                APPROVAL_PLUGINNAME: "Decisions",
                DATA_EXPORT_PLUGINNAME: "Data Export",
                GENERATE_DOCUMENT_PLUGINNAME: "Generate Documents",
                EXPOSE_API_PLUGINNAME: "Expose Api",
                BLOCKCHAIN_PLUGINNAME: "Blockchain",
                JOIN_GATEWAY_PLUGINNAME: "Join Gateway",
                EXCLUSIVE_GATEWAY_PLUGINNAME: "Exclusive Gateway",
                PARALLEL_GATEWAY_PLUGINNAME: "Parallel Gateway",
                PROCESS_PLUGINNAME: "Process",
                errorType: "ERROR 400",
                errorType2: "ERROR 418",
                errorType3: "ERROR 500",
                addExposedClients: "Manage credentials",
                exposedClientsTitle: "Exposed API credentials",
                noClients: "There are no defined exposed API credentials. Please add credentials to enable access to it."
            },
            instanceName: {
                assignInstanceName: "Process instance name",
                customInstanceName: "Custom process instance name",
                errorMsg: "Process instance name contains invalid characters."
            },
            taskSubject: {
                assignTaskSubject: "Task subject",
                customTaskSubject: "Custom task subject",
                errorMsg: "Task subject contains invalid characters.",
                limitMsg: "The character limit has been exceeded"
            },
            setProcess: {
                setProcessLabel: "Select a process",
                noProcessLabel: "Processes",
                nothingDisplay: "Nothing to display",
                subtitle: "There are no elements in this list",
                addProcessBtn: "Add a process",
                syncProcess: "Execution mode:",
                syncProcessOpt: "Synchronous",
                asyncProcessOpt: "Asynchronous",
                syncInfoTooltip: "The master process awaits the completion of the selected process.",
                asyncInfoTooltip: "The master process doesn't wait for the selected process to complete.",
                publishedTooltip: "This process is published and up to date.",
                unpublishedTooltip: "This process is unpublished.",
                unpublishedChangesTooltip: "This process has unpublished changes.",
                archivingTooltip: "This process is archiving.",
                configDataLabel: "Configure inherited data",
                inheritedDataLabel: "Inherited data"
            },
            advancedLogic: {
                configureTitle: "Configure",
                configModalTitle: 'Configure "Advanced Logic"',
                editorTitle: "{name} editor",
                configured: "Configured",
                closeTitle: "Warning",
                closeMsg: "Are you sure you want to leave? You will lose all your changes!",
                deleteTitle: "Remove",
                deleteMsg: "The action will remove advanced logic configuration!",
                saveTitle: "Warning",
                saveMsg: "The script has errors. Are you sure you want to save?",
                successMsg: "Advanced Logic successfully configured.",
                emptyMsg: "Cannot save an empty script"
            },
            recurrence: {
                title: "Recurrence",
                description: "Configure",
                remove: "Delete",
                nextPublish: "Use next Publish date as activation date",
                activationDate: "Activation date",
                processStart: "Process start time",
                repeat: "Repeat every",
                endDate: "End date",
                Day: "Day",
                Week: "Week",
                Month: "Month",
                Year: "Year",
                Monday: "Monday",
                Tuesday: "Tuesday",
                Wednesday: "Wednesday",
                Thursday: "Thursday",
                Friday: "Friday",
                Saturday: "Saturday",
                Sunday: "Sunday",
                onDay: "On Day",
                onThe: "On The",
                First: "First",
                Second: "Second",
                Third: "Third",
                Fourth: "Fourth",
                Last: "Last",
                January: "January",
                February: "February",
                March: "March",
                April: "April",
                May: "May",
                June: "June",
                July: "July",
                August: "August",
                September: "September",
                October: "October",
                November: "November",
                December: "December",
                monthOf: "of",
                requiredField: "This field is required!",
                processTimeNotSet: "Process start time not set.",
                processOn: "Starts on ",
                publishDateOn: "next publish date, ",
                at: " at ",
                recurringEvery: ", recurring every ",
                recurring: ", recurring ",
                daily: "daily",
                days: "days",
                months: "months",
                weeks: "weeks",
                onTheDesc: " on the ",
                everyWeek: " of every ",
                endOn: ", ends on "
            },

            taskEmail: {
                assignTaskEmail: "Email subject",
                customTaskEmail: "Custom email ",
                subject: "Message subject",
                attachments: "Add attachment",
                dataAttachments: "Attachments",
                body: "Message body",
                variablesType: "VAR",
                dataModelType: "DML",
                variablesName: "Variables",
                dataModelName: "Data Model"
            },

            externalStart: {
                externalUrl: "App Url",
                addExternalClients: "Manage credentials",
                externalClients: "Exposed API credentials",
                addMapRequest: "Map request",
                externalDataModel: "Data model fields",
                availableClients: "Available API credentials",
                noClients: "There are no defined exposed API credentials. Please add credentials to enable access to it.",
                name: "Name",
                addNewClient: "Add new API credentials",
                mapRequest: "Map request",
                mapFields: "Map fields",
                defineRules: "Define Rules",
                configurationRequest: "Configuration",
                fieldsDefine: "Fields",
                dataFields: "Data",
                defineBtn: "Define",
                noMappedFields: "No required fields defined",
                continueBtn: "Continue",
                rulesTitle: "Rules",
                addRules: "Add rules",
                rulesEditor: "Rules Editor",
                setError: "Set Error",
                errorMessage: "Error message",
                error418: "I'm a teapot",
                error400: "Bad Request",
                error500: "Internal Server Error",
                errorCode418: "ERROR 418",
                errorCode400: "ERROR 400",
                errorCode500: "ERROR 500",
                backBtn: "Back",
                finishBtn: "Finish",
                mappedFields: " mapped fields",
                mappedField: " mapped field",
                rules: " rules",
                rule: " rule",
                addBtn: "Add",
                warningRemoveDataModelTitle: "This field is used in at least one rule. Please, check the rules that contain this field."
            },
            smsSubject: {
                assignSMSSubject: "Sms Subject",
                customSMSSubject: "Custom sms subject",
                body: "Message body"
            },
            messagingOptions: {
                messagingTitle: "Messaging Options",
                regularMessages: "Regular messaging",
                dynamicExternalTasks: "Dynamic external tasks",
                addRegularMessage: "Add message type",
                addDynamicMessage: "Add dynamic message type",
                noMessages: "You haven't added any messages, yet.",
                itemSubject: "Subject:",
                itemTo: "To:",
                actionDelete: "Delete",
                email: "EMAIL",
                sms: "SMS",
                dataModel: "DML",
                regularMsgType: "Regular",
                dynamicMsgType: "Dynamic",
                addNewMessage: {
                    regularMsgTitle: "New message type",
                    dynamicMsgTitle: "New dynamic external task",
                    editRegularMsgTitle: "Edit message type",
                    editDynamicMsgTitle: "Edit dynamic external task",
                    messageProp: "Message properties",
                    messageRecipients: "Message recipients",
                    tooltipInfo: "By choosing Email only option you might be exposing yourself to identity theft.",
                    messageName: "Message name",
                    emailOnly: "Email Only",
                    emailSms: "Email & SMS",
                    separateTask: "Create a separate task for each recipient",
                    notificationSettings: "Notification settings",
                    messageRecipient: "Message recipient (Not set)",
                    dynamicMsgRecipient: "Select datamodel class",
                    requiredMsgType: "Please select a message type!",
                    requiredMsgReceipient: "Please add Message Recipient",
                    requiredMsgName: "Please add Message Name!",
                    toRecipient: "TO: ",
                    emailTabName: "Notification",
                    smsTabName: "Authentication",
                    setMessageRecipient: {
                        title: "Set message recipient",
                        userInfo: "User Information",
                        selectSource: "Select Source",
                        dataModelLabel: "Data Model",
                        emailAdd: "Email address",
                        phoneNr: "Phone number",
                        txtType: "TXT",
                        dataModelType: "DML",
                        manualInput: "Manual Input",
                        dataModel: "Data Model",
                        emailAndPhoneRequired: "Please add email and phone number for your recipient",
                        phoneRequired: "Please add phone for your recipient",
                        dataModelRequired: "Please add a data model for your recipient",
                        validEmail: "Invalid email address!",
                        invalidPhone: "Invalid phone number!",
                        contentSmsAndEmail: "Please complete email and sms!",
                        contentEmail: "Please complete email body!"
                    }
                }
            },
            variablesCard: {
                insertSpecialIdentificator: "Insert special identificator",
                dataModel: "Data model",
                variables: "Variables",
                users: "Assignees",
                searchUsers: "Search users",
                freeText: "Text",
                dataText: "Data model text",
                email: "Email",
                phone: "Phone",
                list: "List",
                errEmail: "Enter an email address",
                errPhone: "Enter a phone number",
                listOf: "List of",
                addNew: "Add new"
            },
            setTarget: {
                newTarget: "Add new target",
                targetElement: "Select target element",
                targetLabel: "Target",
                outcomeProcessLabel: "Outcome from previous process",
                connectorProperties: "Connector properties",
                untitledConnector: "Untitled connector",
                addNotifications: "Add notification",
                notifications: "Notifications",
                to: "To",
                more: "more",
                subj: "Subject",
                body: "Body",
                trigger: "Trigger",
                noLabelConnector: " connector label missing",
                noProcessSelected: "No process selected in the {processName} process activity",
                noEndpointAvailable: "No endpoints available for selection",
                allEndpointsSelected: "All the endpoints are already selected on other connectors",
                submissionSettings: "Task submission settings",
                preselect: "Preselect the first option",
                submissionCommentBehavior: "Task submission comment behavior",
                optionalComment: "Optional",
                requiredComment: "Required",
                hideComment: "Hide comment box",
                noConnectors: "No connectors available yet",
                defaultTooltip: "The Task submission option list will show the order of targets if there is more than one"
            },
            setUsers: {
                users: "Assignees",
                assignUser: "Add Assignee"
            },
            generateDocuments: {
                configDocuments: "Assign Template",
                documentSettings: "Document template settings",
                generateModalTitle: "Assign template",
                editgenerateModalTitle: "Edit template",
                documentLabel: "Document template",
                docExtension: "Generated document extension",
                dataModelLabel: "Data model field",
                addRow: "Add",
                headerAction: "Delete",
                dupDocError: "You already mapped this data model field to a document template.",
                fileName: "Custom document name"
            },
            notifications: {
                notifications: "Notifications",
                notificationProperties: "Notification properties",
                notificationType: "Notification type",
                notificationName: "Notification Name",
                setup: "Notification setup",
                send: "Send notification",
                email: "Email",
                sms: "SMS",
                addRecipients: "Recipients",
                cc: "cc",
                bcc: "bcc",
                subject: "Subject",
                notificationBody: "Notification body",
                templates: "Templates",
                attachments: "Attachments",
                collapse: "Collapse",
                notificationTargetRequired: "Please add a target for your notification",
                messageRequired: "Please add a message for your notification",
                subjectRequired: "Please add a subject for your notification",
                characters: "characters",
                mandatory: "Mandatory",
                nameError: "Notification name is mandatory",
                trigger: "Trigger",
                when: "When",
                after: "After",
                before: "Before",
                on: "On",
                taskEvent: "Task Event",
                timeframe: "Timeframe",
                expiration: "Expiration",
                deadline: "Deadline",
                creation: "Creation",
                completion: "Completion",
                repeat: "Repeat notification",
                repeatEvery: "Repeat every",
                until: "until the task is completed.",
                noNullValues: "Do not insert empty values",
                validFormat: "Valid values are: 3d 7h 30m",
                daysLabel: " day(s)",
                hoursLabel: " hour(s)",
                minsLabel: " minute(s)",
                andLabel: " and ",
                notConfigured: "Notification not configured.",
                starts: "Starts",
                repeating: ", repeating every",
                markedCompleted: "until the task is marked as completed.",
                placeholderTimeframe: "Eg: 4d 2h",
                createNew: "Create new notification"
            },
            exclusiveGate: {
                name: "Name",
                code: "Code",

                description: "Description",
                rules: "Configure Rules",
                activityMessage: "Please add actions to activity first",
                order: "Order",
                activity: "Activity",
                condition: "Condition",
                exception: "Exception",
                up: "Up",
                down: "Down"
            },
            conditionalBlock: {
                modalTitle: "Conditional block settings",
                deleteBlock: "Remove block",
                deleteBlockTitle: "Delete block {name}",
                errorBlockName: "Please fill in a name for the conditional block",
                deleteBlockMessage:
                    "By deleting the conditional block, you will remove the block itself only, not its contents too. Any rule saved here will be deleted also."
            },
            richTextBlock: {
                modalTitle: "Interface content settings"
            },
            repeatableBlock: {
                modalTitle: "Repeatable block settings",
                addListAttribute: "Add list attribute",
                errorBlockName: "Please fill in a name for the repeatable block",
                customSorting: "Custom sorting",
                sortListLabel: "Sort list values",
                sortBy: "by",
                sortPlaceholder: "Select value",
                selectAttributeTitle: "Select attribute",
                filtersTitle: "Filters",
                sortAttrMandatory: "The attribute is required to perform sorting",
                changeDeleteListWarnTitle: "Change the existing list attribute",
                changeDeleteListWarnBody:
                    "Changing it leaves the previously contained list attributes unlinked and they will need to be manually removed from the repeatable block.",
                continueBtn: "Continue",
                configureInfo: "The current block cannot be configured before the parent block"
            },
            ruleTesting: {
                importedData: "Data imported from:",
                existingInstances: "Existing process instances",
                rule: "rule",
                rules: "rules",
                statement: "Statement:",
                condition: "Condition",
                level: "level",
                levels: "levels",
                title: "Test outcome",
                sideBarTitle: "Rule testing",
                sideBarCardTitle: "Selected diagram component",
                sideBarTestBtn: "Test",
                sideBarTestAgainBtn: "Test again",
                sideBarGetInstanceBtn: "Get process instance data",
                sideBarLevels: "levels",
                testAllLevels: "Test all levels",
                testAllRules: "Test all rules",
                copy: "Copy",
                paste: "Paste",
                copyMessage: "Values have been successfully copied",
                successPaste: " values have been successfully matched",
                noMatchPaste: "No values have been matched"
            },
            importConditions: {
                importConditionsSubTitle: "Rules to import conditions",
                importConditionsTitle: "Import Conditions",
                activities: "Activities",
                condition: "condition",
                conditions: "conditions",
                level: "Level",
                search: "Search activity"
            },
            exclusiveGateway: "Exclusive Gateway",
            setRules: {
                ruleEditor: "Rule editor",
                addRule: "Add rule",
                ruleHighlights: "Rule highlights",
                name: "Rule name",
                description: "Rule description",
                ruleName: "Rule name",
                ruleNameRequired: "Please add a name for your rule",
                conditionsRequired: "Please add at least one condition for your rule",
                syntaxError: "Your conditions generate a syntax error. You need to fix it first",
                outcomesRequired: "Please add at least one outcome for your rule",
                targetsRequired: "You must set one or more assignees to continue",
                targetsAndRightRequired: 'You must set one or more members and at least one "Approver" role',
                delete: "Delete",
                update: "Update",
                warning: "Warning",
                warningMessage: "Are you sure you want to leave? You will lose all your changes!",
                validCondition: "Please make sure that the condition is valid"
            },
            setConditions: {
                importConditions: "Import conditions",
                conditions: "Conditions",
                statement: "Statement",
                addCondition: "Add new condition",
                equals: "Equals",
                notEquals: "Not equals",
                greater: "Greater than",
                greaterOrEqual: "Greater or equal than",
                less: "Less than",
                lessOrEqual: "Less or equal than",
                is: "Is",
                not: "Not",
                isNot: "Is not",
                group: "Group",
                addValue: "Add value",
                selectValue: "Select value..."
            },
            // targets last tab assign for users
            ruleOutcomes: {
                outcomes: "Outcomes",
                roles: "Assignees",
                notifications: "Notifications",
                taskDetails: "Task details",
                usersInfo: "Set one or more assignees that will receive this task once the conditions above are met",
                initialAssignees: "Initial assignees",
                newAssignees: "Add Assignee",
                newUserGroup: "New assign group",
                addMembers: "Add members",
                decisionGroup: "Decision Group",
                addDecisionGroup: "Add decision group",
                levelTaskDetails: "You can update the behaviour of the level",
                initialValues: "Initial assignees ",
                newValues: "New assignees",
                notificationsInfo: "Update the Notifications to notify one or more users once the conditions above are met",
                tasks: "Tasks",
                role: "Role",
                decisionType: "Decision type",
                prolonger: "Prolonger",
                approveBtn: "Approver",
                evaluateBtn: "Evaluator",
                overrideBtn: "Overrider",
                singular: "Singular",
                group: "Group",
                approversNumber: "Number of approvers",
                setApproversNumber: "Set a value",
                singularTooltip: "Any of the group members can decide on behalf of the group.",
                groupTooltip: "Multiple group members need to approve the task. Once the required number is reached the system continues the approval process.",
                approverTooltip: "Has decisional power; they are, however, below Overriders; at least one Approver is necessary to be configured on a Level.",
                evaluatorTooltip:
                    "Has consultative power; its aim is to help Approvers and Overriders reach a decision; the approval cannot be configured only with Evaluators on a Level",
                overriderTooltip:
                    "Has highest power; their decision overrides any decision taken by any other approvers; the approval cannot be configured only with Overriders on a Level",
                requires: "Requires",
                approvals: "approvals",
                noApprovalsError: "Must have at least one approval",
                noApprovalsDMError: "Must have one attribute selected",
                integerError: "The value must be a number greater than 0"
            },
            setLevels: {
                level: "Level",
                name: "Name",
                addLevel: "Add another level",
                levelEditor: "Level editor",
                levelSettings: "Level settings",
                rules: "Rules",
                conditionalRules: "Conditional notification rules",
                levelHighlights: "Level highlights",
                delete: "Delete",
                selectBehaviour: "Select Behaviour"
            },
            approvalTime: "Time to expiration",
            timeUnit: "Unit",
            continueIfRejected: "Continue to next level if rejected",
            ifExpires: {
                ifExpires: "Expiration behaviour",
                autoReject: "Auto-reject",
                autoApprove: "Auto-approve",
                propagatePreviousDecision: "Propagate previous decision"
            },
            setBlockchain: {
                assignFunction: "Assign function",
                assignedFunction: "Assigned function",
                selectFunction: "Function",
                eventTitleModal: "Configure Blockchain Event",
                inParameters: "In params",
                outParameters: "Out params",
                configEvent: "Configure Blockchain Event",
                mesWarning: "Blockchain event must be connected to either a Decisions activity or to an Exclusive Gateway",
                configureBlockchain: "Configure Blockchain",
                startFromBkActivity: "Start from Blockchain Event"
            }
        }
    },
    smartContract: {
        duplicateScName: "There is already a contract named {name}",
        scNameValidation: "Special characters are not allowed in smart contract name",
        newScTitle: "Use a template your smart contract",
        newScDescription: "You can create a smart contract from an existing template that you can easily configure.Contrary to popular belief, Lorem.",
        startFromScratch: "Start from scratch",
        useTemplate: "Use a template",
        removeTitle: "Delete Parameter",
        removeEvent: "Delete Event",
        removeTitleFunction: "Delete Function",
        dialogBodyDefaultFunction: "Are you sure you want to delete function ? You will no longer be able to use this function in the future",
        dialogBodyDefaultEvent: "Are you sure you want to delete event ? You will no longer be able to use this event in the future",
        deleteSmartContract: "Are you sure you want to delete",
        deleteSmartContract2: "You will no longer be able to use this Smart Contract in the future.",
        dialogBodyDefault: "Are you sure you want to delete variable? You will no longer be able to use this paramater in the future.",
        deleteParamEventConstraint: "At least one parameter is required!",
        cancel: "Cancel",
        remove: "Delete",
        uiTitle: "Blockchain",
        createBtn: "Create",
        importBtn: "Import",
        ethType: "Etherum",
        uiSubtitle: "Learn more about Blockchain",
        scListTitle: "Blockchain",
        scListSubtitle: "Learn more about blockchain",
        scTitle: "smart contracts",
        scNetwork: "Network",
        scCredentials: "Credentials",
        titleDetails: "Function Details",
        eventsTitleDetails: "Events Details",
        subscriptionType: "Subscription Type",
        onDemand: "On Demand Subscription",
        continous: "Continous Subscription",
        addBtn: "Add",
        editBtn: "Save",
        scAddress: "Address",
        scAddressInfo: "The address will be populated after the smart contract is published",
        scPlaceholderText: "You don't have any Smart Contracts yet.",
        scPlaceholderTextSmall: "Create a smart contract using <b>Create Smart Contract</b> button",
        unpublishedChanges: "UNPUBLISHED CHANGES",
        functions: "Functions",
        events: "Events",
        newContract: "Create new",
        newEvent: "Create Event",
        editContract: "Edit Smart Contract",
        importContract: "Import Smart Contract",
        scDetails: "Smart Contract Details",
        scName: "Smart Contract Name*",
        scDescription: "Description",
        scType: "Type",
        newFunction: "Create Function",
        editFunctionTitle: "Edit Function",
        editEvent: "Edit Event",
        editFunction: "Edit",
        loadMore: "Load more",
        previewFunction: "Preview Function Code",
        deleteFunction: "Delete Function",
        deleteEvent: "Delete Event",
        noFuncDescription: "No description",
        confirmationDialog: {
            agree: "Agree",
            disagree: "Disagree",
            msg: "Are you sure you want to leave? You will lose all your changes!",
            msg2: "Are you sure you want to leave? Any unsaved data will be lost",
            title: "Confirm"
        },
        appendVariable: "Append Variable",
        appendVarComponent: {
            noVar: "No Variables Available"
        },
        ifHandler: {
            expression: "Expression"
        },
        forHandler: {
            noNumericVars: "No integer variables were found declared!",
            increasing: "Increasing",
            decreasing: "Decreasing",
            variable: "Variable",
            startValue: "Start Value",
            endValue: "End Value",
            stepBy: "Step By",
            direction: "Direction"
        },
        assignHandler: {
            noFunctionsAvailable: "<b>You don't have any functions.</b>",
            noEventsAvailable: "<b>You don't have any events.</b>",
            createAnEvent: "Create an event using <b>Create Event</b> button",
            createAFunction: "Create a function using <b>Create Function</b> button",
            parameter: "Parameter",
            parameters: "Parameters",
            function: "Function",
            noParams: "This function does not expect any parameters!",
            isFunctionCall: "Function Call",
            description: "Description",
            assignment: "Assignment",
            variable: "Variable",
            value: "Value",
            add: "Add Assignment",
            delete: "Delete Assignment",
            custom: "Custom Code",
            condition: "Condition"
        },
        declareHandler: {
            size: "Array Size",
            blockchainRead: "Blockchain Read"
        },
        parameters: {
            variable: "Variable Name*",
            addParam: "Add Parameter",
            editParams: "Edit Parameter",
            title: "Parameters",
            description: "Description",
            isArray: "Is Array",
            isIndexable: "Is Indexable",
            nothingToDisplay: "Nothing to display"
        },
        callHandler: {
            detailsTab: "Details",
            description: "Description",
            selectContract: "Select Smart Contract",
            selectFunction: "Select Function",
            configureCallFunction: "Configure Call Function ",
            title: "Call Function",
            save: "Save",
            noVar: "No variable",
            saveWarning: "Please map all request parameters to save the configuration"
        },
        emitEventHandler: {
            selectEvent: "Select Event",
            configureEmitEvent: "Configure Emit Event",
            title: "Emit Event",
            eventParams: "Event Parameters"
        },
        declare: {
            declaration: "Declaration",
            addNewDeclaration: "Add Declaration",
            isArray: "Is Array?",
            variableName: "Variable Name",
            variableType: "Variable Type"
        },
        returnVars: {
            addReturns: "Add Return Variable",
            editParams: "Edit Return Variable",
            title: "Return Variables"
        },
        callFunction: {
            search: "Search for function parameters",
            functionParams: "Function Parameters",
            declareVar: "Declared Variables",
            systemVar: "System variable",
            noParams: "NO PARAMETER DEFINED",
            request: "Request",
            response: "Response",
            config: "Configuration"
        },
        main: {
            element: "Element",
            noFunctionElementsYet: "No function elements added yet!",
            functionElements: "Function Elements",
            functionActions: "Function Actions",
            selectFunction: "Select Function",
            editFunction: "Edit Function",
            inEditFunctionIs: "Currently editing function: ",
            noFunctionSelectedForEdit: "No function selected for edit!",
            clickManageFunctions: "Click 'Manage Functions' to select a function for edit!",
            noFunctionSelected: "Please select a function for edit first!",
            noFunctionsMain: "Please create a function and enter edit mode for that function.",
            deleteFunction: "Delete Function",
            editFunctionBody: "Edit Function Body",
            variableName: "Variable Name",
            functionsTitle: "Functions",
            addFunction: "Create Function",
            variableType: "Variable Type*",
            isArray: "Is Array",
            function: "Function",
            funcName: "Function Name*",
            eventName: "Event Name*",
            funcNameErr: "Function name is required!",
            description: "Description",
            isExposed: "Public",
            isSubscribed: "Subscribed",
            previewFunctionCode: "Preview Function Code",
            manageFunc: "Manage Functions",
            noFunctions: "There are no functions declared for this application!",
            addAFunc: "Add a function",
            diagramError: "Please add a Start, an End and at least one process block",
            diagramErrorTitle: "Errors",
            sameNameParametersError:
                "This function has the same parameters as an existing function. The parameters configuration must be unique. Please, change your data"
        },

        manageFunctions: {
            functionDetails: "Details",
            functionParameters: "Parameters",
            functionReturn: "Return Variables",
            noNameError: "Name can not be empty and it should not start with a number, contain spaces or special characters.",
            functionDuplicateName: "This function name already exists!",
            duplicateParams: "There are 2 parameters with the same name",
            varTypeNull: "Please select a type for the function parameters"
        },
        pluginDescription: {
            name: "Object properties",
            noPluginSelected: "There are no objects selected. Choose one from the left sidebar to find out more about its properties",
            noneSelected: "None"
        },
        useTemplateSC: {
            select: "Template selection",
            config: "Template configuration",
            details: "Contract details",
            titleSelect: "Select your template",
            descriptionSelect: "You can add one or more properties for your smart contract. Please, note that you will need to configure them.",
            selectBtn: "Select Template",
            back: "Back",
            titleDetails: "Smart Contract Details",
            descriptionDetails: "Configure basic details for your new smart contract.",
            finalStep: "Finish configuration",
            wallet: "You can add a wallet identifier for your template.",
            walletIdentifier: "Wallet Identifier",
            saveChanges: "Save Changes",
            proceedToDetails: "Proceed to details",
            notConfig: "Not configured",
            optionalValues: "The values in this card are optional",
            titleDialog: "Confirm",
            messageDialog: "Are you sure you want to leave? You will lose all your changes"
        },
        createFromScratch: {
            btnCreate: "Create"
        }
    },
    documents: {
        addSelect: "ADD/SELECT",
        addSelectWarn: "Are you sure you want to Select or Add a new document? All your unsaved changes will be discarded.",
        save: "SAVE",
        select: "SELECT",
        titleModal: "Documents",
        deleteDocumentTitle: "Delete Document Template",
        deleteWarn: "Are you sure you want to delete ",
        documentBuilder: "Document Templates",
        noDocuments: "Woah! No documents",
        deleteTitle: "Woah! Are you sure you want to delete this item?",
        deleteBody: "This action cannot be undone. The current information is currently in use and removing it will cause the following systems to stop:",
        uploadedBy: "Uploaded by",
        on: "on",
        preview: "Preview",
        download: "Download",
        delete: "Delete",
        rename: "Rename",
        selectAll: "Select All",
        selectNewModalHeader: "Select an existing Document or create new",
        selectDocLabel: "Select an existing document",
        createNewDocLabel: "Create new document",
        saveDocModalHeader: "Save Document",
        uniqueName: "Document template name must be unique",
        wrnMessage: "By leaving this page you are going to lose your changes!",
        draftMessage: "If you add a new document template without saving the current one, all your changes will be lost. Are you sure you want to continue?",
        leaveBtn: "Leave",
        cancelBtn: "Cancel",
        wrnTitle: "Warning",
        imageTooLargeError: "Image size too large, maximum 10MB",
        addDocument: "Create new",
        emptyDocuments: "There are no documents in the list.",
        successDelete: "The document template was removed.",
        alreadyDeleted: "Document template was deleted by another user.",
        listUpdate: "The list of document templates has changed",
        updated: "has been updated",
        renamed: "has been renamed",
        deleteBy: "has been deleted by",
        documentUpdateToast: "has been updated. To see the latest version please refresh the page.",
        refresh: "Update",
        maxLengthNameErr: "Please use maximum 400 characters!",
        untitledDoc: "Untitled document template",
        noDocsAvailable: "No documents available yet",
        noDisplayDocsDesc: "Choose your new action based on your needs.",
        deleteMessageDialog: "{docNam} will be permanently deleted. Are you sure?",
        deleteConfirmation: "{type} successfully deleted",
        deletedDocument: "Document template was deleted",
        renamedSuccessfully: "The document has been successfully renamed.",
        cantBeRenamed: "The Document Template is being edited by {user} and cannot be renamed.",
        sameNameDocument: "Document Template name must be unique.",
        docs: "document template | document templates",
        results: "result | results"
    },
    userProfile: {
        title: "User details",
        settings: "Settings",
        notif: "Notifications",
        username: "Username",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        phone: "Phone",
        phoneNumber: "Phone Number",
        roles: "Roles assigned to me:",
        position: "Position",
        manager: "Manager",
        allowAccessibility: "(The feature is disabled by Administrator)",
        allowAdminAccessibility: "(Relog in order to have access to the enhanced contrast option)",
        language: "Select Language",
        en: "English",
        ro: "Romanian",
        taskToMe: "Notify me each time I am assigned a task",
        taskToTeam: "Notify me each time a task is assigned to a role I am in",
        diagramNotif1: "Notify me each time an application I own is run",
        diagramNotif2: "Notify me each time a diagram I worked on is modified",
        interfNotif1: "Notify me each time a user interface is added",
        interfNotif2: "Notify me each time a user interface I have worked on is modified",
        notifTypeEmail: "Via email at",
        notifTypeSms: "Via SMS at ",
        notifTypeApp: "Regular in-app notifications",
        password: "Password",
        department: "Department",
        changePassword: "Change Password",
        oldPass: "Old password",
        newPass: "New password",
        enterOldPass: "Old password is required",
        oldPassNoMatch: "Passwords don't match.",
        confirmPass: "Confirm new password",
        minLengthErr: "Please enter a password with at least 6 characters",
        alphaNumErr: "Password must be at least 6 characters in length and must contain a minimum of 1 upper case letter and 1 special character",
        sameAsErr: "Passwords don't match!",
        samePassword: "Password already in use for this account. Please choose another password.",
        reportsTo: "Reports to",
        taskNotif: "Task-related notifications",
        diagramNotif: "Diagram-related notifications",
        interfaceNotif: "Interface-related notifications",
        notifType: "Notification type",
        changeInfo: "Change information",
        passwordNeverUpdated: "Never changed",
        lastPasswordUpdateOn: "Last update on {date}",
        emptyPhone: "Phone number is mandatory",
        myAccountSideNav: {
            myAccount: "My account",
            usrDet: "User details",
            notif: "Notifications",
            roles: "Groups",
            othSettings: "Other settings",
            taskDelegation: "Task Delegation",
            blockchainWallet: "Blockchain Wallets"
        },
        changePassCode: {
            title: "Validate your phone,",
            label: "Access code",
            button: "Continue",
            validSuccess: "Phone number validated successfully",
            validPass: "Password changed successfully"
        },
        tasksDelegation: {
            pageTitle: "Task Delegation",
            subtitle: "My delegation",
            helperText: "Configure and view your delegation",
            delegateButton: "Create delegation",
            editButton: "Edit",
            cancelButton: "Cancel",
            cancelDelegationTitle: "Cancel delegation",
            cancelDelegationBody: "Are you sure that you want to cancel the delegation of tasks to {delegatedUser} between {startDate} and {endDate} ?",
            cancelDelegationStartedBody: "Your delegation to {delegatedUser} started on {startDate}. Are you sure you want to cancel the delegation?",
            sureButtonCancel: "Yes, I am sure",
            noDelegation: "You don't have an active delegation yet",
            receivedText: "Delegations received from other users",
            receivedHelperText: "Delegations you receive will be shown here",
            from: "From ",
            to: "To",
            between: "Between ",
            and: "and",
            rejectButton: "Reject",
            acceptButton: "Accept",
            accepted: "Accepted",
            pending: "Pending",
            rejected: "Rejected",
            successfullyAccepted: "The delegation has been successfully accepted",
            rejectDelegationTitle: "Reject delegation from {user}",
            rejectDelegationMessage: "Are you sure you want to reject the delegation request?"
        },
        delegationModal: {
            newDelegationTitle: "New Delegation",
            editDelegationTitle: "Edit Delegation",
            createBtn: "Create",
            saveBtn: "Save",
            period: "Period",
            recipient: "Recipient",
            availableTasks: "Available tasks",
            startDate: "Start date",
            endDate: "End date",
            startDateError: "Start date is required",
            endDateError: "End date is required",
            unsavedChangesTitle: "Unsaved changes",
            unsavedChangesBody: "If you leave this page, any changes you have made will be lost. Are you sure you want to return to Task delegation page?",
            leaveButton: "Leave",
            availableTasksInfo: "Choose what happens with your currently available tasks from your “To do” list ",
            delegateThem: "Delegate them",
            keepThem: "Keep them",
            recipientInfo: "The recipient, or delegatee, will receive all your incoming tasks during your delegation period",
            requiredEmail: "Insert a delegatee",
            currentUserError: "You cannot delegate tasks to yourself",
            emailInputLabel: "Email address",
            delegationCreated: "Your delegation has been successfully created",
            delegationEdited: "Your delegation has been successfully updated",
            delegationCanceled: "Your delegation has been successfully canceled",
            readonlyTooltip: "Cannot be edited after a delegation was accepted"
        },
        currentlyPartOfNRoles: "I'm currently part of {n} roles:",
        roleUsers: "0 users | 1 user | {count} users",
        roleApplications: "0 applications | 1 application | {count} applications",
        uploadedProfileImageSizeError: "Uploaded image is too large. Maximum allowed size is {maxSize}",
        uploadedProfileImageTypeError: "Uploaded image should be JPG, SVG or PNG"
    },
    historyPLV: {
        id: "Instance ID",
        name: "Instance Name",
        status: "Status",
        actions: "Actions",
        deadline: "Deadline",
        users: "Users",
        finished: "Finished processes",
        active: "Active processes"
    },
    dashboard: {
        sidebarTitle: "My dashboards",
        myDashboard: "My Dashboard",
        myTeamDashboard: "Team Dashboard",
        week: "Week",
        month: "Month",
        year: "Year",
        compareWith: "Compare with",
        productivity: "Task productivity",
        infomationComparedToLastWeek: "compared to last week",
        informationAboutYestarday: "tasks completed yesterday",
        chartGroupTitle: "Your users and group",
        chartGroupInstruction:
            "Compare a Group to a User or 2 Users to each other. Use the left click to select the first user or group and the right click to select the second.",
        tasks: "Tasks",
        containerTasksTitle: "My Tasks",
        title: "Dashboards",
        myDashTitle: "My Dashboard",
        start: "Start",
        applications: "applications",
        editApp: "Edit app",
        application: "Application",
        period: "Interval",
        tasksOverview: "Tasks status overview",
        allApps: "All applications",
        charts: {
            januaryShort: "Jan",
            februaryShort: "Feb",
            marchShort: "Mar",
            aprilShort: "Apr",
            mayShort: "May",
            juneShort: "Jun",
            julyShort: "Jul",
            augustShort: "Aug",
            septemberShort: "Sep",
            octoberShort: "Oct",
            novemberShort: "Nov",
            decemberShort: "Dec",
            mondayShort: "Mon",
            tuesdayShort: "Tue",
            wednesdayShort: "Wed",
            thursdayShort: "Thu",
            fridayShort: "Fri",
            saturdayShort: "Sat",
            sundayShort: "Sun",
            day: "Day",
            week: "Week",
            week1: "Week 1",
            week2: "Week 2",
            week3: "Week 3",
            week4: "Week 4",
            week5: "Week 5",
            week6: "Week 6",
            twoWeeks: "2 Weeks",
            lastWeek: "Last Week",
            lastTwoWeeks: "Last Two Weeks",
            twoWeeksAgo: "Two Weeks Ago",
            threeWeeksAgo: "Three Weeks Ago",
            lastMonth: "Last Month",
            twoMonthsAgo: "Two Months Ago",
            threeMonthsAgo: "Three Months Ago",
            lastQuarter: "Last Quarter",
            lastSemester: "Last Semester",
            lastYear: "Last Year",
            month: "Month",
            quarter: "Quarter",
            semester: "Semester",
            year: "Year",
            onTrack: "On time",
            attentionState: "In attention",
            warningState: "In warning",
            exceededDeadline: "Exceeded",
            yesterday: "Yesterday"
        },
        tasksPriority: "Tasks priority",
        opened: "Opened",
        onTrack: "On time",
        totalTasks: "Total tasks",
        attentionState: "In attention state",
        warningState: "In warning state",
        exceededDeadline: "Overdue",
        display: "Display",
        allTasks: "All tasks",
        timeToDeadline: "Time to deadline:",
        status: "Status:",
        total: "Total",
        reports: "Analytics",
        selectAttributes: "Select attributes",
        select: "Select",
        stringErrorMessage: "Only a-z, 0-9, and space are accepted",
        integerErrorMessage: "Only integer values accepted",
        decimalErrorMessage: "Only decimal values accepted",
        usedFilterTitle: "Filter used: ",
        instanceStatus: "Process instance status",
        savedFilters: "Saved filters",
        yourFilters: "Your filters",
        bulkDelete: "Bulk delete",
        selectAll: "Select all {count} filters",
        filterDeleteText:
            "This action will delete your filter forever. It cannot be undone. | This action will delete your filters forever. It cannot be undone.",
        filterDeleteTitle: "Delete saved filter | Delete saved filters",
        filterSavedMessage: "Filter saved successfully",
        filterFavoriteMessage: "The filter has successfully been marked as favorite",
        filterUnfavoriteMessage: "The filter has successfully been unmarked ",
        emptyNameFilter: "Please type a name for your filter",
        duplicateName: "This filter name is already used.",
        filterName: "Filter name",
        nrOfGroups: "1 group | {count} groups",
        nrOfUsers: "1 user | {count} users",
        showSelected: "{count} selected",
        lowPriority: "Low Priority",
        mediumPriority: "Medium Priority",
        highPriority: "High Priority",
        latestApps: "Applications",
        customize: "Customize Dashboard",
        applications_name: "Applications",
        tasks_name: "Tasks",
        overview_name: "Task overview",
        tasklist_name: "Tasklist",
        productivity_name: "Productivity",
        applyToThis: "Apply only to this dashboard",
        applyToAll: "Apply to all existing team dashboards",
        sections: "Sections",
        settings: "Settings",
        editDashboard: "Edit dashboard",
        atLeastOneSection: "At least one section must be active at all times",
        atLeastOneSubsection: "At least one subsection must be active at all times"
    },
    reports: {
        favoritesFilters: "Favorite filters",
        favorites: "Favorites",
        viewAllFilters: "View all filters",
        noFavFilters: "You don't have any favorite filters yet",
        allActivities: "All activities",
        unclaimTitle: "Unclaim | Bulk unclaim",
        reassignTitle: "Reassign | Bulk reassign",
        unclaimMessage: "Do you wish to unclaim your selected task? | Do you wish to bulk unclaim your selected tasks?",
        reassingMessage: "Do you wish to reassign your selected task? | Do you wish to bulk reassign your selected tasks?",
        bulkCountReassign: "Reassign ({count})",
        bulkCountUnclaim: "Unclaim ({count})",
        copyFilterInfo: "Copy filter link",
        copyInfo: "Copy link",
        succesCopyFilter: "Filter copied",
        filterSaved: "Filter saved successfully",
        shareFilter: "Share filter",
        share: "Share",
        directLink: "Direct link",
        noUsersSelected: "No users selected",
        usersSelected: "{count} user selected | {count} users selected",
        saveFilterMessage: "The {count} filter has been successfully shared",
        savedFiltersInfo: "Saved filters",
        resetColumnInfo: "Reset column layout to default",
        saveLaterUser: "Save filter for later use",
        addFiltersDM: "Add filters from data model",
        addColumnsDM: "Add columns from data model",
        filterFavInfo: "Mark filter as favorite",
        applyFilterInfo: "Apply filter",
        shareFilterInfo: "Share filter by email",
        deleteFilterInfo: "Delete",
        noFiltersList: "Saved filters can be accessed in this area.",
        emptyListFilters: "No saved filters yet",
        noProcessesTitle: "No processes yet",
        noProcessesDescription: "Here you will find any processes created and published in the future.",
        selectProcessTitle: "Select a process to continue",
        selectProcessDescription: "View process live view here",
        noProcessesYet: "No processes available yet",
        reportsTxt: "process | processes",
        caseSearchTxt: "data view | data views"
    },
    pluginFileManager: {
        uploadFile: "Upload a file",
        selectDataModel: "Select from Data Model",
        imageSourse: "Select image source"
    },
    pluginFabricImage: {
        labelClass: "Class",
        labelSource: "Source",
        imageDescription: "Image description",
        imageTitle: "Image Title",
        imageDimensions: "Dimensions",
        imageWidth: "Width",
        imageDimensionsOperator: "x",
        imageHeight: "Height",
        imageConstrainProp: "Constrain proportions",
        imageCaption: "Caption",
        advancedTabs: "Insert/edit image",
        bodyGeneral: "General",
        bodyAdvanced: "Advanced",
        bodyStyle: "Style",
        styleVerticalspace: "Vertical space",
        styleHorizontalspace: "Horizontal space",
        styleBorder: "Border",
        titleDefaultDialog: "Insert/edit image",
        tooltipImageButton: "Insert/edit image",
        textImageMenu: "Image"
    },
    pluginPageSetup: {
        documentProperties: "Document properties",
        labelPageSize: "Page size",
        labelPageSizeA4: "A4",
        labelPageSizeA3: "A3"
    },
    setLabel: {
        untitledPlugin: "Untitled Plugin",
        untitledConnector: "Untitled connector"
    },
    liveView: {
        leftSideBar: {
            titlePLV: "Live view",
            infoPLV: "Learn more about tasks and applications",
            itemTasks: "Process Live View",
            itemStatistics: "Process Statistics"
        },
        filters: {
            dml: "DML",
            completion: "Completion:",
            title: "Filters",
            viewBtn: "View",
            noFiltersMsg: "No filters applied",
            nrOfFiltersApplied: " filters applied",
            itemsFound: " items found",
            taskStatus: "Task status",
            allStst: "All statuses",
            dataModel: "Data model",
            addStatment: "Add new statement",
            verifyApp: "Select one application to continue",
            onTime: "On time",
            attn: "Attention",
            wrng: "Warning",
            overdue: "Overdue",
            creationDate: "Creation date",
            taskPriorityTitle: "Task priority",
            allPriorities: "All priorities",
            lowest: "Lowest",
            low: "Low",
            normal: "Normal",
            high: "High",
            highest: "Highest",
            completionSts: "Completion status",
            date: "Date",
            fromDate: "From",
            toDate: "To",
            allTsks: "All tasks",
            openTask: "Open",
            completedTasks: "Completed",
            usersAndRoles: "Users and Roles",
            noUsersSel: "No users selected",
            usersSel: " users selected",
            noGroupsSel: "No groups selected",
            groupsSel: " groups selected",
            noResultsFound: "No results found",
            addBtn: "Add",
            conditionTitle: "Condition",
            statement: "Statement",
            dataModelSearch: "Search (min 3 chars)",
            dataModelCollapsTitle: "Data Model Classes",
            catalogsCollapsTitle: "Catalogs",
            apiTitle: "APIs",
            variablesTitle: "Variables",
            dataModelOperators: {
                equals: "Equals",
                contains: "Contains",
                notEquals: "Not equals",
                greater: "Greater than",
                greaterOrEqual: "Greater or equal than",
                less: "Less than",
                lessOrEqual: "Less or equal than",
                true: "True",
                false: "False"
            },
            validations: {
                noProperty: "Please select a property from Data Model",
                noStatement: "The Statement should contain only letters and numbers"
            },
            export: {
                exportResults: "Export Results",
                exportBtn: "Export",
                toastMsg: "The Export request has been sent. Once the action is completed, you will receive an email notification.",
                err409: "You already have an ongoing export in progress for this application!",
                err400: "At least one data model field must be selected!",
                err5001: "Internal server error",
                err500: "No task data is available",
                err404: "Not found",
                errorGen: "Something went wrong, try again later."
            }
        },
        taskDetails: {
            search: "Search for...",
            searchForTask: "Search for a task...",
            searchForInstance: "Search for a process instance...",
            activitiesCollapsibleLabel: "Activities",
            endpointsCollapsibleLabel: "Endpoints",
            tasksFilterSearchBtn: " filters applied",
            searchForTaskAndInstance: "Search for tasks and process instances...",

            title: "Activities - Open process instances",
            titleOpened: "Activities - Open process instances",
            titleCompleted: "Activities - Completed process instances",
            taskDescription: "Activity",
            taskDescrAssignee: "Assignee: ",
            taskDescrDeadline: "Original time to deadline: ",
            instanceId: "ID:",
            timeToDeadline: "Time to deadline:",
            timeToCompletionDate: "Completion date:",
            timeToExpiration: "Time to expiration:",
            expired: "expired",
            titleInstances: "Tasks",
            creationDate: "Creation date:",
            openTasks: "Tasks",
            completedTasks: "Completed tasks",
            completeBy: "Completed by: ",
            completionDate: "Completion date: ",
            timeframe: "Timeframe: ",
            asc: "Asc",
            desc: "Desc",
            deadlineExceeded: "Deadline exceeded by: ",
            exceededType: "exceeded",
            warningType: "Warning",
            onTimeType: "On Time",
            typeHours: " hrs, ",
            typeMinutes: " min",
            loadMore: "Load More",
            notificationMsg: "No details!",
            noTasks: "No tasks!",
            ON_TRACK: "On Time",
            ATTENTION: "In Attention",
            AT_RISK: "In Warning",
            OVERDUE: "Overdue",
            TERMINATED: "Terminated",
            SUSPENDED: "Suspended",
            FAILED: "Failed",
            COMPLETED: "Completed",
            RUNNING: "Running",
            ARCHIVED: "Archived",
            instances: "Process instances",
            actionsCancel: "Cancel",
            UNCLAIM: "Unclaim",
            REASSIGN: "Reassign",
            selectedSortType: "desc"
        },
        taskDescription: {
            activityTitle: "Activity Details",
            taskTitle: "Task Details",
            appTitle: "Source",
            appName: "Application",
            processName: "Process",
            taskName: "Task name",
            instanceName: "Process instance",
            timeToDeadline: "Time to deadline",
            timeRemaining: "Time remaining",
            expirationTimeRemaining: "Expiration time remaining",
            expirationBehaviour: "Expiration behaviour",
            priority: "Priority",
            taskDescriptionProp: "Task description",
            assignedUserinterface: "Assigned User Interface",
            escalationBehaviour: "Escalation behaviour",
            users: "Users",
            autoApprove: "Auto approve",
            autoReject: "Auto reject",
            pPDecision: "Propagate previous decision",
            label: "Label"
        },
        statistics: {
            appStatsTitle: "Process statistics",
            taskTitle: "Task",
            nrCurrInstances: "no. of current open cases",
            nrUncompletedTasks: "Uncompleted tasks",
            nrCompletedTasks: "Completed tasks",
            turnaroundTime: "Turnaround time",
            nrCompletedInstances: "no. of completed instances",
            levelDetails: "Level details",
            appStatsOptimal: "OPTIMAL:",
            currTimeFrame: "CURRENT TIMEFRAME:",
            prevTimeFrame: "PREVIOUS TIMEFRAME:",
            timeFrameVariation: "TIMEFRAME VARIATION:",
            extendedReport: "Extended report",
            taskDeadline: "TASK DEADLINE:",
            applicationThresholds: "Application thresholds",
            viewLevels: "View Levels",
            oneWeek: "1 Week",
            twoWeeks: "2 Weeks",
            month: "Month",
            thresholds: {
                title: "Set up application thresholds",
                currentThresholds: "Current Thresholds",
                infodefault: "Default thresholds can be updated",
                infoDefaultDescription: "Lorem ipsum dolor sit amet, consectetur . . . ",
                thOnTime: "On time",
                thAttention: "Attention",
                thWarning: "Warning",
                taskInception: "Task inception",
                taskOverdue: "Task overdue",
                thSimulation: "Threshold simulation",
                infoSimulation: "Verify the diagram above with a timeframe simulation",
                labelTimeToDeadline: "Time to deadline",
                labelUnits: "Units",
                runSimulation: "Run simulation",
                infoSimDetails: "The simulated task will have the following life-span:",
                attentionInfo0: "If the application is started on ",
                attentionInfo1: "The deadline will reach the ",
                attentionInfo2: " threshold in ",
                attentionInfo: "ATTENTION",
                warningInfo: "WARNING",
                overdueInfo: "OVERDUE",
                titleButtActions: "Update"
            }
        },
        tasksInstances: {
            tasksTitle: "Tasks",
            instancesTitle: "Process instances",
            tooltipFullScreen: "Full list view",
            tooltipDiagramView: "Diagram view",
            expand: "Expand",
            collapse: "Collapse",
            showSearchFilter: "Show filters",
            hideSearchFilter: "Hide filters",
            export: "Export",
            moreActions: "More actions",
            priority: "Priority",
            taskName: "Task name",
            instanceName: "Process instance name",
            instanceId: "Process instance ID",
            finalStage: "Final stage",
            creationSource: "Creation source",
            activity: "Activity",
            assignment: "Assignment",
            creationDate: "Creation date",
            startDate: "Start date",
            completionDate: "Completion date",
            tasks: "Tasks",
            deadline: "Deadline",
            expiration: "Expiration",
            status: "Status",
            action: "Action",
            more: "More",
            ON_TRACK: "On time",
            AT_RISK: "In warning",
            ATTENTION: "In attention",
            OVERDUE: "Overdue",
            viewBtn: "View",
            unclaim: "Unclaim",
            reassign: "Reassign",
            bulkUnclaim: "Bulk unclaim",
            bulkReassign: "Bulk reassign",
            bulkReassignExternal: "Bulk reassign for External Tasks",
            noInterfaceError: "There is no user interface mapped on this end point. It can't be displayed.",
            cancel: "Cancel",
            selectAll: "Select all {counter} tasks",
            clearAll: "Clear all selected tasks",
            itemTask: "task",
            itemTasks: "tasks",
            itemInstance: "process instance",
            itemInstances: "process instances",
            selected: "selected",
            displayed: "displayed",
            viewAssignee: "Show assignees",
            instancesActivity: "Activity",
            tooltipInstance: "View process instance tasks",
            tooltipInstanceFailed: "No tasks available",
            switchTabWarning: "If you want to return to your previous search please remove the 'Process instance ID' from search field",
            filterNotFound: "The requested filter doesn't exist.",
            noPermissions: "You don't have the proper permission to view the application page",
            noStatus: "Status not applicable",
            assigneeSystem: "System",
            clearFilters: "Clear filters",
            cancelRequest: "The request has been successfully canceled."
        }
    },
    dataTable: {
        settingsTitle: "Columns",
        exportTasksTitle: "Export tasks",
        exportInstancesTitle: "Export process instances",
        exportMessage: "Processing export request. When finished, you will receive it via email",
        btnData: "Data Model",
        btnCancel: "Cancel",
        btnReset: "Reset",
        btnConfirm: "Confirm",
        btnExport: "Export",
        noData: "Nothing to display",
        noDataInfo: "There are no elements in this list",
        dataModelTitle: "Select attributes",
        removeCol: "Remove",
        tooltipSettings: "Settings",
        firstPage: "First page",
        prevPage: "Previous page",
        nextPage: "Next page",
        lastPage: "Last page",
        settingsInfo: "Selected: ",
        paginationLabel: " of ",
        exportNotification: "Processing export request. When finished, you will receive it via email.",
        exportError: "Too many requests in progress. Please try again later.",
        exportPanelTooltip: "Select at least one column to continue"
    },
    comments: {
        weekdays: ["Sun", "Mon", "Twe", "Wen", "Thu", "Fri", "Sat"],
        noComments: "No comments, yet",
        userText: "said"
    },
    oneAtATime: {
        uiReadonly: "This item is currently being edited.",
        uiReadonlyMessage: "This item is currently being edited by {user}",
        uiReadonlyDetail: "You will be notified when you can start editing",
        uiEditableMessage: "You can now edit",
        beginEditingAction: "Start editing"
    },
    manageGroupsApps: {
        title: "Manage Groups"
    },
    exportReports: {
        beginDownload: "Your download will begin shortly",
        retryDownload: "If your download won't begin in",
        retryDownload2: "seconds, please press the button below.",
        retryDlBtn: "Retry download",
        downloadBtnLabelCounter: "Retry in {counter}s ...",
        retryDlBtn30s: "Retry in 30s ...",
        exportTaskInfo: "Export task data",
        exportInstanceInfo: "Export process instances data",
        noPermission: "You don't have the permission to access this page!",
        goToDashboard: "Go to dashboard",
        usedBrowsers: "You can use any of the supported browsers instead:",
        usedPlatforms: "You can use any of the supported platforms instead:",
        browserNotSupported: "Your browser is not currently supported.",
        platformNotSupported: "Your platform is not currently supported."
    },
    externalTaskLogin: {
        title: "Enter access code to continue",
        welcomeTitle: "Welcome,",
        accessCode: "Access code",
        continue: "Continue",
        invalidOrExpiredToken: "Invalid or expired token",
        invalidOrExpiredTokenInfo: "Invalid or expired token, please contact support",
        checkingAccessToken: "Checking access token",
        serverDown: "Unable to connect to server.",
        serverIssueMsg: "Please, try again later.",
        accessCodeMandatory: "Add access code or click the link below to get a new one",
        twoFactorAuthTxt: "Your account requires multi-factor authentication.",
        accessCodeSentTo: "We've sent an access code via SMS to the following number:",
        accessCodeSentToEmail: "We've sent an access code via Email",
        sentCode: "If you don't receive it in 10 minutes, generate a new one by",
        resendCode: "A new code has been sent. If you don't receive it in 10 minutes, generate a new one by",
        clickHere: "Resend code",
        emailAddress: "Email address",
        invalidAuthCode: "The access code is incorrect",
        expiredAuthCode: "Access code provided is expired, click Resend code for a new one",
        taskNoLongerActive: "This task is no longer active",
        newAccessCodeSent: "A new code has been sent.",
        resendInTime: "Resend in {time}s",
        tokenExpired: "Your token has expired",
        taskExpired: "The task is no longer active.",
        taskCompleted: "Thank you!",
        taskCompletedInfo: "The task has been successfully submitted.",
        roLang: "RO",
        enLang: "EN"
    },
    timeline: {
        title: "Process timeline",
        search: "Search",
        loadMore: "Load more",
        timelineOf: "Timeline of ",
        collapseAll: "Collapse all",
        ON_TRACK: "ON TIME",
        ATTENTION: "IN ATTENTION",
        AT_RISK: "IN WARNING",
        OVERDUE: "OVERDUE",
        actionBy: "by",
        onBehalfOf: "on behalf of",
        openComment: "Open comment",
        errorTask: "Error receving task details !",
        CLAIM: "Claimed",
        CREATE: "Created",
        SUBMIT: "Submitted",
        DELEGATION: "Delegated",
        SAVE_DATA: "Saved",
        JAVA_SCRIPT_EXECUTED: '"JavaScript"',
        TASK_TIMER_TRIGGERED: "Expired",
        SAVE_FOR_LATER: "Saved for later",
        ASSIGN: "Assigned",
        TASK_CLOSE: "Closed",
        UN_CLAIM: "Unclaimed",
        AUTO_REJECT: "Auto Rejected",
        REASSIGN: "Reassigned",
        START_SUBPROCESS: "started",
        submittedAction: "Submitted with ",
        autosubmitAction: "Auto-submitted with",
        startAction: "Started",
        instanceLabel: "process instance",
        processLabel: "process",
        listeningValidRsp: "Listening for a valid response...",
        exitedAction: "Exited with ",
        submitBy: "by",
        eventReceved: "received by",
        assignedTo: "to",
        task: "Task",
        Response: "Response received",
        eventAction: "Response for",
        Request: "Request sent",
        apiService: "APIService",
        executedBy: "System",
        executedAction: "executed",
        levelMatrixDetails: "ON",
        approve: "Approve",
        reject: "Reject",
        autoApprove: "Auto approve",
        autoReject: "Auto reject",
        approveLevel: "Approved",
        rejectLevel: "Rejected",
        autoApproveLevel: "Auto-approved",
        autoRejectLevel: "Auto-rejected",
        started: "Started from",
        system: "System",
        inProgress: "IN PROGRESS",
        noTrueRule: "No rules were evaluated as true",
        noResultsAvailable: "No results available",
        singularDecision: 'Approver ("Singular" decision)',
        groupDecision: 'Approver (threshold set to "{count}" approvals)',
        overriderDecision: "Overrider",
        evaluatorDecision: "Evaluator",
        SMS: "sent",
        EMAIL: "sent",
        uploadedBy: "uploaded by",
        generatedBy: "generated by",
        retried: "Retried",
        terminated: "Terminated",
        downloadedLog: "Downloaded log",
        viewedLog: "Viewed log",
        savedDataModel: "Saved data model",
        deleteDataModel: "Data model values deleted",
        deleteDataModelAudit: "Data model values audit deleted",
        anonymizeInfo: "Anonymization of personal data",
        archived: "Archived",
        on: "on",
        using: "using",
        changeMadeBy: " change made by ",
        changesMadeBy: " changes made by ",
        valueChanges: "Value changes",
        viewDataAudit: "View data audit",
        deleteCommentAudit: "Comment was deleted",
        deletedAudit: "Data audit was deleted",
        added: "added",
        removed: "removed",
        edited: "edited",
        subtitleDeteletedProcess: "The process instance has been deleted"
    },

    fabricInterface: {
        taskWindow: "Task window",
        appTracer: "App tracer",
        minSidebar: "Minimize sidebar",
        taskInfoTitle: "Task information",
        timelineTitle: "Timeline",
        docsTitle: "Documents",
        commTitle: "Comments",
        taskErrorsTitle: "Task Errors",
        noErrorsFound: "No errors found",
        errors: "error | errors",
        errorsFound: "{count} Error Found | {count} Errors Found",
        submitErrorMessage: "Please solve the error to continue. | Please solve the errors to continue.",
        errorsTitle: "User interface errors",
        myAccount: "My Account",
        logout: "Logout",
        unclaim: "Unclaim",
        reassign: "Reassign",
        escalate: "Escalate",
        goBack: "Go back",
        saveForLater: "Save for later",
        submitData: "Submit data",
        sgMandatoryField: "There is a mandatory field that was not completed.",
        multiMandatoryField: "There are some mandatory fields that were not completed.",
        invalidFields: "There is a field with invalid data. | There are some fields with invalid data.",
        configIssues: "Field validation failed. There is a configuration problem. Please contact an administrator.",
        loseDataMsg: "You will lose any unsaved data, are you sure?",
        landscapeTitle: "Please turn your device on portrait mode",
        landscapeDescription: "In order to view the platform from your device, please keep your device on portrait mode.",
        removeImage: "Remove Image",
        editContent: "Edit content",
        submitTask: "Submit Task",
        confirmInfo: "By confirming the submission, the task will be sent to the next stage and it will be considered as completed for you.",
        cancelBtn: "Cancel",
        confirmBtn: "Confirm submission",
        confirmBtnMobile: "Submit",
        commentplaceHolder: "Leave comment",
        mandatoryComment: "Required",
        optionalComment: "Optional",
        mandatoryCommError: "This field is mandatory",
        selectError: "You must select a destination before you can continue",
        noPreviewMsg: "No preview available for this type of file"
    },
    userInterface: {
        addNewBtn: "Create new",
        interface: "user interface | user interfaces",
        fragment: "fragment | fragments",
        labelInterfaces: "User Interfaces",
        labelFragments: "Fragments",
        results: "result | results",
        info1: "Start adding some layout elements.",
        info2: "Drag layout elements from the sidebar on the left and drop them on this canvas.",
        deleteInfoTitle: "Item doesn't exist",
        deleteInfoContent: "The item you're trying to open doesn't exist or has been deleted.",
        hasFragments: " user interface contains fragments! Do you wish to continue?",
        mandatoryField: "This field is mandatory",
        codeMandatory: "Code is mandatory",
        duplicateCode: "Code is duplicated",
        duplicateCodeToast: "A user interface with the same code already exists!",
        nameMandatory: "Name is mandatory",
        listUpdate: "The list of user interfaces has changed",
        interfaceUpdate: "has been updated",
        pageProp: "Page properties",
        codeLabel: "Code",
        nameLabel: "Name",
        descriptionlabel: "Description",
        testingLabel: "Testing",
        auraAssistant: "Assistant",
        appAndBehLabel: "Appearance and behaviour",
        selectTheme: "Select a theme",
        layoutElements: "Layout elements",
        dataModelMapp: "Data model mappings",
        allPages: "All pages",
        userInterfaces: "User interfaces",
        basicComponents: "Basic components",
        layoutStruct: "Layout structure",
        standardElements: "Standard elements",
        formElements: "Form elements",
        customComponents: "Custom components",
        interfaces: "User Interfaces",
        fragments: "Fragments",
        importInterf: "Import user interface",
        exportInterf: "Export user interface",
        pagesTitle: "Pages",
        layoutTitle: "Layout",
        values: "Option values",
        container: "Container",
        containerFilter: "Filter",
        containerFilterDefault: "None",
        positionIndex: "Position index",
        addItem: "Add item",
        viewMode: "User Interface is opened in view mode",
        importInterfaceReadonlyMode: "You can't import user interface in read-only mode",
        addComponentReadonlyMode: "You can't add components in read-only mode",
        addInterfaceFirst: "You have to add a user interface or fragment first",
        leavePageMsg: "You have unsaved changes that will be lost if you continue",
        deleteInterfaceTitle: "Delete User Interface",
        deleteFragmentTitle: "Delete Fragment",
        deleteMessage: "Are you sure you want to delete ",
        deleteElementTitle: "Delete Element",
        deleteElementMsg: "Are you sure you want to delete the element?",
        confirm: "Confirm",
        continue: "Continue",
        errorRemoveInterface: "There was a problem while removing the user interface.",
        interfaceRemoved: "The user interface was removed.",
        importInterface: "User Interface successfully imported.",
        saveInterface: "User Interface saved successfully",
        errorInterface: "There was an error while saving the user interface.",
        fragmentError: "You can't save a fragment with another fragment in it.",
        sameFragment: "You can't add fragment inside same fragment.",
        addedFragment: "Fragment already added to this user interface.",
        addedSegment: "You can't add a fragment inside a segment.",
        updateInterface: "has been updated. To see the latest version please refresh the page.",
        refresh: "Update",
        deleteInterfaceMsg: "The {interface} user interface has been deleted by {username}.",
        noDisplayInterfaces: "Select or create a new user interface or fragment",
        noInterfacesDesc: "Here you will find any created user interfaces or fragments in the future",
        noInterfaces: "No user interfaces or fragments yet",
        openModeInterface: "User Interface is opened in read-only mode",
        loseDataMsgTitle: "Warning",
        loseDataMsg: "By leaving this page you are going to lose your changes!",
        leaveBtn: "Confirm",
        cancelBtn: "Cancel",
        integerVal: "Integer",
        decimalVal: "Decimal",
        nrOfDecimals: "Number of decimals",
        expressionLabel: "Expression",
        expressionTooltip: "The validation is applied on element defocus",
        eventLabel: "Event",
        eventTooltip: "The validation is applied on selected event",
        onChangeOpt: "On change",
        onDefocusOpt: "On defocus",
        tooltipAIDisabled: "Please save the Interface to use the AI assistant.",
        validation: {
            emailOpt: "Email address",
            regexOpt: "RegEx",
            ibanOpt: "IBAN",
            urlOpt: "URL"
        },
        data: {
            linkModel: "Link Get/Set model",
            getLabel: "Get data",
            setLabel: "Set data"
        },
        properties: {
            align: "Align",
            leftAlign: "Left",
            rightAlign: "Right",
            centerAlign: "Center",
            icon: "Icon",
            process: "Process",
            configureProcessTitleModal: "Configure data sync",
            configureProcessModalSubtitle: "Data model",
            pickerPlaceholder: "Search for data model",
            dataSyncLabel: "Data sync",
            elementLabel: "element | elements",
            addDataModel: "Data model",
            modalTitle: "Add data model variables",
            modalCardTitle: "Data model",
            filename: "Filename",
            type: "Type",
            validationTxtOpt: "Text",
            validationNumberOpt: "Number",
            validationOthOpt: "Other"
        },
        scriptErr: " | Script contains {n} error. | Script contains {n} errors.",
        renameInterface: "Rename user interface",
        renamedSuccessfully: "The Interface/Fragment has been successfully renamed.",
        cantBeRenamed: "The Interface/Fragment is being edited by {user} and cannot be renamed",
        emptyName: "The Interface/Fragment must have a name",
        notFoundFr: "Fragment with id {id} not found",
        promptAiPlaceholder: "Describe what you want the AI to {action}",
        promptTooltip: "Your prompt, and possibly the content of the script will be sent to OpenAI for processing. Do not enter any sensitive information.",
        auraAssist: {
            addBtn: "Add",
            title: "Create an assistant action",
            editTitle: "Edit an assistant action",
            actionType: "Action type",
            summarizeAct: "Summary",
            targetedSum: "Targeted summary",
            conversationAct: "Conversation",
            translateAct: "Translate",
            custom: "Custom",
            allowDocSelection: "Allow user to select documents",
            instructions: "Instructions",
            userPrompt: "Allow user prompts",
            userRepliesPrompt: "Allow user replies",
            deleteAiAcTitle: "Delete Assistant Action",
            deleteAiAcBody: "Are you sure you want to delete this assistant action?",
            promptText: "Select one of the available actions to continue",
            docsForSelection: "Select documents",
            summaryDefaultBody: "Summarize the documents.",
            convDefaultBody: "Answer any questions asked by the user based on the information from the documents.",
            translateDefaultBody: "Translate the documents provided into the language indicated.",
            targetedSumBody: "Extract and summarize all information related to the topic indicated by the user from the documents.",
            targetedDocs: "Targeted documents",
            translateInfoBox: "The user will be able to select their desired language",
            conversationInfoBox: "The user will be able to ask questions and follow-ups about the documents.",
            targetedSumInfoBox: "The user will be asked to enter a topic.",
            docsError: "You must select at least 1 interface element before saving your configuration.",
            docsErrorExecution: "You must select at least 1 interface element before continuing",
            noUploadedDocs: "The selected fields do not contain any documents",
            targetTopic: "Target topic",
            englishLg: "English",
            frenchLg: "French",
            germanLg: "German",
            spanishLg: "Spanish",
            generatingResponse: "Generating response",
            promptLabel: "Prompt",
            docsAlreadySelectedPlaceholder: "Selected documents",
            duplicatedName: "Name must be unique",
            errInstructions: "Instructions cannot be empty if the user prompt is disabled",
            additionalReq: "Add additional requests",
            progressTooltip: "Uploading documents and generating response",
            progressTooltipShort: "Generating response",
            noElemensAvailable: "No 'Upload' elements available in the interface yet",
            interfaceSubtitle: "Interface documents",
            additionalDocsSubtitle: "Additional documents",
            topicLabel: "Topic",
            exportPDFAnswers: "Export all answers",
            exportPDFAll: {
                targeted: "Export all answers and your topic",
                custom: "Export all answers and your prompt",
                conversation: "Export all answers and your question"
            }
        }
    },
    appTasksContainer: {
        available: "Available",
        claimed: "Claimed",
        delegated: "Delegated",
        delegatedFrom: "Delegated from",
        delegatedTo: "Delegated to",
        completionDate: "Completion date",
        timeRemaining: "Time remaining",
        myOpenTasks: "My Tasks",
        completedTasks: "My Tasks",
        teamsTasks: "Team Tasks",
        totalNumbertasks: "tasks",
        tasksDisplayed: "displayed",
        myTasks: "Tasks",
        myTeamsTasks: "Team Tasks",
        selectAllTasks: "All tasks",
        selectTasks: "Tasks",
        selectAllStatus: "All statuses",
        selectStatuses: "Statuses",
        selectAllApps: "All applications",
        selectAllProcesses: "All processes",
        selectAllUsers: "All users",
        selectAllGroups: "All Groups",
        selectStatus: "Status",
        selectApps: "Applications",
        selectUsers: "Users",
        selectGroup: "Team",
        priority: "Priority",
        taskName: "Task name",
        instanceName: "Process instance name",
        application: "Application",
        applications: "Applications",
        processes: "Processes",
        users: "Users",
        creationDate: "Creation date",
        assignment: "Assignment",
        status: "Status",
        action: "Action",
        viewDetails: "View",
        loadMoreFirst: "Load more",
        onTrack: "On time",
        atRisk: "In warning",
        attention: "In attention",
        overdue: "Overdue",
        goTop: "Back to top",
        unclaimAction: "Unclaim",
        reassignAction: "Reassign",
        noTasks: "No tasks available",
        hours: " hours",
        minutes: " minutes",
        days: " days",
        weeks: " weeks",
        critical: "Less than 1 minute left",
        priorityTooltip: "priority",
        UNCLAIM: "Bulk Unclaim",
        REASSIGN: "Bulk Reassign",
        cancelBulk: "Cancel",
        tasks: "tasks",
        task: "task",
        tasksSelectedUNCLAIM: "selected to be unclaimed",
        tasksSelectedREASSIGN: "selected to be reassigned",
        settingsTitle: "Column settings",
        settingsConfirm: "Confirm",
        settingsDefault: "Default",
        settingsCancel: "Cancel",
        completedTeamsTasks: "Team Tasks",
        completedBy: "Completed by",
        selected: "selected",
        none: "None"
    },
    submitModal: {
        modalTitle: "Submit",
        submitAction: "Submit action",
        commentInput: "Comment"
    },
    adminUsersGroups: {
        usersGroupsTitle: "Users & Groups",
        searchField: "Search",
        tabUsersTitle: "Users",
        tabGroupsTitle: "Groups",
        itemsDisplayed: "displayed",
        results: "result | results",
        numberItemUSERS: "user | users",
        numberItemGROUPS: "group | groups",
        andWord: "and",
        typeLabel: "Type",
        statusLabel: "Status",
        allTypesLabel: "All types",
        allStatusLabel: "All Status",
        createNewUSERS: "Create new user",
        createNewGROUPS: "Create new group",
        typeEXTERNAL: "External",
        typePLATFORM: "Platform",
        typeSYSTEM: "System",
        typeAPPLICATION: "App",
        optionTypeApp: "Application",
        typeACTIVE: "Active",
        typeINACTIVE: "Inactive",
        typeDISABLED: "Disabled",
        disabledTypeOn: "Disabled on ",
        lastLogin: "Last login: ",
        noLastLogin: "Last login: Never",
        disabledTypeAt: " at ",
        loadMoreButton: "Load more",
        noGROUPS: "No groups available",
        noUSERS: "No users available",
        inviteBulkUsers: "Bulk invite users",
        createNew: "Create new",
        bulkuserStatusTitle: "New user status",
        disabledUser: "Disabled (users need to confirm their account)",
        activeUser: "Active",
        bulkInviteModalListing: "listing | listings",
        bulkInviteModalInvalidEntries: "invalid entries",
        formatInstructions: "Format instructions:",
        formatInstruction: "The phone number must always start with “+” and the country code",
        emailInvalidMsg: "Invalid email address format. Will be skipped during invite.",
        phoneInvalidMsg: "Invalid phone number format. Will be skipped during invite.",
        doneBtn: "Done",
        downloadTemplate: "Download template",
        downloadSubtitle: "Select the desired file format from the <br> supported options below",
        uploadTitle: "Upload your file",
        uploadInfo: "Drag and drop here a .cvs, .xls, .xlsx file or <br> click here to browse your machine.",
        dialogTitle: "Some email addresses or phone numbers are not valid",
        dialogMessage:
            "{invalidEntries} of the {totalEntries} imported entries have incorrect data and cannot be invited. Send invites to the remaining {availableEntries}{space}",
        emailAddress: "adress? | addresses?",
        invalidEntriesMessage: "Wrong or already existing email address format or phone number. Will be skipped during invite",
        multipleInvitesToastMsg: " users have been successfully invited.",
        oneInviteToastMsg: "The user has been successfully invited.",
        noAvailableEmails: "All imported entries have incorrect data and cannot be invited. Please upload a different file, with correct data.",
        noAvailableEmailsTitle: "Invalid emails",
        invalidFile: "Invalid file",
        invalidFileText: "The file you selected is incorrect. Upload a correct file and try again."
    },
    applicationSettingsSidebar: {
        settings: "General",
        workSchedule: "Work Schedule",
        applicationGroups: "Specific Groups",
        permissions: "Permissions"
    },
    applicationPermissions: {
        title: "Permission sets",
        search: "Search",
        itemsResults: "result | results",
        OWNERRole: "Owner",
        OWNERRoleDesc: "Full access anywhere in the application",
        INITIATORTitle: "Initiate",
        INITIATORRole: "Initiate all processes",
        INITIATORRoleDesc: "Permission to start any process in the application",
        ADMINISTRATORRole: "Manage permissions & groups",
        ADMINISTRATORRoleDesc: "Create and edit specific groups, give and remove permissions.",
        EDITORRole: "Design & configure business elements",
        EDITORRoleDesc: "Create & configure processes, user interfaces, document templates, data model and catalogs. View integrations and smart contracts.",
        DIAGRAM_EDITORRole: "Model application flow",
        DIAGRAM_EDITORRoleDesc:
            "Create & configure processes. View user interfaces, document templates, integrations, smart contracts, data model and catalogs.",
        REPORTS_VIEWERRole: "View analytics",
        REPORTS_VIEWERRoleDesc: "View application tasks and process instances, process statistics, process flow, and task interfaces.",
        TASKS_MANAGERRole: "Reallocate tasks",
        TASKS_MANAGERRoleDesc: "Unclaim & reassign all task assignments across application via analytics or data views.",
        SMART_CONTRACT_DESIGNERRole: "Design smart contract functions",
        SMART_CONTRACT_DESIGNERRoleDesc: "Create & configure smart contracts. View processes, data model and catalogs.",
        INTERFACES_MANAGERRole: "Design user interfaces",
        INTERFACES_MANAGERRoleDesc: "Create, edit and delete user interfaces. View processes, document templates, integrations, data model and catalogs.",
        DOCUMENTS_MANAGERRole: "Design document templates",
        DOCUMENTS_MANAGERRoleDesc: "Create, edit and delete document templates. View processes, user interfaces, integrations, data model and catalogs.",
        PERSPECTIVE_MANAGERRole: "Design data views",
        PERSPECTIVE_MANAGERRoleDesc: "Create, edit and delete data views. View user interfaces.",
        PerspectiveRoleDesc: "The user can view this data view.",
        API_MANAGERRole: "Configure integrations",
        API_MANAGERRoleDesc: "Edit, add & delete application integrations. View processes, user interfaces, document templates, data model and catalogs.",
        VIEWERRole: "Access the application in view mode",
        VIEWERRoleDesc: "View all application modules in read only mode.",
        SIDEBARContainerRole: "View task interface info & resource panels",
        SIDEBARContainerRoleDesc: "Access the process instance documents, timeline, comments and task details info panels on the task interface",
        INITIATORContainerRole: "Initiate processes",
        INITIATORContainerRoleDesc: "Permission to start processes in the application",
        SIDEBAR_DOCUMENTSRole: "View process instance documents",
        SIDEBAR_COMMENTSRole: "View process instance comments",
        SIDEBAR_TIMELINERole: "View process instance timeline",
        SIDEBAR_TASK_INFORMATIONRole: "View task information",
        SIDEBARRole: "View all task interface info & resource panels",
        PUBLISH_APPRole: "Publish application",
        PUBLISH_APPRoleDesc: "Permission to publish application.",
        DATA_MODEL_MANAGERRole: "Define & configure data model & catalogs",
        DATA_MODEL_MANAGERRoleDesc: "Add, edit and delete data model classes and attributes, catalog definitions and values.",
        CATALOGS_MANAGERRole: "Manage catalogs",
        CATALOGS_MANAGERRoleDesc: "Define catalogs and their values.",
        DATA_MODEL_VIEWERRole: "View data model & catalogs",
        DATA_MODEL_VIEWERRoleDesc: "View data model classes and attributes, view catalogs.",
        permissionOnlyOneUser: "This permission can have only 1 user",
        buildingTab: "Building",
        initiateTab: "Initiate",
        tasksTab: "Tasks",
        dataViewsTab: "Data views",
        analyticsTab: "Analytics",
        settingsTab: "Settings",
        viewDetailsBtn: "View permission details",
        changeBtn: "Change",
        addNewBtn: "Add new",
        permissionsFirst: "This permission has ",
        permissionsSecond: "and ",
        group: "group",
        groups: "groups",
        user: "user",
        users: "users",
        usersAndGroups: "users and groups",
        displayed: "displayed",
        noUsersAndGroups: "This permission has no users and groups",
        givePermissions: "Give permissions",
        saveAddPermission: "The permissions have been successfully added",
        noResultsFound: "No results found",
        noResultsFoundDetails: "We couldn't find what you searched for.",
        noData: "No data",
        noDataDisplayed: "There's no data to display.",
        tooltipPermissions: "Permissions view",
        tooltipUsers: "Users view",
        alreadyExisting: "Already existing items",
        newlyAdded: "Newly added items",
        addConfirmationMsg: "The permissions have been successfully saved",
        removeConfirmationMsg: "The permissions have been successfully removed"
    },
    applicationPermsViewDet: {
        title: "View permission details",
        titleEditor: "Editor",
        titleSection: "Section",
        titleManage: "Manage",
        titleView: "View",
        appSettings: "Application settings",
        highlights: "Highlights",
        workSchedule: "Work schedule",
        updateApp: "Update application",
        exportApp: "Export application",
        managePerms: "Manage permissions",
        manageAppGr: "Manage application groups",
        diagrams: "Processes",
        smartConDes: "Smart contracts",
        interfaceBuilder: "User Interfaces",
        docBuilder: "Document Templates",
        perspectiveBuilder: "Custom Data Views",
        apis: "Integrations",
        dataModel: "Data Model",
        catalogs: "Catalogs",
        catalogDef: "Catalog definition",
        catalogValues: "Catalog values",
        reports: "Analytics",
        instancesTasks: "Process live view",
        statistics: "Process statistics",
        reassign: "Reassign tasks",
        unclaim: "Unclaim tasks",
        publish: "Publish"
    },
    applicationChangeOwner: {
        title: "Change application owner",
        subtitle: "Current owner",
        ownerChanged: "Owner successfully changed"
    },
    appEditPermissions: {
        title: "Edit permissions",
        memberTitle: "Member",
        other: "Other permissions",
        inharited: "Inherited from parent groups:",
        inheritedDesc: "This user has the following access permissions inherited from the groups he/she is included in:",
        permissions: "Permissions",
        tooltipSave: "The user needs to have at least one permission selected",
        remove: "Remove",
        cancel: "Cancel",
        removeUser: "Remove item",
        dialogBody: "The action will remove {type} from '{permissionName}'",
        dialogBodyDefault: "The action will remove all permissions",
        dialogBodyGroup: "This action will remove all direct permissions from this group",
        dialogBodyUser: "This action will remove all direct permissions from this user",
        saveEditPermission: "The permissions have been successfully updated",
        removeEditPermission: "The permissions have been successfully removed",
        owner: "OWNER"
    },
    appSetPermissions: {
        title: "Set permissions",
        editTitle: "Edit permissions",
        appTitle: "Application",
        placeholderApp: "Select application",
        addPermissions: "Add permissions",
        directPermissions: "Direct permissions",
        directPermDesc: "This group has the following access permissions granted directly",
        directPermDescUser: "This user has the following access permissions granted directly",
        inheritedPermissions: "Inherited from parent groups",
        inheritedPermDesc: "Following access permissions inherited from the groups he/she is included in",
        inheritedPermDescUser: "This user has the following access permissions granted by being a member of certain groups",
        code: "Code:",
        permissions: "permissions",
        remove: "Remove",
        requiredMsgApp: "Please select an application",
        requiredMsgPerm: "Select one or more permissions",
        group: "group",
        groups: "groups"
    },
    uploader: {
        defaultTitle: "Upload your file here",
        uploadText: "Drag and drop a",
        uploadFiles: "file",
        uploadText2: "max",
        uploadText3: "or",
        uploadText4: "click here",
        uploadText5: "to browse your machine.",
        duplicatedNameErr: "File is already selected",
        addedFiles: "file added | files added",
        ignoredFiles: "file ignored | files ignored",
        fileSizeError: "File size too large",
        extensionError: "Unaccepted file format",
        allowExtensions: "Allow extensions",
        uploadTitle: "Uploaded file",
        updateUploadTitle: "Update application",
        samlUploadTitle: "Upload the Identity Provider metadata file",
        uploadSubTitle: "Drag and drop a <b>{allowedExtensions}</b> file in this area, or {clickHere} to browse your machine"
    },
    froala: {
        insertPageBreakTooltip: "Insert page break",
        pastePlainTextTooltip: "Toggle paste as plain text",
        directionRTLTooltip: "Text direction right to left",
        directionLTRTooltip: "Text direction left to right",
        pageA4Tooltip: "Page A4",
        pageA3Tooltip: "Page A3",
        toggleBlocksTooltip: "Show blocks",
        dynamicTableTooltip: "Insert table from Data model",
        richTextBlockTooltip: "Insert rich text block",
        dynamicTable: "Dynamic table",
        renameDocumentTitle: "Rename Document Template",
        header: "Header",
        footer: "Footer",
        dataModel: "Data model",
        backgroundImage: "Background image",
        firstPage: "Different first page",
        firstPageTab: "FIRST PAGE",
        otherPagesTab: "OTHER PAGES",
        pageNumbers: "Page numbers",
        pageNr: "Page Number",
        pagesCount: "Pages count",
        conditionalBlock: "Conditional block",
        richTextBlock: "Rich text block",
        conditionalBlockTooltip: "Insert conditional block",
        repeatableBlock: "Repeatable block",
        repeatableBlockTooltip: "Insert repeatable block",
        separatorError: 'You cannot use "{char}" as a separator',
        decimalError: "Decimal separator cannot be empty",
        insertLineBefore: "Add new line before",
        insertLineAfter: "Add new line after",
        customDateTitle: "Date and time format",
        customNrTitle: "Number Formatting",
        settings: "Settings",
        delete: "Delete",
        addBefore: "Add new line before",
        addAfter: "Add new line after",
        downloadPreviewPDF: "PDF Preview",
        downloadPreviewDOCX: "DOCX Preview",
        failedPreview: "You cannot have list attributes outside of a repeatable block or dynamic table",
        moveRight: "Move column right",
        moveLeft: "Move column left",
        moveUp: "Move row up",
        moveDown: "Move row down",
        transpose: "Transpose",
        transposeDisabled: "Transpose not possible for dynamic tables or tables with merged or split cells.",
        reorder: "Reorder",
        reorderDisabled: "Reorder not possible for tables with merged or split cells."
    },
    globalDataModel: {
        entitiesTitle: "Data Tables",
        entitiesLegacy: "Data Tables Legacy",
        invalidEntries: "invalid cell",
        invalidCell: "entry | entries",
        latestDisplayed: "Latest {number} entries displayed",
        refreshData: "Refresh",
        addNewData: "Add data",
        createNewEntity: "Create new",
        importEntity: "Import",
        entities: "data table | data tables",
        numberItems: "result | results",
        searchEntities: "Search data tables",
        viewAs: "View as",
        createEntityTitle: "Create new data table",
        settings: "Settings",
        name: "Name",
        code: "Code",
        type: "Data type",
        addColumn: "Add column",
        editColumn: "Edit column",
        source: "Source type",
        aurachain: "{brandName}",
        microsoftSQL: "Microsoft SQL Server",
        MySQL: "MySQL",
        oracle: "Oracle",
        catalogType: "Catalog type",
        wrongPatternErr: "The name can contain letters, numbers and special characters such as underline,line and space. The first character must be a letter",
        wrongPattern: "The name can contain a maximum of 60 alphanumeric characters, such as: letters, numbers and the special characters underline, line, and space.",
        wrongPatternCode: "The code can contain a maximum of 60 alphanumeric characters, such as: letters, numbers and the special character underline.",
        wrongPatternEntityName: "The data table name can contain a maximum of 60 alphanumeric characters, such as: letters, numbers and the special characters underline, line and space.",
        duplicateName: "The name is already in use",
        duplicateCode: "The code is already in use",
        alreadyEdited: "The table is currently being edited by {userName} and cannot be deleted",
        alreadyInRoom: "The table is currently being edited by {userName} and cannot be renamed",
        tooltipInfo: "Autogenerated primary key column with unique incremental integer values for each row",
        permCard: "Access permissions",
        renameEntityToast: "The {entityName} table has been successfully renamed",
        duplicatedEntityToast: "The data table name is already in use.",
        emptyNameEntity: "Name can not be empty.",
        wrongPatternEntity: "The data table name can contain a maximum of 60 alphanumeric characters, such as: letters, numbers and the special characters underline, line and space.",
        addNewAtt: "Add new attribute",
        addNewColumn: "Add column",
        attType: "Attribute type",
        columnType: "Type",
        addAnother: "Add another",
        addAnotherColumn: "Add another",
        emptyName: "This field is required!",
        globalEntities: "Data Tables",
        editTitle: "data table",
        deleteEntity: "Delete",
        deleteTitle: "Delete Data Table",
        deleteMsg: "The action is irreversible and any application using the data table will stop working properly.",
        publishedDeleteMsg:
            "The data table and its data will be deleted. This action is irreversible. It is highly advised to backup the data before continuing with the action.",
        deleteForever: "Delete forever",
        deletedMsg: "The table has been successfully deleted",
        deletedMsgStore: "The {entityName} table has been successfully deleted ",
        editEntity: "Edit",
        permissions: "Permissions",
        permissionsLabel: "{entityName} permissions",
        editPermissions: "Edit permissions",
        accessPermissions: "Access permissions",
        addNewAccessPermissions: "Add new access permission",
        emptyElement: "This element is mandatory",
        addPermission: "Add permission",
        renameDataTable: "Rename data table",
        rename: "Rename",
        emptyEntityName: "The name can not be empty",
        duplicatedEntity: "The data table name is already in use",
        applications: "Applications",
        dataAccess: "Data access",
        audit: "Audit",
        viewDataAudit: "View data audit",
        notifyToast: "The permission list for {entityName} has been successfully updated",
        view: "View",
        edit: "Edit",
        duplicatedName: "The name is already in use",
        save: "Save",
        onlyDecimal: "Only decimal values are allowed",
        onlyInteger: "Only integer values are allowed",
        publishInfo: "Last publish date: ",
        unpublishedInfo: "Not published",
        toastMsg: "The data table has been successfully published! ",
        deleteRow: "Delete row",
        deleteData: "Delete data",
        deleteRowMsg: "Do you really want to delete this row? Once deleted, you cannot restore it.",
        deleteDataMsg: "The action will remove the rows and it is irreversible.",
        confirmBtn: "Proceed",
        copySwaggerLink: "Copy Swagger descriptor URL location",
        downloadSwagger: "Download Swagger descriptor",
        deleteBtn: "Delete",
        editAtt: "Edit Attribute",
        deleteAttTitle: "Delete attribute",
        deleteColumnTitle: "Delete column",
        deleteAttMsg: "The action is irreversible and any application using the attribute will stop working properly.",
        deleteColumnMsg: "The action is irreversible and any application using the column will stop working properly.",
        deletedAttMsg: "The attribute has been successfully deleted",
        deletedColMsg: "The column has been successfully deleted",
        editedAttToast: "The attribute has been successfully edited.",
        editedColToast: "The column has been successfully updated.",
        addedAttribute: "The attribute has been successfully added.",
        addedColumn: "The column has been successfully created.",
        schema: "Schema",
        tableView: "Table/View",
        availableActions: "Available actions",
        create: "Create",
        update: "Update",
        read: "Read",
        delete: "Delete",
        pullStructure: "Pull structure",
        refreshStructure: "Refresh structure",
        entityAttributes: "Data Table Attributes",
        sourceField: "Source Field",
        dataType: "Data type",
        attOnAurachain: "Attribute name on {brandName}",
        dataTypeOnAurachain: "Data type on {brandName}",
        attCode: "Attribute code",
        invalidAttribute: "This attribute is not supported for integration",
        invalidInput: "The name contains invalid characters.",
        updateEntity: "The data table has been successfully updated",
        deleteTooltip: "You cannot delete the Row ID attribute",
        deleteTooltipColumn: "You cannot delete the ID column",
        export: "Export",
        exportEntityDetails: "Output details (.xlsx files)",
        download: "Download",
        sendByEmail: "Send to email (recommended for large amounts of data)",
        exportEntitMethod: "Method",
        structure: "Structure",
        data: "Data",
        successExportStructure: "Structure has been successfully exported",
        successExportData: "Data has been successfully exported",
        exportConfig: "Export configuration",
        exportByEmail: "Processing structure and data export request. When finished, you will receive it via email",
        importData: "Import data",
        import: "Import",
        entries: "entries",
        importAFile: "Import a file",
        fileHasErrors: "Files containing errors cannot be imported",
        noUnpublishedEntity: "Cannot import data on an unpublished data table",
        invalidExcelEntries: "The file contains invalid entries",
        invalidFile: "The file structure does not match the data table structure.",
        allowedDataFormats: "Allowed data formats",
        rowIdInfo: "6 alphanumeric characters, 0-9 numbers and lower letters",
        row: "Row",
        invalidRows: "row | rows",
        error: "Error",
        separated: "separated by dot",
        invalidFileStructure: "Invalid file structure.",
        noAttError: 'Attribute with name "{attributeName}" does not exist or is not published.',
        rowIdValidation: "Row ID format must be of 6 characters in length.",
        rowIdUnique: "Row ID must be unique.",
        invalidDataFormat: 'Invalid data format on "{name}".',
        successExport: "Structure has been successfully exported",
        uploadFileTitle: "Upload structure file",
        uploadInstruction: "Upload instructions:",
        instructionLine: "Supported attributes are: ",
        instructionLine1: "string, integer, decimal, datetime, date, time",
        instructionLine2: "and",
        instructionLine3: "boolean.",
        instructionLine4: "The",
        instructionLine5: "data table code, Row ID",
        instructionLine6: "attribute,",
        instructionLine7: " attribute code",
        instructionLine8: "will be automatically generated by the system.",
        importModalTitle: "Import table from CSV file",
        csvFile: "CSV file",
        allowedDataFormatsText: "Allowed data formats:",
        instrLine1: "datetime:",
        instrLine2: "yyyy-mm-ddThh:mm:ss+hh:mm",
        instrLine3: "date:",
        instrLine4: "yyyy-mm-dd",
        instrLine5: "time:",
        instrLine6: "hh:mm:ss+hh:mm",
        instrLine7: "boolean:",
        instrLine8: "true, false",
        instrLine9: "decimal - ",
        instrLine10: "separated by dot “.”",
        importBehaviourText: "Import behaviour:",
        instrLine11: "Each new data table row will automatically receive a unique incremental number",
        instrLine12: "ID:",
        instrLine13: "integer",
        ruleUseIdFromFile: "The CSV mapped ID column requires new unique IDs. Rows with empty or existing IDs will be skipped.",
        ruleUpdateExistingRows: "The rows are updated based on the ID column. Rows with empty or mismatched IDs will be skipped.",
        errorNoColumn: "At least one column must be present",
        errorNoId: "'ID' column must be mapped",
        uploadYourFileTitle: "Upload your file",
        importDataLabel: "Import data into {entityName} table",
        table: "Table",
        addNewRows: "Add new rows",
        updateExistingRows: "Update existing rows",
        autoGenerateId: "Auto-generate IDs",
        idFromFile: "Use IDs from file",
        errorDuplicateColumns: "The file has duplicated columns.",
        errorFileEmpty: "The file is empty.",
        alreadyMapped: "Already mapped",
        invalidStructure: "Invalid file structure",
        dataNotSupported: '"{invalidDataInFile}" data type is not supported.',
        missingData: 'Missing attribute name or type in line "{invalidDataInFile}"',
        duplicatedData: '"{invalidDataInFile}" name is not unique!',
        successImportedFile: "Data has been successfully imported",
        importInfoBehaviour: "Import behavior:",
        importInfoBehaviour1:
            "File entries without a Row ID value will be added as new lines in the data table and a random Row ID will be generated for each of them.",
        importInfoBehaviour2: "File entries with Row ID values:",
        importInfoBehaviour3: "Will be added as new lines, if the Row ID doesn't exist in the data table (they will receive the Row ID from the file);",
        importInfoBehaviour4: "Will be updated if the Row ID exists in the data table.",
        entityCreated: "The data table has been successfully created",
        importSuccessMsg: "Processing import request. When finished, you will receive it via email.",
        createSuccessMsg: "Processing create request. When finished, you will receive a notification via email",
        columnMappedError: "The column must be mapped",
        autoGeneratedId: "Auto-generated ID",
        importInProgress: "An import for this data table is already in progress",
        errorUploadEmptyFile: "The file is empty.",
        errorUploadDuplicatedColumns: "The file has duplicated columns.",
        errorUploadCSVHeader: "Error reading CSV header of file.",
        disabledAddDataBtnTooltip: "Cannot add data to unpublished data tables",
        noDataToExport: "Cannot export an unpublished data table",
        noSwaggerDownload: "Cannot download swagger for an unpublished data table",
        importedRows: "The import will add {newRows} new rows and update {updatedRows} existing ones.",
        personalInfo: "Personal information",
        noResults: "No results found",
        selectEntity: "Select or create a new data table",
        choseAction: "Choose your next action based on your needs.",
        noEntity: "There are no data tables created yet",
        firstCreate: "Once you'll create your first data table, it will appear here",
        headerPublishedTooltip: "The data table structure is published and up to date",
        headerUnpublishedChangesTooltip: "The data table structure has unpublished changes",
        codeForSubtitle: "Code:",
        wrnMsg: "By selecting delete data you are going to lose your unsaved changes.",
        wrnMsgDel: "By selecting this action you are going to lose your unsaved changes.",
        rowsDeleted: "Rows were successfully deleted",
        dataDeleted: "Data has been successfully deleted",
        columns: "Columns",
        columnMapping: "Column mapping",
        deleteAllData: "Delete all data",
        deleteAllDataMsg: "Table data will be deleted. This action is irreversible. It is highly advised to backup the data before continuing with the action.",
        deleteEntityMsg: "The action is irreversible and any application using the data table will stop working properly.",
        deleteTable: "Delete table",
        dataAudit: "Data audit",
        tooltipOldValue: "Old value: \"{oldValue}\"",
        dataAuditTitle: "{entityName} data audit",
        warningRightIconTooltip: "This column is mapped multiple times",
        modifiedBy: "Modified by",
        modifiedVia: "Modified via",
        event: "Event",
        eventDate: "Event date",
        processInstanceId: "Process instance ID",
        applicationId: "Application ID",
        modifiedByUserId: "Modified by (User ID)",
        exportCsv: "Export to CSV",
        warningMessage: "Changing the type might result in mismatches when old values of this attribute are displayed in Interfaces (e.g. for existing process instances). If you want ensure old values are accessible, create a new attribute of the desired type and map the new attribute to a new field."
    },
    gdmIntegration: {
        addNewIntegration: "Create new",
        integrations: "database connection | database connections",
        title: "Database Connections Legacy",
        createNewIntegration: "Create new database connection",
        DBIntegration: "Connection details",
        connection: "Database details",
        type: "Connector type",
        DB: "Database",
        host: "Host/IP",
        port: "Port",
        username: "Username",
        role: "Role",
        password: "Password",
        connectionSucces: "Connection is successful",
        connectionError: "Could not connect",
        testConnectionBtn: "Test connection",
        testAgainConnectionBtn: "Test again",
        host2: "Host",
        database: "Database",
        pending: "Pending",
        connected: "Connected",
        error: "Error",
        status: "Status",
        editIntegration: "Edit database connection",
        changeCredentials: "Change Credentials",
        dbUnreachable: "The data table cannot reach the source database",
        externalNotPublished: "The data table is not published yet.",
        theEntity: "The data table",
        listUpdated: "The data table list has been updated",
        noConnection: "No connection",
        checkIntegration: "Check database connection",
        deleteTitle: "Delete database connection",
        deleteMsg: "Deleting the database connection will remove it from your 'Database Connections' page.",
        columnAdded: "New attribute added to the source",
        columnRemoved: "This attribute was deleted from source"
    },

    helpCenter: {
        title: "Help center",
        tooltipTitle: "Help center",
        ourResources: "Our resources",
        recommendedArticles: "Recommended articles",
        allArticles: "All articles",
        academy: "Academy"
    },
    capturePhotoVideo: {
        startBtnVideo: "Start Recording",
        cancelBtnVideo: "Cancel recording",
        stopBtnVideo: "Stop recording",
        capture: "Take photo",
        cancel: "Cancel",
        doneBtn: "Done",
        timer: "seconds remaining...",
        seconds: "seconds",
        captured: " Photo captured",
        capturedVideo: "Video captured",
        resetBtn: "Retake",
        recordAgain: "Record again",
        photoModal: "Photo Capture",
        videoModal: "Video Capture",
        messageDialog: "Recording will not be saved, are you sure you want to close?",
        titleDialog: "Confirm",
        submitCurrent: "Done"
    },
    perspectiveBuilder: {
        savePerspective: "The data view has been successfully created. | The data view has been successfully saved.",
        errorPerspective: "There was an error while saving the data view.",
        noPerspective: "Select or create a new data view",
        noPerspectiveDesc: "Choose your next action based on your needs.",
        noDisplay: "Nothing to display",
        noPersDescription: "There are no data views created yet",
        dialogTitle: "Warning",
        dialogMessage: "You have unsaved changes that will be lost if you continue",
        deleteTitleDialog: "Delete data view",
        deleteMessageDialog: "By deleting the data view, you will have it removed permanently from your view list and also from the Permissions section.",
        infoDeleteTooltip: "To delete this data view you need to remove users and groups permissions first",
        infoDeleteToast: "data view was deleted",
        duplicate: "Duplicate",
        copy: "copy",
        duplicateTitle: "Duplicate data view",
        duplicateMessage: "By duplicating the “{count}“ you will continue to the duplicated version.",
        delete: "Delete",
        tableInfo: "This table is populated with placeholder data. Actual data will be available on use.",
        leftSideBar: {
            title: "Custom Data Views",
            titleBtn: "Create new",
            defaultPerspective: "Default data view",
            noPerspectiveFound: "No results found",
            noPerspectiveYet: "No data views available yet",
            perspective: "Data view"
        },
        rightSideBar: {
            setupTitle: "Data view setup",
            name: "Name",
            showDiagram: "Show process diagram",
            customInterface: "Add user interface",
            invalidName: "The name can only contain letters, numbers, spaces, and underscore",
            tabSetup: "Page",
            tabFilters: "Filters",
            tabTable: "Table settings",
            showOnTasks: "Show on tasks too",
            searchArea: "Search area landing state",
            searchCollapse: "Collapsed",
            searchExpanded: "Expanded",
            tableState: "Table state on landing",
            tableFullscreen: "Fully expanded",
            tablePreview: "Preview mode",
            tableCollapsed: "Collapsed",
            configFilters: "Configure filters",
            modelOption: "Data model option",
            saveFiltersOption: "Save filters",
            lockOperator: "Lock operator",
            advancedBtn: "Advanced",
            noActivities: "No activities available",
            addDataModel: "Add data model filters",
            addAdvancedFilters: "Advanced filter configuration",
            availableFilters: "Available filters",
            invisibleToUser: "Invisible to end user",
            modelTitleContainer: "Data model classes",
            advancedInfoTooltip: "Prepopulate filters with values and configure specific behavior for the available filters",
            noFiltersSelected: "At least one filter must be visible in order to use this option",
            emptyName: "The name cannot be empty.",
            duplicateName: "The name must be unique",
            infoFiltersTab: "Select which filters will be available for use",
            infoInterfaceBox: "Display a user interface for process instances.",
            process: "Process",
            noProcess: "No processes available",
            settings: "Settings",
            searchFilters: "Search & Filters",
            tableConfig: "Table Config"
        },
        tabTable: {
            tableLayout: "Table layout",
            tasks: "Tasks",
            cases: "Cases",
            columnSorting: "Column sorting",
            columnSettings: "Column settings",
            settingsAddModel: "Add extra data model attributes",
            dataExport: "Data export",
            tabTasks: "Tasks tab",
            dataModel: "Data model",
            // tabCases: "Cases tab",
            tabCases: "Process instances tab",
            tabsTooltip: "At least one tab must be selected at any time",
            oneColSelected: "At least one column must be selected at any time"
        }
    },
    searchPerspectives: {
        title: "Data views",
        defaultStateTile: "Select a data view to continue",
        defaultStateDescription: "Show data view here",
        noProcessTitle: "Something went wrong. | The data view could not be loaded. <br>If the problem persists, contact your administrator.",
        noProcessDesc: "If the problem persists, contact your administrator.",
        loadFilterError: "Filter cannot be applied. Some attributes/values are not available anymore. Refresh the page to see the latest version.",
        sortSettingsError: "Action cannot be completed. Refresh the page to continue.",
        goToSearchRedirect: "Go to data view list",
        tryAgain: "Try again"
    },
    blockchainBuilder: {
        title: "Smart Contract mapping",
        selectSC: "Select Smart Contract",
        settings: "Settings",
        address: "Contract address*",
        bcAddress: "BC network address*",
        chainId: "Chain ID",
        method: "Method",
        mapping: "Mapping",
        request: "Request",
        noResult: "No Result",
        response: "Response",
        noMethod: "Please select Method first...",
        save: "Save",
        delete: "Delete",
        script: "script",
        req: "1 request parameter",
        resp: "1 response parameter",
        reqParams: "request parameters",
        resParams: "response attributes",
        noMap: "no mappings",
        allMap: "all parameters mapped",
        param: "parameter",
        params: "parameters",
        mapped: "mapped",
        selectInterface: "Select user interface component",
        error: "Cannot be empty",
        succes: "Smart Contract has been successfully mapped!",
        deleteSucces: "Smart Contract mapping has been successfully deleted!",
        uploadTitle: " Upload Smart Contract ABI"
    },
    dialogComponent: {
        exportBtn: "Export data"
    },
    defaultState: {
        title: "Nothing to display",
        description: "There are no items created yet",
        createButton: "Create new",
        createApp: "No application created yet",
        createAppView: "No application available yet",
        createPlugin: "No plugin imported yet ",
        import: "Import",
        descriptionPlugin: "Import your first plugin and enjoy powerful Aurachain & Integrate your tools for more powerful Apps",
        descriptionApp:
            "Here you can create applications, together with its supporting elements: user interfaces, document templates, integrations, data model and so on.",
        descriptionAppView: "The applications that are available to you will show up here.",
        descriptionMobile:
            "Applications are a collection of business processes together with their supporting elements: user interfaces, document templates, APIs, and data models. Here you can find any applications created in the future.",
        createEntity: "No data table created yet",
        descriptionEntity: "Here you can create data tables to store and read global data that can be accessed across applications.",
        createIntegration: "No database connection created yet",
        descriptionIntegration:
            "Here you can connect the platform to existing systems, using pre-built connectors, such as SQL Server, Oracle, or MySQL databases and so on.<br><br>Once the connection is available, it can be used as a data table source to access the data across applications.",
        noTasks: "You don't have any tasks yet.",
        noTasksDescription: "The tasks that are available to you will show up here.",
        noTeamTasks: "Your Team doesn't have any tasks yet.",
        noTeamTasksDescription: "The tasks available to your team will be displayed here.",
        createProcess: "No process created yet",
        createProcessView: "No process created yet.",
        createProcessDescription:
            "Here you can visually create business processes, by using a simplified editor that allows you to: configure tasks, events, rules, flows, assignees, approvals, notifications, and all business logic.",
        createProcessDescriptionView: "The processes that are available to you will show up here.",
        createSC: "No smart contract descriptor imported yet",
        createSCView: "No smart contract descriptor imported yet",
        createSCDescription:
            "Here you can import smart contract descriptors to enable blockchain capabilities into your application. Once added, it can be used to read and store data on the blockchain.",
        createSCDescriptionView: "The smart contract descriptors that are available to you will show up here.",
        createInterface: "Create User Interface",
        createInterfaceView: "User Interfaces",
        createInterfaceDescription:
            "The User Interfaces is a powerful way to visually design and assemble web pages that allow users to interact with  applications. <br> Get started by creating or selecting a user interface or fragment.",
        createInterfaceDescriptionView:
            "The User Interfaces is a powerful way to visually design and assemble web pages that allow users to interact with  applications. <br> Here you can find any user interfaces or fragments created in the future.",
        createDocument: "No document template created yet",
        createDocumentView: "No document template created yet",
        createDocumentDescription:
            "Here you can design and generate document templates by making use of the dynamic content from the application data.<br><br>The templates are used to generate documents at process and user interface level",
        createDocumentDescriptionView: "The document templates that are available to you will show up here.",
        internalApis: "No system API available yet",
        internalApisDescription: "The system APIs that are available to you will show up here.",
        consumedApis: "No external API added yet",
        consumedApisView: "No external API added yet",
        consumedApisDescription:
            "Here you can integrate external systems with your application, using web services.<br><br>Once the API is added, it can be accessed from processes and user interfaces.",
        consumedApisDescriptionView: "The external APIs that are available to you will show up here.",
        exposedApis: "No exposed API credentials created yet",
        exposedApisView: "No exposed API credentials created yet",
        exposedApisDescription:
            "Here you can create credentials that you can use to authorize the client's access to an exposed API, once it is created in the application's processes.",
        exposedApisDescriptionView: "The exposed API credentials that are available to you will show up here.",
        createDM: "No data model created yet",
        createDMView: "No data model created yet",
        createDMDescription:
            "Process data model define how your data will be stored, organized, and classified once a process is started.<br><br>Create classes and their attributes and use the Data Model to access and manage data from different areas of the application, such as User Interfaces, Processes, Analytics and so on.",
        createDMDescriptionView: "The data model classes and attributes that are available to you will show up here.",
        createCatalog: "No catalog created yet",
        createCatalogView: "No catalog created yet",
        createCatalogDescription:
            "Here you can create lists with predefined values.<br><br>Once a catalog is defined, use it in user interfaces to populate drop-down lists with values from it.",
        createCatalogDescriptionView: "The catalogs that are available to you will show up here.",
        createPerspective: "No data view created yet ",
        createPerspectiveView: "No data view created yet",
        createPerspectiveDescription:
            "Here you can create custom data views, adapted to the specific needs of each user profile.<br><br>Once a custom data view is defined, business users can access it as per configured permissions.",
        createPerspectiveDescriptionView: "The data views that are available to you will show up here.",
        noPerspective: "You have no data views available yet.",
        noPerspectiveView: "You have no data views available yet",
        noPerspectiveDescription: "Here you can access personalized data views for your process data.",
        noStatistics: "No process data available",
        noStatisticsView: "No process data available",
        noStatisticsDescription: "The processes that are available to you will show up here.",
        noStatisticsDescriptionView: "The processes that are available to you will show up here.",
        noProcessData: "No process data available",
        noProcessDataView: "No process data available data",
        noProcessDataDescription: "The processes that are available to you will show up here.",
        noProcessDataDescriptionView: "The processes that are available to you will show up here.",
        acessDenied: "Access Denied",
        acessDeniedDescription: "We are sorry... <br>The page you're trying to access has restricted access.<br>Please refer to your system administrator",
        blockchainEmptyWallet: "Create Blockchain Wallet",
        blockchainEmptyWalletView: "Blockchain Wallets",
        blockchainEmptyWalletDescription:
            "Blockchain wallets are used to sign smart contracts in tasks that require it.<br> Here you can find any wallets that you saved, and you can also import wallets for future use.",
        toDashboard: "Go to dashboard",
        maintenanceTitle: "We're under maintenance",
        maintenanceDescription: "Currently the platform is under maintenance. Refresh the page or contact an administrator.",
        pageNotFoundTitle: "Page not found",
        pageNotFoundDescription: "The page you're trying to access could not be found.<br> Check again the link or contact an administrator."
    },
    wallet: {
        wallet: "wallet",
        dashboard: {
            iconAlt: "Icon No wallets yet",
            noWallets: "No wallets yet",
            noWalletsInfo: "Initialized or created wallets will be visible here",
            passwordRequirements: "Password must contain minimum of 8 characters, from which 1 uppercase, 1 lowercase and 1 number",
            dropdown: {
                edit: "Edit",
                remove: "Remove"
            },
            notifyMessage: "Transaction in progress",
            captionMessage: " Please wait for the action to complete."
        },
        title: {
            create: "Create new HD wallet",
            import: "Import wallet",
            sign: "Choose blockchain account",
            edit: "Edit wallet",
            editAccount: "Edit account"
        },
        subtitle: {
            settings: "Settings",
            wallets: "Wallets"
        },
        heading: {
            savedWallets: "Saved wallets",
            otherWallets: "Other wallets"
        },
        button: {
            import: "Import",
            create: "Create new",
            save: "Save",
            initialize: "Initialize",
            initializeAnother: "Initialize a different HD wallet",
            differentPrivateKey: "Use a different private key",
            differentKeystore: "Use a different keystore file",
            done: "Done",
            validate: "Validate"
        },
        cta: {
            create: "Create",
            import: "Import",
            sign: "Sign",
            edit: "Done"
        },
        accountDefaultName: "Account",
        saveForLater: "Securely save this wallet for further use",
        label: {
            name: "Name",
            password: "Password",
            confirmPassword: "Confirm password",
            type: "Type",
            passphrase: "Secret recovery phrase",
            confirmPassphrase: "Reenter recovery phrase",
            optional: "Optional",
            bip39passphrase: "BIP39 passphrase",
            address: "Address"
        },
        error: {
            missingPassword: "Choose wallet password",
            passwordsNotMatching: "Passwords don't match",
            passphraseNotMatching: "Recovery phrases don't match",
            passwordRequirements: "Password must contain min 8 characters, from which at least 1 number, 1 uppercase and 1 lowercase",
            unknownError: "Something went wrong. Please help us improve your experience by sending an error report.",
            invalidMnemonic: "Invalid mnemonic",
            invalidPrivateKey: "Invalid private key",
            invalidPassword: "Invalid password",
            invalidKeystore: "Invalid keystore"
        },
        passphraseInfo:
            "Your Secret recovery phrase is the only way to create a copy of your wallet or restore it. \n "
            + "Make sure to save your Secret recovery phrase in a secure location before continuing. \n"
            + "If you lose your recovery phrase you will permanently lose access to your wallet. \n"
            + "Do not share your Secret recovery phrase with anyone.",
        importOptions: {
            hd: "HD wallet",
            privateKey: "Private Key",
            keystoreFile: "Keystore file",
            wallet: "Wallet"
        },
        createSuccess: "Wallet has been successfully created!",
        importSuccess: "Wallet has been successfully imported!",
        signSuccess: "Transaction successful!",
        callSuccess: "Call successful!",
        signFail: "Transaction failed!",
        callFail: "Call failed!",
        generateAccount: "Generate another account",
        saveMethod: {
            local: "Save on this device only",
            cloud: "Save on cloud (Available to use on all your devices)"
        },
        storageType: {
            device: "Device",
            cloud: "Cloud"
        },
        successDelete: "Wallet has been successfully deleted!",
        deleteWalletTitle: "Delete wallet",
        deleteWalletText: "Are you sure you want to delete {walletName} wallet?"
    },
    licenses: {
        title: "Software licenses",
        viewDetails: "View details",
        libraryDetails: "Software library details",
        dialogMessage: "You can learn more details about the library on the link provided by its developer:",
        externalSite: "Continue to external site"
    },
    columnProps: {
        label: "Format",
        hint: "Only available when mapped attribute is numeric or string.",
        thousands: "Thousands separator",
        decimal: "Decimal separator"
    },
    btnListComponents: {
        edit: "Edit",
        delete: "Delete",
        copy: "Copy",
        more: "More",
        download: "Download"
    },
    versioning: {
        by: "by",
        at: "at",
        published: "Published",
        restore: "Restore",
        addNote: "Add Note",
        editNote: "Edit Note",
        deleteNote: "Delete Note",
        createNote: "Create",
        updateNote: "Update",
        deleteNoteBtn: "Delete",
        noteTooltip: "Note",
        dialogTitleCreate: "Create note for {date}",
        dialogTitleEdit: "Edit note for {date}",
        descriptionDeleteNote: "Are you sure you want to permanently remove the note for {date}?",
        recover: "Recover",
        edited: "edited",
        restored: "restored",
        recovered: "recovered",
        deleted: "deleted",
        renamedTo: "renamed to",
        imported: "imported",
        created: "created",
        nothingToDisplay: "Nothing to display",
        noModuleActivity: "There is no activity in this module yet",
        noSectionActivity: "There is no activity in this section yet",
        edits: "edits",
        saveHModalTitle: "Save history",
        changeHModalTitle: "Change history",
        containsPublishPoints: " | Contains {count} publish point | Contains {count} publish points",
        showOlderSaves: "Show older saves",
        showOlderChanges: "Show older changes",
        saveNote: "Note has been added successfully",
        updateNoteDialog: "Note has been updated successfully",
        previewToastTitle: "Savepoint from",
        previewToastText: "You are previewing an older save. To make changes, restore this save.",
        close: "Close",
        interfaceRecovered: "Interface/Fragment was recovered",
        interfaceAlreadyRecovered: "Interface/Fragment has already been recovered",
        interfaceNotFound: "Interface/fragment not found",
        interfaceNotDeleteEvent: "The 'Recover' action is only available on 'Delete' events",
        documentRecovered: "Document Template was recovered successfully.",
        documentAlreadyRecovered: "Document Template has already been recovered.",
        documentNotFound: "Document Template not found.",
        catalogRecovered: "The catalog was recovered.",
        catalogAlreadyRecovered: "The catalog has already been recovered.",
        catalogNotFound: "Catalog not found",
        apiRecovered: "External API was recovered",
        apiAlreadyRecovered: "External API has already been recovered",
        apiNotFound: "External API not found",
        processRecovered: "Process was recovered successfully.",
        processAlreadyRecovered: "Process has already been recovered.",
        processNotFound: "Process not found.",
        restoreSave: "Restore this save",
        restoreDialogTitle: "Restore a previous save",
        restoreDialogInfo: "This action will return {interfaceName} to the state of {date}.",
        restoreDialogInfoDM: "This action will restore the Data Model to the state of {date}.",
        restoreDialogInfoCat: "This action will restore the Catalog to the state of {date}.",
        confirmRestoreNotify: "The restore was successful",
        emptyNameNotif: "Name can not be empty",
        renameInfo: "Click the page title on the top-left in order to rename the Interface",
        noPublishWhilePreview: "Sorry you can not publish while previewing",
        filters: "Filters",
        eventType: "Event type",
        user: "User"
    },
    startFromEmail: {
        emailConfig: "Email Configuration",
        emailContent: "Email content ",
        config: "Configuration",
        protocol: "Server Type",
        host: "Server Address",
        port: "Port",
        encryption: "Encryption",
        username: "User Name",
        password: "Password",
        content: "Content",
        subject: "Subject",
        from: "Sender",
        to: "Recipient",
        cc: "CC",
        bcc: "BCC",
        body: "Body",
        configured: "Configured"
    },
    plugins: {
        title: "Plugin | Plugins",
        importPlugin: "Import plugin",
        importBtn: "Import plugin | Import",
        importTitle: "Upload your file",
        successNotif: "Plugin successfully imported.",
        errorNotif: "Failed to import plugin!"
    }
};
